webpackJsonp([1],{

/***/ "5Rfz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5UXz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5aCn":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7bK5":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "8uYP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "B4ao":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "J4AD":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JAIY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KDwJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KUHQ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vue-gtag/dist/vue-gtag.esm.js
var vue_gtag_esm = __webpack_require__("Z3T5");

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/js-search/dist/commonjs/index.js
var commonjs = __webpack_require__("5KK7");
var commonjs_default = /*#__PURE__*/__webpack_require__.n(commonjs);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/FeatherIcon.vue
//
//
//
//

var feather = __webpack_require__("/qmR");
//  feather.icons.x
// {
//    name: 'x',
//    contents: '<line ... /><line ... />`,
//    tags: ['cancel', 'close', 'delete', 'remove'],
//    attrs: {
//      class: 'feather feather-x',
//      xmlns: 'http://www.w3.org/2000/svg',
//      width: 24,
//      height: 24,
//      viewBox: '0 0 24 24',
//      fill: 'none',
//      stroke: 'currentColor',
//      'stroke-width': 2,
//      'stroke-linecap': 'round',
//      'stroke-linejoin': 'round',
//    }
// }
/* harmony default export */ var FeatherIcon = ({
  name: 'feather-icon',
  props: ['icon', 'options'],
  computed: {
    iconSvg: function iconSvg() {
      return feather.icons[this.icon].toSvg(this.options);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-61ddc7ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/FeatherIcon.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{domProps:{"innerHTML":_vm._s(_vm.iconSvg)}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_FeatherIcon = (esExports);
// CONCATENATED MODULE: ./src/components/FeatherIcon.vue
function injectStyle (ssrContext) {
  __webpack_require__("Om6c")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  FeatherIcon,
  components_FeatherIcon,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_FeatherIcon = (Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PublishPage.vue

//
//
//
//
//



/* harmony default export */ var PublishPage = ({
  name: 'kpPage',
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  props: ['page', 'width', 'height', 'classes'],
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['basePath']), {
    styleObject: function styleObject() {
      return {
        width: this.width + 'px',
        height: this.height + 'px',
        'background-image': 'url(' + this.basePath + '/static/_content/' + this.page.original + ')'
      };
    }
  }),
  updated: function updated() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  },
  mounted: function mounted() {
    if (this.classes == "currentPage" || this.classes == "leftPage" || this.classes == "rightPage") {
      var p = parseInt(this.page.pageIndex);
      var s = parseInt(this.page.sectionIndex);
      if (window["p" + p + "s" + s + "onPageEnter"]) {
        window["p" + p + "s" + s + "onPageEnter"]();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3a0bff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PublishPage.vue
var PublishPage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"page",class:_vm.classes,style:(_vm.styleObject),attrs:{"data-page":((_vm.page.pageIndex + 1) + "-" + (_vm.page.sectionIndex + 1))},domProps:{"innerHTML":_vm._s(_vm.page.content)}})}
var PublishPage_staticRenderFns = []
var PublishPage_esExports = { render: PublishPage_render, staticRenderFns: PublishPage_staticRenderFns }
/* harmony default export */ var components_PublishPage = (PublishPage_esExports);
// CONCATENATED MODULE: ./src/components/PublishPage.vue
function PublishPage_injectStyle (ssrContext) {
  __webpack_require__("JAIY")
}
var PublishPage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PublishPage___vue_template_functional__ = false
/* styles */
var PublishPage___vue_styles__ = PublishPage_injectStyle
/* scopeId */
var PublishPage___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PublishPage___vue_module_identifier__ = null
var PublishPage_Component = PublishPage_normalizeComponent(
  PublishPage,
  components_PublishPage,
  PublishPage___vue_template_functional__,
  PublishPage___vue_styles__,
  PublishPage___vue_scopeId__,
  PublishPage___vue_module_identifier__
)

/* harmony default export */ var src_components_PublishPage = (PublishPage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobilePage.vue

//
//
//
//
//
//
//



/* harmony default export */ var MobilePage = ({
  name: 'kpMobilePage',
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentMobilePage', 'mobilePageContent']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13cf244c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobilePage.vue
var MobilePage_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"mobile-page",class:_vm.currentMobilePage.cssClass},[_c('header',{staticClass:"mobile-header",domProps:{"textContent":_vm._s(_vm.currentMobilePage.title)}}),_vm._v(" "),_c('article',{staticClass:"mobile-content",domProps:{"innerHTML":_vm._s(_vm.mobilePageContent(_vm.currentMobilePage))}})])}
var MobilePage_staticRenderFns = []
var MobilePage_esExports = { render: MobilePage_render, staticRenderFns: MobilePage_staticRenderFns }
/* harmony default export */ var mobile_MobilePage = (MobilePage_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobilePage.vue
function MobilePage_injectStyle (ssrContext) {
  __webpack_require__("Z1YF")
}
var MobilePage_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobilePage___vue_template_functional__ = false
/* styles */
var MobilePage___vue_styles__ = MobilePage_injectStyle
/* scopeId */
var MobilePage___vue_scopeId__ = "data-v-13cf244c"
/* moduleIdentifier (server only) */
var MobilePage___vue_module_identifier__ = null
var MobilePage_Component = MobilePage_normalizeComponent(
  MobilePage,
  mobile_MobilePage,
  MobilePage___vue_template_functional__,
  MobilePage___vue_styles__,
  MobilePage___vue_scopeId__,
  MobilePage___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobilePage = (MobilePage_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileNavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var MobileNavigationBar = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['title', 'companyLogo', 'showContents', 'isMobileFontLarge'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS',
    toggleFontSize: 'TOGGLE_FONT_SIZE'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d2c09f7","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileNavigationBar.vue
var MobileNavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-bar",attrs:{"id":"mobile-nav-bar"}},[_c('div',{staticClass:"nav-menu-button",class:{ mobileFontLarge: _vm.isMobileFontLarge },attrs:{"id":"mobile-font-size-toggle"},on:{"click":_vm.toggleFontSize}},[_c('span',{staticClass:"font-size-toggle-small"},[_vm._v("Aa")]),_vm._v(" "),_c('span',{staticClass:"font-size-toggle-large"},[_vm._v("Aa")])]),_vm._v(" "),_c('img',{attrs:{"id":"mobile-nav-bar__logo","src":_vm.companyLogo}}),_vm._v(" "),_c('div',{staticClass:"nav-menu-button",attrs:{"id":"mobile-nav-button"},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"menu"}})],1)])}
var MobileNavigationBar_staticRenderFns = []
var MobileNavigationBar_esExports = { render: MobileNavigationBar_render, staticRenderFns: MobileNavigationBar_staticRenderFns }
/* harmony default export */ var mobile_MobileNavigationBar = (MobileNavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileNavigationBar.vue
function MobileNavigationBar_injectStyle (ssrContext) {
  __webpack_require__("nSix")
}
var MobileNavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileNavigationBar___vue_template_functional__ = false
/* styles */
var MobileNavigationBar___vue_styles__ = MobileNavigationBar_injectStyle
/* scopeId */
var MobileNavigationBar___vue_scopeId__ = "data-v-1d2c09f7"
/* moduleIdentifier (server only) */
var MobileNavigationBar___vue_module_identifier__ = null
var MobileNavigationBar_Component = MobileNavigationBar_normalizeComponent(
  MobileNavigationBar,
  mobile_MobileNavigationBar,
  MobileNavigationBar___vue_template_functional__,
  MobileNavigationBar___vue_styles__,
  MobileNavigationBar___vue_scopeId__,
  MobileNavigationBar___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileNavigationBar = (MobileNavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileMenu.vue

//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var MobileMenu = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['mobilePages', 'mobilePageLink', 'showContents'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: 'TOGGLE_CONTENTS'
  }))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f86d1c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileMenu.vue
var MobileMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showContents)?_c('div',{attrs:{"id":"mobile-menu"}},[_c('ul',{attrs:{"id":"mobile-list"}},_vm._l((_vm.mobilePages),function(mobilePage,index){return (!mobilePage.hideInMenu)?_c('li',{key:index,on:{"click":_vm.toggleContents}},[_c('router-link',{attrs:{"to":_vm.mobilePageLink(mobilePage)}},[_vm._v(_vm._s(mobilePage.title))])],1):_vm._e()}))]):_vm._e()}
var MobileMenu_staticRenderFns = []
var MobileMenu_esExports = { render: MobileMenu_render, staticRenderFns: MobileMenu_staticRenderFns }
/* harmony default export */ var mobile_MobileMenu = (MobileMenu_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileMenu.vue
function MobileMenu_injectStyle (ssrContext) {
  __webpack_require__("7bK5")
}
var MobileMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileMenu___vue_template_functional__ = false
/* styles */
var MobileMenu___vue_styles__ = MobileMenu_injectStyle
/* scopeId */
var MobileMenu___vue_scopeId__ = "data-v-9f86d1c4"
/* moduleIdentifier (server only) */
var MobileMenu___vue_module_identifier__ = null
var MobileMenu_Component = MobileMenu_normalizeComponent(
  MobileMenu,
  mobile_MobileMenu,
  MobileMenu___vue_template_functional__,
  MobileMenu___vue_styles__,
  MobileMenu___vue_scopeId__,
  MobileMenu___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileMenu = (MobileMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/mobile/MobileContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var MobileContainer = ({
  components: {
    MobilePage: components_mobile_MobilePage,
    MobileNavigationBar: components_mobile_MobileNavigationBar,
    MobileMenu: components_mobile_MobileMenu
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['nextMobilePage', 'previousMobilePage', 'currentMobilePage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0878514e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/mobile/MobileContainer.vue
var MobileContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"mobile-container"}},[_c('mobile-navigation-bar'),_vm._v(" "),(_vm.currentMobilePage)?_c('mobile-page'):_vm._e(),_vm._v(" "),_c('mobile-menu'),_vm._v(" "),_c('div',{staticClass:"nav-buttons",attrs:{"id":"navButtons"}},[(_vm.previousMobilePage)?_c('button',{staticClass:"advert-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnPrev","onclick":"Publish.goToPreviousMobilePage();"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('button',{staticClass:"aqua-btn",staticStyle:{"visibility":"visible"},attrs:{"id":"btnNext","onclick":"Publish.goToNextMobilePage();"}}):_vm._e()])],1)}
var MobileContainer_staticRenderFns = []
var MobileContainer_esExports = { render: MobileContainer_render, staticRenderFns: MobileContainer_staticRenderFns }
/* harmony default export */ var mobile_MobileContainer = (MobileContainer_esExports);
// CONCATENATED MODULE: ./src/components/mobile/MobileContainer.vue
function MobileContainer_injectStyle (ssrContext) {
  __webpack_require__("r8RT")
}
var MobileContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileContainer___vue_template_functional__ = false
/* styles */
var MobileContainer___vue_styles__ = MobileContainer_injectStyle
/* scopeId */
var MobileContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileContainer___vue_module_identifier__ = null
var MobileContainer_Component = MobileContainer_normalizeComponent(
  MobileContainer,
  mobile_MobileContainer,
  MobileContainer___vue_template_functional__,
  MobileContainer___vue_styles__,
  MobileContainer___vue_scopeId__,
  MobileContainer___vue_module_identifier__
)

/* harmony default export */ var components_mobile_MobileContainer = (MobileContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/LanguagesPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var LanguagesPanel = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['languages']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c2f03a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LanguagesPanel.vue
var LanguagesPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"languages-fade"}},[_c('nav',{staticClass:"languages-panel"},[_c('ul',{staticClass:"languages-list"},_vm._l((_vm.languages),function(language,index){return _c('li',{key:index,staticClass:"languages-item"},[_c('a',{attrs:{"rel":"alternate","href":language.href,"target":"_blank"}},[_vm._v(_vm._s(language.code))])])}))])])}
var LanguagesPanel_staticRenderFns = []
var LanguagesPanel_esExports = { render: LanguagesPanel_render, staticRenderFns: LanguagesPanel_staticRenderFns }
/* harmony default export */ var components_LanguagesPanel = (LanguagesPanel_esExports);
// CONCATENATED MODULE: ./src/components/LanguagesPanel.vue
function LanguagesPanel_injectStyle (ssrContext) {
  __webpack_require__("5UXz")
}
var LanguagesPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var LanguagesPanel___vue_template_functional__ = false
/* styles */
var LanguagesPanel___vue_styles__ = LanguagesPanel_injectStyle
/* scopeId */
var LanguagesPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var LanguagesPanel___vue_module_identifier__ = null
var LanguagesPanel_Component = LanguagesPanel_normalizeComponent(
  LanguagesPanel,
  components_LanguagesPanel,
  LanguagesPanel___vue_template_functional__,
  LanguagesPanel___vue_styles__,
  LanguagesPanel___vue_scopeId__,
  LanguagesPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_LanguagesPanel = (LanguagesPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/EditionsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ var EditionsPanel = ({
  // components: {
  //   EditionsJson
  // },
  computed: extends_default()({
    editions_data: function editions_data() {
      if (window.editions_data && window.editions_data.length) {
        return window.editions_data;
      } else {
        return editions;
      }
    }
  }, Object(vuex_esm["e" /* mapState */])({
    currentLanguage: function currentLanguage(state) {
      return state.document.currentLanguage;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['currentLanguage']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4bdf4d00","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EditionsPanel.vue
var EditionsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"editions-fade"}},[_c('nav',{staticClass:"editions-panel"},[_c('ul',{staticClass:"editions-list"},_vm._l((_vm.editions_data),function(edition,index){return _c('li',{key:index,staticClass:"editions-item"},[_c('a',{attrs:{"rel":"alternate","href":edition.href + _vm.currentLanguage.toLowerCase(),"target":"_blank"}},[_vm._v(_vm._s(edition.code))])])}))])])}
var EditionsPanel_staticRenderFns = []
var EditionsPanel_esExports = { render: EditionsPanel_render, staticRenderFns: EditionsPanel_staticRenderFns }
/* harmony default export */ var components_EditionsPanel = (EditionsPanel_esExports);
// CONCATENATED MODULE: ./src/components/EditionsPanel.vue
function EditionsPanel_injectStyle (ssrContext) {
  __webpack_require__("5aCn")
}
var EditionsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var EditionsPanel___vue_template_functional__ = false
/* styles */
var EditionsPanel___vue_styles__ = EditionsPanel_injectStyle
/* scopeId */
var EditionsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var EditionsPanel___vue_module_identifier__ = null
var EditionsPanel_Component = EditionsPanel_normalizeComponent(
  EditionsPanel,
  components_EditionsPanel,
  EditionsPanel___vue_template_functional__,
  EditionsPanel___vue_styles__,
  EditionsPanel___vue_scopeId__,
  EditionsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_EditionsPanel = (EditionsPanel_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/dist/vue-slider-component.umd.min.js
var vue_slider_component_umd_min = __webpack_require__("lCKi");
var vue_slider_component_umd_min_default = /*#__PURE__*/__webpack_require__.n(vue_slider_component_umd_min);

// EXTERNAL MODULE: ./node_modules/vue-slider-component/theme/material.css
var material = __webpack_require__("KUHQ");
var material_default = /*#__PURE__*/__webpack_require__.n(material);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationBar.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ var NavigationBar = ({
  data: function data() {
    return {
      editions: [],
      zoomValue: 1
    };
  },

  props: ["logoURL", "title", "page", "companyName", "width"],
  components: {
    FeatherIcon: src_components_FeatherIcon,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    VueSlider: vue_slider_component_umd_min_default.a
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "contentsPinned", "searchEnabled", "subscribeEnabled", "languagesEnabled", "editionsEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "rightToLeft", "companyLogo", "downloadPath", "showContents", "showLanguages", "showEditions", "showSearch", "showSubscribe", "showGuide", "isZoomed", "isMobile", "mobileSwitch", "currentMobilePage", "fullscreenEnabled", "zoomScrollEnabled"]), {
    divider: function divider() {
      if (this.rightToLeft) return "chevron-left";
      return "chevron-right";
    }
  }),
  mounted: function mounted() {
    this.loadEditionsScript();
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS",
    toggleLanguages: "TOGGLE_LANGUAGES",
    toggleEditions: "TOGGLE_EDITIONS",
    toggleZoom: "TOGGLE_ZOOM",
    slideZoom: "SLIDE_ZOOM",
    toggleSearch: "TOGGLE_SEARCH",
    toggleSubscribe: "TOGGLE_SUBSCRIBE",
    toggleGuide: "TOGGLE_GUIDE",
    toggleReader: "TOGGLE_READER",
    toggleFullscreen: "TOGGLE_FULLSCREEN"
  }), {
    loadEditionsScript: function loadEditionsScript() {
      var editionsJson = document.createElement('script');
      editionsJson.setAttribute('src', 'https://touchline-uefa.s3-eu-west-1.amazonaws.com/editions.js');
      document.head.appendChild(editionsJson);
      this.editions = editionsJson;
    },
    updateSliderZoom: function updateSliderZoom() {
      Publish.$store.commit("SLIDE_ZOOM", { zoomValue: this.zoomValue });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fcd7d690","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationBar.vue
var NavigationBar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"nav-bar"},[_c('div',{staticClass:"nav-bar__container"},[_c('div',{staticClass:"nav-bar__logo"},[_c('img',{staticClass:"nav-bar__logo-image",attrs:{"src":_vm.companyLogo,"alt":_vm.companyName}})]),_vm._v(" "),_c('div',{staticClass:"nav-bar__text"},[_c('span',{staticClass:"nav-bar__title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__divider"},[_c('feather-icon',{attrs:{"icon":_vm.divider}})],1):_vm._e(),_vm._v(" "),(_vm.page)?_c('span',{staticClass:"nav-bar__page"},[_vm._v(_vm._s(_vm.page))]):_vm._e()]),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && !_vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Reader is available")]):_vm._e(),_vm._v(" "),((_vm.readerEnabled && !(_vm.isMobile)) && _vm.currentMobilePage && _vm.isReader)?_c('p',{staticClass:"nav-bar__reader",on:{"click":_vm.toggleReader}},[_vm._v("Return to magazine")]):_vm._e(),_vm._v(" "),_c('nav',{staticClass:"nav-bar__links"},[_c('ul',[(!((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader))?[(_vm.zoomScrollEnabled)?_c('li',{staticClass:"nav-bar__link nav-bar__zoom-slider"},[_c('vue-slider',{ref:"zoomSlider",attrs:{"min":1,"max":2,"interval":0.01,"tooltip-placement":'bottom'},on:{"change":function($event){_vm.updateSliderZoom()},"click":_vm.slideZoom},model:{value:(_vm.zoomValue),callback:function ($$v) {_vm.zoomValue=$$v},expression:"zoomValue"}})],1):_vm._e(),_vm._v(" "),(_vm.guideEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showGuide},on:{"click":_vm.toggleGuide}},[_c('feather-icon',{attrs:{"icon":"help-circle"},on:{"click":_vm.toggleGuide}})],1):_vm._e(),_vm._v(" "),((_vm.zoomNavEnabled && (!_vm.isMobile)))?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.isZoomed},on:{"click":_vm.toggleZoom}},[_c('feather-icon',{attrs:{"icon":"zoom-in"},on:{"click":_vm.toggleZoom}})],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSearch},on:{"click":_vm.toggleSearch}},[_c('feather-icon',{attrs:{"icon":"search"}})],1):_vm._e(),_vm._v(" "),(_vm.subscribeEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showSubscribe},on:{"click":_vm.toggleSubscribe}},[_c('feather-icon',{attrs:{"icon":"mail"}})],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showLanguages},on:{"click":_vm.toggleLanguages}},[_c('feather-icon',{attrs:{"icon":"globe"}}),_vm._v(" "),_c('languages-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLanguages),expression:"showLanguages"}]})],1):_vm._e(),_vm._v(" "),(_vm.editionsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showEditions},on:{"click":_vm.toggleEditions}},[_c('feather-icon',{attrs:{"icon":"book"}}),_vm._v(" "),_c('editions-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showEditions),expression:"showEditions"}]})],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('a',{attrs:{"href":_vm.downloadPath,"target":"_blank","download":""}},[_c('feather-icon',{attrs:{"icon":"download"}})],1)]):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',{staticClass:"nav-bar__link"},[_c('feather-icon',{attrs:{"icon":"printer"}})],1):_vm._e()]:_vm._e(),_vm._v(" "),(_vm.contentsEnabled && _vm.contentsPinned)?_c('li',{staticClass:"nav-bar__link hidden-large",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}}):(_vm.contentsEnabled)?_c('li',{staticClass:"nav-bar__link",class:{'nav-bar__link--active': _vm.showContents},on:{"click":_vm.toggleContents}},[_c('feather-icon',{attrs:{"icon":"grid"}})],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled && !_vm.isMobile)?_c('li',{staticClass:"nav-bar__link",on:{"click":_vm.toggleFullscreen}},[_c('feather-icon',{attrs:{"icon":"maximize"}})],1):_vm._e()],2)])])])}
var NavigationBar_staticRenderFns = []
var NavigationBar_esExports = { render: NavigationBar_render, staticRenderFns: NavigationBar_staticRenderFns }
/* harmony default export */ var components_NavigationBar = (NavigationBar_esExports);
// CONCATENATED MODULE: ./src/components/NavigationBar.vue
function NavigationBar_injectStyle (ssrContext) {
  __webpack_require__("zMNT")
}
var NavigationBar_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationBar___vue_template_functional__ = false
/* styles */
var NavigationBar___vue_styles__ = NavigationBar_injectStyle
/* scopeId */
var NavigationBar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationBar___vue_module_identifier__ = null
var NavigationBar_Component = NavigationBar_normalizeComponent(
  NavigationBar,
  components_NavigationBar,
  NavigationBar___vue_template_functional__,
  NavigationBar___vue_styles__,
  NavigationBar___vue_scopeId__,
  NavigationBar___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationBar = (NavigationBar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/NavigationLink.vue
//
//
//
//
//
//



/* harmony default export */ var NavigationLink = ({
  props: ['to', 'rotation', 'color', 'classes'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 25,
        height: 25
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18e76692","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavigationLink.vue
var NavigationLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes},[_c('router-link',{attrs:{"to":_vm.to}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)],1)}
var NavigationLink_staticRenderFns = []
var NavigationLink_esExports = { render: NavigationLink_render, staticRenderFns: NavigationLink_staticRenderFns }
/* harmony default export */ var components_NavigationLink = (NavigationLink_esExports);
// CONCATENATED MODULE: ./src/components/NavigationLink.vue
function NavigationLink_injectStyle (ssrContext) {
  __webpack_require__("8uYP")
}
var NavigationLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var NavigationLink___vue_template_functional__ = false
/* styles */
var NavigationLink___vue_styles__ = NavigationLink_injectStyle
/* scopeId */
var NavigationLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var NavigationLink___vue_module_identifier__ = null
var NavigationLink_Component = NavigationLink_normalizeComponent(
  NavigationLink,
  components_NavigationLink,
  NavigationLink___vue_template_functional__,
  NavigationLink___vue_styles__,
  NavigationLink___vue_scopeId__,
  NavigationLink___vue_module_identifier__
)

/* harmony default export */ var src_components_NavigationLink = (NavigationLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/MobileLink.vue
//
//
//
//
//
//



/* harmony default export */ var MobileLink = ({
  props: ['to', 'rotation', 'color', 'classes', 'click'],
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: {
    options: function options() {
      return {
        class: 'r' + this.rotation,
        width: 50,
        height: 50
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-726eead2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MobileLink.vue
var MobileLink_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"navigation-link",class:_vm.classes,on:{"click":_vm.click}},[_c('feather-icon',{attrs:{"icon":"play","options":_vm.options}})],1)}
var MobileLink_staticRenderFns = []
var MobileLink_esExports = { render: MobileLink_render, staticRenderFns: MobileLink_staticRenderFns }
/* harmony default export */ var components_MobileLink = (MobileLink_esExports);
// CONCATENATED MODULE: ./src/components/MobileLink.vue
function MobileLink_injectStyle (ssrContext) {
  __webpack_require__("KDwJ")
}
var MobileLink_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var MobileLink___vue_template_functional__ = false
/* styles */
var MobileLink___vue_styles__ = MobileLink_injectStyle
/* scopeId */
var MobileLink___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var MobileLink___vue_module_identifier__ = null
var MobileLink_Component = MobileLink_normalizeComponent(
  MobileLink,
  components_MobileLink,
  MobileLink___vue_template_functional__,
  MobileLink___vue_styles__,
  MobileLink___vue_scopeId__,
  MobileLink___vue_module_identifier__
)

/* harmony default export */ var src_components_MobileLink = (MobileLink_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentItem.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var ContentItem = ({
  props: ['page', 'index'],
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'contentsPinned', 'contentsNumbers', 'contentsTitles']), {

    currentPageIndex: function currentPageIndex() {
      return this.page[0].pageIndex;
    }
  }),
  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])(['goToPage']), Object(vuex_esm["d" /* mapMutations */])({
    toggleContents: "TOGGLE_CONTENTS"
  }), {

    getBackgroundURL: function getBackgroundURL(index, sectionIndex) {
      if (sectionIndex == 0) {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '.png)';
      } else {
        return 'url(' + this.basePath + '/static/_thumbs/' + (index + 1) + '-' + (sectionIndex + 1) + '.png)';
      }
    },

    toggleExpanded: function toggleExpanded(index) {
      this.isExpanded = !this.isExpanded;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09fd935e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentItem.vue
var ContentItem_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"contents-item"},[_c('div',{staticClass:"contents-item__section",class:{active: _vm.currentPage.pageIndex == _vm.currentPageIndex && _vm.currentPage.sectionIndex == 0}},[_c('div',{staticClass:"contents-item__text",on:{"click":function($event){if($event.target !== $event.currentTarget){ return null; }_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}},[(_vm.contentsNumbers)?_c('p',{staticClass:"contents-item__text--index"},[_vm._v("\n          "+_vm._s(_vm.currentPageIndex + 1)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsTitles)?_c('p',{class:['contents-item__text--title', _vm.contentsPinned ? '' : '']},[_vm._v("\n          "+_vm._s(_vm.page[0].title)+"\n        ")]):_vm._e(),_vm._v(" "),(_vm.contentsPinned && _vm.page.length > 1)?_c('div',{staticClass:"content-item__chevrons"},[_c('div',{staticClass:"contents-item__expander",on:{"click":function($event){_vm.toggleExpanded(_vm.index)}}},[(_vm.isExpanded)?_c('feather-icon',{attrs:{"icon":"chevron-up"}}):_c('feather-icon',{attrs:{"icon":"chevron-down"}})],1)]):_vm._e()]),_vm._v(" "),(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.currentPageIndex, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.currentPageIndex + 1, sectionIndex: 1});_vm.toggleContents();}}}):_c('div',{staticClass:"contents-item__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, 0)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: 1});_vm.toggleContents();}}})]),_vm._v(" "),(_vm.page.length > 1)?_c('div',{staticClass:"contents-item__sections",class:{'collapsed': !_vm.isExpanded}},_vm._l((_vm.page),function(section,sectionIndex){return (sectionIndex != 0)?_c('div',{key:(_vm.index+1) + '-' + (sectionIndex + 1),staticClass:"contents-item__subsection",class:{active: _vm.currentPage.pageIndex == _vm.index && _vm.currentPage.sectionIndex == sectionIndex}},[(_vm.contentsPinned)?_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]):_c('div',{staticClass:"contents-item__text",on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}},[_c('p',{staticClass:"contents-item__text--index"},[_vm._v(_vm._s(_vm.index + 1)+" - "+_vm._s(sectionIndex + 1))])]),_vm._v(" "),_c('div',{staticClass:"contents-section__thumb",style:({'background-image': _vm.getBackgroundURL(_vm.index, sectionIndex)}),on:{"click":function($event){_vm.goToPage({pageIndex: _vm.index + 1, sectionIndex: sectionIndex + 1});_vm.toggleContents();}}})]):_vm._e()})):_vm._e()])}
var ContentItem_staticRenderFns = []
var ContentItem_esExports = { render: ContentItem_render, staticRenderFns: ContentItem_staticRenderFns }
/* harmony default export */ var components_ContentItem = (ContentItem_esExports);
// CONCATENATED MODULE: ./src/components/ContentItem.vue
function ContentItem_injectStyle (ssrContext) {
  __webpack_require__("p53m")
}
var ContentItem_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentItem___vue_template_functional__ = false
/* styles */
var ContentItem___vue_styles__ = ContentItem_injectStyle
/* scopeId */
var ContentItem___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentItem___vue_module_identifier__ = null
var ContentItem_Component = ContentItem_normalizeComponent(
  ContentItem,
  components_ContentItem,
  ContentItem___vue_template_functional__,
  ContentItem___vue_styles__,
  ContentItem___vue_scopeId__,
  ContentItem___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentItem = (ContentItem_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ContentsPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ var ContentsPanel = ({
  data: function data() {
    return {
      isExpanded: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon,
    ContentItem: src_components_ContentItem
  },
  //TODO make sections
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'titledPages', 'basePath', 'currentPage', 'showContents', 'contentsPinned']))

});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-688d3493","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContentsPanel.vue
var ContentsPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('nav',{staticClass:"contents-panel"},[(_vm.contentsPinned)?_c('ul',{staticClass:"contents-list"},_vm._l((_vm.titledPages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})})):_c('ul',{staticClass:"contents-list"},_vm._l((_vm.pages),function(page,index){return _c('content-item',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}],key:index,attrs:{"page":page,"index":index}})}))])])}
var ContentsPanel_staticRenderFns = []
var ContentsPanel_esExports = { render: ContentsPanel_render, staticRenderFns: ContentsPanel_staticRenderFns }
/* harmony default export */ var components_ContentsPanel = (ContentsPanel_esExports);
// CONCATENATED MODULE: ./src/components/ContentsPanel.vue
function ContentsPanel_injectStyle (ssrContext) {
  __webpack_require__("hxKv")
}
var ContentsPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ContentsPanel___vue_template_functional__ = false
/* styles */
var ContentsPanel___vue_styles__ = ContentsPanel_injectStyle
/* scopeId */
var ContentsPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ContentsPanel___vue_module_identifier__ = null
var ContentsPanel_Component = ContentsPanel_normalizeComponent(
  ContentsPanel,
  components_ContentsPanel,
  ContentsPanel___vue_template_functional__,
  ContentsPanel___vue_styles__,
  ContentsPanel___vue_scopeId__,
  ContentsPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_ContentsPanel = (ContentsPanel_Component.exports);

// CONCATENATED MODULE: ./src/helpers/modules/trackingHandler.js
/* harmony default export */ var trackingHandler = ({
  init: function init() {
    // Events

    //External Links clicked
    document.addEventListener('click', this.trackOutboundLinks, false);
    //Video Played
    //https://medium.com/@matt_west/track-html5-video-events-using-google-analytics-and-javascript-3be691b8bd45

  },
  trackOutboundLinks: function trackOutboundLinks(event) {
    if (event.target.tagName != 'A') return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Outbound Link',
        eventAction: 'Click',
        eventLabel: event.target.href,
        transport: 'beacon'
      });
    }
  },
  trackSearchTerms: function trackSearchTerms(searchTerm) {
    if (searchTerm == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Search',
        eventAction: 'Search',
        eventLabel: searchTerm
      });
    }
  },
  trackVideoPlay: function trackVideoPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Video',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  },
  trackAudioPlay: function trackAudioPlay(filename) {
    if (filename == "") return;
    if (Publish.$gtag) {
      Publish.$gtag.event({
        eventCategory: 'Audio',
        eventAction: 'Play',
        eventLabel: filename
      });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SearchPanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SearchPanel = ({
  // TODO Highlight search text */

  data: function data() {
    return {
      searchText: '',
      searchResults: [],
      noResults: false
    };
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSearch: 'TOGGLE_SEARCH'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    // getBackgroundURL: (index) => "url(/static/_thumbs/"+(index)+"="+1+"-w140-h105.png)",
    // getBackgroundURL: (background) => 'url(/static/_content/'+ background +')',
    getBackgroundURL: function getBackgroundURL(background) {
      return this.basePath + '/static/_thumbs/' + background + '.png';
    },
    search: function search() {
      this.noResults = false;
      trackingHandler.trackSearchTerms(this.searchText);
      this.searchResults = window.search.search(this.searchText);
      if (this.searchResults.length == 0) {
        this.noResults = true;
      }
    },
    goToResultPage: function goToResultPage(pageIndex, sectionIndex) {
      this.goToPage({ pageIndex: pageIndex, sectionIndex: sectionIndex });
      this.toggleSearch();
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-07dfdf84","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SearchPanel.vue
var SearchPanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"search-fade"}},[_c('div',{staticClass:"search-container"},[_c('div',{staticClass:"search-panel"},[_c('div',{staticClass:"search-bar"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchText),expression:"searchText"}],staticClass:"search-input",attrs:{"type":"text","placeholder":"Search Publication"},domProps:{"value":(_vm.searchText)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key)){ return null; }_vm.search($event)},"input":function($event){if($event.target.composing){ return; }_vm.searchText=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"search-button",on:{"click":_vm.search}},[_c('feather-icon',{attrs:{"icon":"search"}})],1)]),_vm._v(" "),_c('transition-group',{staticClass:"search-results",attrs:{"name":"list","tag":"ul"}},_vm._l((_vm.searchResults),function(searchResult){return _c('li',{key:searchResult.id,staticClass:"search-result",on:{"click":function($event){_vm.goToResultPage(searchResult.pageIndex, searchResult.sectionIndex)}}},[_c('img',{staticClass:"search-result__image",attrs:{"src":_vm.getBackgroundURL(searchResult.thumb),"alt":""}}),_vm._v(" "),_c('div',{staticClass:"search-result__text"},[_c('div',{staticClass:"search-result__title"},[_vm._v("\n            "+_vm._s(searchResult.id)+". "+_vm._s(searchResult.title)+"\n          ")]),_vm._v(" "),_c('div',{staticClass:"search-result__body"},[_vm._v("\n            "+_vm._s(searchResult.body)+"\n          ")])])])})),_vm._v(" "),(_vm.noResults)?_c('div',{attrs:{"id":"noResultsContainer"}},[_c('h2',[_vm._v("No results found. Please try again")])]):_vm._e()],1)])])}
var SearchPanel_staticRenderFns = []
var SearchPanel_esExports = { render: SearchPanel_render, staticRenderFns: SearchPanel_staticRenderFns }
/* harmony default export */ var components_SearchPanel = (SearchPanel_esExports);
// CONCATENATED MODULE: ./src/components/SearchPanel.vue
function SearchPanel_injectStyle (ssrContext) {
  __webpack_require__("hLNX")
}
var SearchPanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SearchPanel___vue_template_functional__ = false
/* styles */
var SearchPanel___vue_styles__ = SearchPanel_injectStyle
/* scopeId */
var SearchPanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SearchPanel___vue_module_identifier__ = null
var SearchPanel_Component = SearchPanel_normalizeComponent(
  SearchPanel,
  components_SearchPanel,
  SearchPanel___vue_template_functional__,
  SearchPanel___vue_styles__,
  SearchPanel___vue_scopeId__,
  SearchPanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SearchPanel = (SearchPanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/SubscribePanel.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ var SubscribePanel = ({
  data: function data() {
    return {};
  },

  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['pages', 'rightToLeft', 'basePath'])),

  mounted: function mounted() {
    this.loadScripts();
  },


  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleSubscribe: 'TOGGLE_SUBSCRIBE'
  }), Object(vuex_esm["b" /* mapActions */])(['goToPage']), {
    loadScripts: function loadScripts() {
      this.setMailchimpOne();
      this.setMailchimpTwo();
    },
    setMailchimpOne: function setMailchimpOne() {
      var mailchimpValidation = document.createElement('script');
      mailchimpValidation.setAttribute('src', '//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js');
      document.head.appendChild(mailchimpValidation);
    },
    setMailchimpTwo: function setMailchimpTwo() {
      var mailchimpScript = document.createElement("script");
      var inlineScript = document.createTextNode("(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[5]='BIRTHDAY';ftypes[5]='birthday';}(jQuery));var $mcj = jQuery.noConflict(true);");
      console.log(inlineScript);
      mailchimpScript.appendChild(inlineScript);
      document.head.appendChild(mailchimpScript);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f908b6b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/SubscribePanel.vue
var SubscribePanel_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"subscribe-fade"}},[_c('div',{staticClass:"subscribe-container"},[_c('div',{staticClass:"subscribe-panel"},[_c('div',{attrs:{"id":"subscribe-overlay"}},[_c('div',{attrs:{"id":"mc_embed_shell"}},[_c('link',{attrs:{"href":"//cdn-images.mailchimp.com/embedcode/classic-061523.css","rel":"stylesheet","type":"text/css"}}),_vm._v(" "),_c('div',{attrs:{"id":"mc_embed_signup"}},[_c('img',{attrs:{"id":"subscription-cross","src":"/issue2/static/_content/subscription-cross.png"},on:{"click":_vm.toggleSubscribe}}),_vm._v(" "),_c('form',{staticClass:"validate",attrs:{"action":"https://kpstudio.us22.list-manage.com/subscribe/post-json?u=1db79021f22160aa6c8eff4de&id=41edb2fc75&f_id=0030c1e1f0&c=?","method":"post","id":"mc-embedded-subscribe-form","name":"mc-embedded-subscribe-form","target":"_blank"}},[_c('div',{attrs:{"id":"mc_embed_signup_scroll"}},[_c('img',{attrs:{"id":"subscription-img","src":"/issue2/static/_content/subscription-img.png"}}),_vm._v(" "),_c('h2',{staticClass:"sommet-rounded"},[_vm._v("Stay in the loop!")]),_vm._v(" "),_c('div',{staticClass:"mc-field-group"},[_c('label',{staticClass:"open-sans-regular",attrs:{"for":"mce-EMAIL"}},[_vm._v("\n                  Enter your email below to receive future issues of "),_c('strong',{staticClass:"open-sans-bold"},[_vm._v("The Loop")]),_vm._v(" direct to your inbox\n                ")]),_vm._v(" "),_c('input',{staticClass:"required email open-sans-regular",attrs:{"type":"email","name":"EMAIL","id":"mce-EMAIL","required":"","value":"","placeholder":"johnsmith@email.com"}})]),_vm._v(" "),_c('div',{staticClass:"clear",attrs:{"id":"mce-responses"}},[_c('div',{staticClass:"response open-sans-regular",staticStyle:{"display":"none"},attrs:{"id":"mce-error-response"}}),_vm._v(" "),_c('div',{staticClass:"response open-sans-regular",staticStyle:{"display":"none"},attrs:{"id":"mce-success-response"}},[_vm._v("There has been an error, please try again.")])]),_vm._v(" "),_c('div',{staticStyle:{"position":"absolute","left":"-5000px"},attrs:{"aria-hidden":"true"}},[_c('input',{attrs:{"type":"text","name":"b_1db79021f22160aa6c8eff4de_41edb2fc75","tabindex":"-1","value":""}})]),_vm._v(" "),_c('div',{staticClass:"clear"},[_c('input',{staticClass:"button sommet-rounded",attrs:{"type":"submit","name":"subscribe","id":"mc-embedded-subscribe","value":"Subscribe","onclick":"mailChimpSubmit()"}})])])])])])])])])])}
var SubscribePanel_staticRenderFns = []
var SubscribePanel_esExports = { render: SubscribePanel_render, staticRenderFns: SubscribePanel_staticRenderFns }
/* harmony default export */ var components_SubscribePanel = (SubscribePanel_esExports);
// CONCATENATED MODULE: ./src/components/SubscribePanel.vue
function SubscribePanel_injectStyle (ssrContext) {
  __webpack_require__("5Rfz")
}
var SubscribePanel_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var SubscribePanel___vue_template_functional__ = false
/* styles */
var SubscribePanel___vue_styles__ = SubscribePanel_injectStyle
/* scopeId */
var SubscribePanel___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SubscribePanel___vue_module_identifier__ = null
var SubscribePanel_Component = SubscribePanel_normalizeComponent(
  SubscribePanel,
  components_SubscribePanel,
  SubscribePanel___vue_template_functional__,
  SubscribePanel___vue_styles__,
  SubscribePanel___vue_scopeId__,
  SubscribePanel___vue_module_identifier__
)

/* harmony default export */ var src_components_SubscribePanel = (SubscribePanel_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ExternalResource.vue
//
//
//
//

/* harmony default export */ var ExternalResource = ({
  props: ['source']
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-277a16ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ExternalResource.vue
var ExternalResource_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('script',{attrs:{"type":"application/javascript","src":_vm.source}})}
var ExternalResource_staticRenderFns = []
var ExternalResource_esExports = { render: ExternalResource_render, staticRenderFns: ExternalResource_staticRenderFns }
/* harmony default export */ var components_ExternalResource = (ExternalResource_esExports);
// CONCATENATED MODULE: ./src/components/ExternalResource.vue
var ExternalResource_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var ExternalResource___vue_template_functional__ = false
/* styles */
var ExternalResource___vue_styles__ = null
/* scopeId */
var ExternalResource___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ExternalResource___vue_module_identifier__ = null
var ExternalResource_Component = ExternalResource_normalizeComponent(
  ExternalResource,
  components_ExternalResource,
  ExternalResource___vue_template_functional__,
  ExternalResource___vue_styles__,
  ExternalResource___vue_scopeId__,
  ExternalResource___vue_module_identifier__
)

/* harmony default export */ var src_components_ExternalResource = (ExternalResource_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/PageDots.vue

//
//
//
//
//
//



/* harmony default export */ var PageDots = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['currentPages', 'width', 'height', 'zeroedPageIndex', 'zeroedSectionIndex', 'rightToLeft']), {
    styleObject: function styleObject() {
      var xTranslation = -(this.width / 2 + 20);
      var yTranslation = -(this.height / 2 - 5);
      if (this.rightToLeft) {
        xTranslation = this.width / 2;
      }
      return {
        transform: 'translate(' + xTranslation + 'px, ' + yTranslation + 'px)',
        width: '20px'
      };
    }
  }),
  methods: {
    activePage: function activePage(page) {
      if (this.zeroedPageIndex == page.pageIndex && this.zeroedSectionIndex == page.sectionIndex) return true;
      return false;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-28b1b3a0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/PageDots.vue
var PageDots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-dots",style:(_vm.styleObject)},_vm._l((_vm.currentPages),function(page,index){return _c('div',{key:index,staticClass:"page-dot",class:{'page-dot--active': _vm.activePage(page)}})}))}
var PageDots_staticRenderFns = []
var PageDots_esExports = { render: PageDots_render, staticRenderFns: PageDots_staticRenderFns }
/* harmony default export */ var components_PageDots = (PageDots_esExports);
// CONCATENATED MODULE: ./src/components/PageDots.vue
function PageDots_injectStyle (ssrContext) {
  __webpack_require__("Tnot")
}
var PageDots_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var PageDots___vue_template_functional__ = false
/* styles */
var PageDots___vue_styles__ = PageDots_injectStyle
/* scopeId */
var PageDots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var PageDots___vue_module_identifier__ = null
var PageDots_Component = PageDots_normalizeComponent(
  PageDots,
  components_PageDots,
  PageDots___vue_template_functional__,
  PageDots___vue_styles__,
  PageDots___vue_scopeId__,
  PageDots___vue_module_identifier__
)

/* harmony default export */ var src_components_PageDots = (PageDots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/VideoContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var VideoContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['videoURL', 'isDoublePage']), {
    isYoutube: function isYoutube() {
      return this.videoURL.search('youtube') !== -1;
    },
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4a0b1688","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/VideoContainer.vue
var VideoContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[(_vm.isYoutube)?_c('div',{attrs:{"id":"video-container"}},[_c('div',{staticClass:"embed-container"},[_c('iframe',{attrs:{"id":"video","width":"854","height":"480","src":_vm.videoURL,"frameborder":"0","allow":"autoplay; encrypted-media","allowfullscreen":""}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2):_c('div',{attrs:{"id":"video-container"}},[_c('video',{attrs:{"id":"video","src":_vm.videoURL,"autoplay":"","controls":"controls","width":"967","height":"544"}},[_c('source',{attrs:{"src":_vm.videoURL,"type":"video/mp4"}})]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"video-close","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"video-close-mobile","onclick":"Publish.updateVideoURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var VideoContainer_staticRenderFns = []
var VideoContainer_esExports = { render: VideoContainer_render, staticRenderFns: VideoContainer_staticRenderFns }
/* harmony default export */ var components_VideoContainer = (VideoContainer_esExports);
// CONCATENATED MODULE: ./src/components/VideoContainer.vue
function VideoContainer_injectStyle (ssrContext) {
  __webpack_require__("J4AD")
}
var VideoContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var VideoContainer___vue_template_functional__ = false
/* styles */
var VideoContainer___vue_styles__ = VideoContainer_injectStyle
/* scopeId */
var VideoContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var VideoContainer___vue_module_identifier__ = null
var VideoContainer_Component = VideoContainer_normalizeComponent(
  VideoContainer,
  components_VideoContainer,
  VideoContainer___vue_template_functional__,
  VideoContainer___vue_styles__,
  VideoContainer___vue_scopeId__,
  VideoContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_VideoContainer = (VideoContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GalleryContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GalleryContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(["galleryImages", "galleryCaptions", "basePath", "galleryIndex", "isDoublePage"]), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    nextOptions: function nextOptions() {
      return {
        width: 50,
        height: 50
      };
    },
    prevOptions: function prevOptions() {
      return {
        class: "r180",
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobileNextOptions: function mobileNextOptions() {
      return {
        width: 24,
        height: 24
      };
    },
    mobilePrevOptions: function mobilePrevOptions() {
      return {
        class: "r180",
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4e710b5e","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GalleryContainer.vue
var GalleryContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"gallery-container"}},[(_vm.isDoublePage)?[_c('feather-icon',{attrs:{"id":"gallery-next","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.nextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.prevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('feather-icon',{attrs:{"id":"gallery-next-mobile","onclick":"Publish.nextGallerySlide()","icon":"play","options":_vm.mobileNextOptions}}),_vm._v(" "),_c('feather-icon',{attrs:{"id":"gallery-previous-mobile","onclick":"Publish.previousGallerySlide()","icon":"play","options":_vm.mobilePrevOptions}}),_vm._v(" "),_c('div',{attrs:{"id":"gallery-close-mobile","onclick":"Publish.closeGallery()"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)],_vm._v(" "),_vm._l((_vm.galleryImages),function(image,index){return _c('img',{class:{'active': index == _vm.galleryIndex, 'inactive': index != _vm.galleryIndex},attrs:{"src":_vm.basePath + '/static/_content/' + image,"alt":""}})}),_vm._v(" "),_c('div',{staticClass:"gallery-captions"},[(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])?_c('p',{staticClass:"gallery-caption"},[_vm._v("\n        "+_vm._s(_vm.galleryCaptions[_vm.galleryImages[_vm.galleryIndex]])+"\n      ")]):_vm._e()]),_vm._v(" "),_c('div',{staticClass:"gallery-dots"},_vm._l((_vm.galleryImages),function(image,index){return _c('div',{staticClass:"gallery-dot",class:{'gallery-dot--active': index == _vm.galleryIndex}})}))],2)])}
var GalleryContainer_staticRenderFns = []
var GalleryContainer_esExports = { render: GalleryContainer_render, staticRenderFns: GalleryContainer_staticRenderFns }
/* harmony default export */ var components_GalleryContainer = (GalleryContainer_esExports);
// CONCATENATED MODULE: ./src/components/GalleryContainer.vue
function GalleryContainer_injectStyle (ssrContext) {
  __webpack_require__("o4GY")
}
var GalleryContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GalleryContainer___vue_template_functional__ = false
/* styles */
var GalleryContainer___vue_styles__ = GalleryContainer_injectStyle
/* scopeId */
var GalleryContainer___vue_scopeId__ = "data-v-4e710b5e"
/* moduleIdentifier (server only) */
var GalleryContainer___vue_module_identifier__ = null
var GalleryContainer_Component = GalleryContainer_normalizeComponent(
  GalleryContainer,
  components_GalleryContainer,
  GalleryContainer___vue_template_functional__,
  GalleryContainer___vue_styles__,
  GalleryContainer___vue_scopeId__,
  GalleryContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GalleryContainer = (GalleryContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/GuideContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var GuideContainer = ({
    name: 'guide',
    components: {
        FeatherIcon: src_components_FeatherIcon
    },
    computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
        sectionIndices: function sectionIndices(state) {
            return state.sectionIndices;
        }
    }), Object(vuex_esm["c" /* mapGetters */])(["readerEnabled", "zoomNavEnabled", "contentsEnabled", "searchEnabled", "languagesEnabled", "downloadEnabled", "guideEnabled", "printEnabled", "isMobile", "fullscreenEnabled"]))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-399a74da","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/GuideContainer.vue
var GuideContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"guide-container"}},[_c('div',{attrs:{"id":"guide-page"}},[_c('div',{staticClass:"guide-title"},[_c('h4',[_vm._v("User Guide")])]),_vm._v(" "),_c('ul',{staticClass:"guide-items"},[_c('li',[_c('div',[_c('feather-icon',{staticClass:"guide-icons guide-navigation-prev",attrs:{"icon":"play"}}),_vm._v(" "),(_vm.isMobile && !(_vm.sectionIndices.length == 0))?_c('feather-icon',{staticClass:"guide-icons guide-navigation-down",attrs:{"icon":"play"}}):_vm._e(),_vm._v(" "),_c('feather-icon',{staticClass:"guide-icons guide-navigation-next",attrs:{"icon":"play"}})],1),_vm._v(" "),(_vm.isMobile)?_c('p',[_vm._v("Navigate using the arrows or by swiping")]):_c('p',[_vm._v("Navigate using arrows, your keyboard or by dragging the page")])]),_vm._v(" "),(_vm.zoomNavEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"zoom-in"}}),_vm._v(" "),_c('p',[_vm._v("Zoom in and out")])],1):_vm._e(),_vm._v(" "),(_vm.searchEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"search"}}),_vm._v(" "),_c('p',[_vm._v("Search for words or phrases")])],1):_vm._e(),_vm._v(" "),(_vm.languagesEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"globe"}}),_vm._v(" "),_c('p',[_vm._v("Change language")])],1):_vm._e(),_vm._v(" "),(_vm.downloadEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"download"}}),_vm._v(" "),_c('p',[_vm._v("Download PDF")])],1):_vm._e(),_vm._v(" "),(_vm.printEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"printer"}}),_vm._v(" "),_c('p',[_vm._v("Print PDF")])],1):_vm._e(),_vm._v(" "),(_vm.contentsEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"grid"}}),_vm._v(" "),_c('p',[_vm._v("Content navigation")])],1):_vm._e(),_vm._v(" "),(_vm.fullscreenEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"maximize-2"}}),_vm._v(" "),_c('p',[_vm._v("Toggle fullscreen")])],1):_vm._e(),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"viewBox":"0 0 160.62 157.733","enable-background":"new 0 0 160.62 157.733"}},[_c('g',[_c('path',{attrs:{"fill":"#000","d":"M81.691,67.001c7.996,0,14.477,6.481,14.477,14.477s-6.481,14.477-14.477,14.477\n\t\t\t\t\t\t\t\t\t\tc-7.995,0-14.476-6.482-14.476-14.477S73.697,67.001,81.691,67.001z"}}),_vm._v(" "),_c('path',{attrs:{"fill":"#000","d":"M124.263,52.933h-23.92l-0.716-5.581c0-3.189-2.585-5.774-5.774-5.774H69.218\n\t\t\t\t\t\t\t\t\t\tc-3.188,0-5.773,2.585-5.773,5.774l-0.716,5.581H39.001c-2.126,0-3.85,1.627-3.85,3.753v49.656c0,2.126,1.724,3.945,3.85,3.945\n\t\t\t\t\t\t\t\t\t\th85.262c2.125,0,3.849-1.819,3.849-3.945V56.686C128.112,54.56,126.388,52.933,124.263,52.933z M81.65,105.2\n\t\t\t\t\t\t\t\t\t\tc-13.074,0-23.672-10.599-23.672-23.672S68.576,57.856,81.65,57.856s23.672,10.598,23.672,23.671S94.724,105.2,81.65,105.2z\n\t\t\t\t\t\t\t\t\t\tM123.685,63.134h-20.209v-5.966h20.209V63.134z"}})]),_vm._v(" "),_c('g',[_c('path',{attrs:{"fill":"#000","d":"M154.856,78.867h-5.764c-0.001,9.313-1.884,18.156-5.29,26.209c-5.107,12.077-13.654,22.371-24.404,29.633\n\t\t\t\t\t\t\t\t\t\tc-5.375,3.631-11.298,6.504-17.62,8.47s-13.041,3.026-20.026,3.027c-9.314-0.001-18.156-1.884-26.21-5.29\n\t\t\t\t\t\t\t\t\t\tc-12.077-5.107-22.371-13.653-29.632-24.404c-3.631-5.375-6.504-11.298-8.471-17.62c-1.966-6.322-3.026-13.041-3.026-20.026\n\t\t\t\t\t\t\t\t\t\tc0.001-9.314,1.884-18.157,5.29-26.21C24.81,40.58,33.357,30.286,44.107,23.024c5.375-3.631,11.298-6.504,17.619-8.471\n\t\t\t\t\t\t\t\t\t\tc6.322-1.966,13.041-3.026,20.027-3.026c9.313,0,18.156,1.884,26.209,5.29c12.077,5.107,22.371,13.653,29.632,24.404\n\t\t\t\t\t\t\t\t\t\tc3.631,5.375,6.504,11.298,8.471,17.619c1.966,6.322,3.026,13.041,3.026,20.027H154.856h5.764c0.001-10.874-2.207-21.262-6.2-30.7\n\t\t\t\t\t\t\t\t\t\tc-5.991-14.161-15.983-26.191-28.567-34.694c-6.292-4.251-13.235-7.62-20.649-9.926C97.791,1.241,89.907,0,81.753,0\n\t\t\t\t\t\t\t\t\t\tC70.88-0.001,60.491,2.207,51.052,6.2c-14.161,5.991-26.19,15.983-34.693,28.567c-4.251,6.292-7.62,13.235-9.926,20.648\n\t\t\t\t\t\t\t\t\t\tc-2.306,7.413-3.547,15.296-3.546,23.451c-0.001,10.873,2.207,21.262,6.2,30.7c5.991,14.161,15.983,26.191,28.567,34.694\n\t\t\t\t\t\t\t\t\t\tc6.292,4.251,13.235,7.62,20.648,9.926c7.413,2.306,15.296,3.547,23.451,3.546c10.874,0.001,21.262-2.207,30.7-6.2\n\t\t\t\t\t\t\t\t\t\tc14.161-5.991,26.191-15.984,34.694-28.568c4.251-6.292,7.621-13.235,9.926-20.648c2.306-7.413,3.547-15.296,3.547-23.45H154.856\n\t\t\t\t\t\t\t\t\t\tL154.856,78.867z"}})])]),_vm._v(" "),_c('p',[_vm._v("Image gallery")])]),_vm._v(" "),_c('li',[_c('svg',{staticClass:"galleries",attrs:{"version":"1.1","id":"Layer_1","xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","x":"0px","y":"0px","width":"675px","height":"675px","viewBox":"0 0 675 675","enable-background":"new 0 0 675 675","xml:space":"preserve"}},[_c('circle',{attrs:{"fill":"none","stroke":"#000","stroke-width":"30","stroke-miterlimit":"10","cx":"339.195","cy":"340","r":"321"}}),_vm._v(" "),_c('polyline',{attrs:{"fill":"#000","points":"558,356 207,563 207,117 "}})]),_vm._v(" "),_c('p',[_vm._v("Video")])]),_vm._v(" "),(_vm.guideEnabled)?_c('li',[_c('feather-icon',{staticClass:"guide-icons",attrs:{"icon":"help-circle"}}),_vm._v(" "),_c('p',[_vm._v("User guide")])],1):_vm._e()])])])])}
var GuideContainer_staticRenderFns = []
var GuideContainer_esExports = { render: GuideContainer_render, staticRenderFns: GuideContainer_staticRenderFns }
/* harmony default export */ var components_GuideContainer = (GuideContainer_esExports);
// CONCATENATED MODULE: ./src/components/GuideContainer.vue
function GuideContainer_injectStyle (ssrContext) {
  __webpack_require__("hIWI")
}
var GuideContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var GuideContainer___vue_template_functional__ = false
/* styles */
var GuideContainer___vue_styles__ = GuideContainer_injectStyle
/* scopeId */
var GuideContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var GuideContainer___vue_module_identifier__ = null
var GuideContainer_Component = GuideContainer_normalizeComponent(
  GuideContainer,
  components_GuideContainer,
  GuideContainer___vue_template_functional__,
  GuideContainer___vue_styles__,
  GuideContainer___vue_scopeId__,
  GuideContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_GuideContainer = (GuideContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/AudioContainer.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ var AudioContainer = ({
  components: {
    FeatherIcon: src_components_FeatherIcon
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])(['audioURL', 'isDoublePage']), {
    options: function options() {
      return {
        width: 50,
        height: 50
      };
    },
    mobileOptions: function mobileOptions() {
      return {
        width: 24,
        height: 24
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40d498b8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AudioContainer.vue
var AudioContainer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{attrs:{"id":"audio-container"}},[_c('audio',{staticStyle:{"width":"300px","height":"36px"},attrs:{"controls":"","controlsList":"nodownload","autoplay":"","preload":"metadata"}},[_c('source',{attrs:{"src":_vm.audioURL,"type":"audio/mp3"}}),_vm._v("\n      Your browser does not support the audio element.\n    ")]),_vm._v(" "),(_vm.isDoublePage)?[_c('div',{attrs:{"id":"audio-close","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.options}})],1)]:[_c('div',{attrs:{"id":"audio-close-mobile","onclick":"Publish.updateAudioURL('')"}},[_c('feather-icon',{attrs:{"icon":"x-circle","options":_vm.mobileOptions}})],1)]],2)])}
var AudioContainer_staticRenderFns = []
var AudioContainer_esExports = { render: AudioContainer_render, staticRenderFns: AudioContainer_staticRenderFns }
/* harmony default export */ var components_AudioContainer = (AudioContainer_esExports);
// CONCATENATED MODULE: ./src/components/AudioContainer.vue
function AudioContainer_injectStyle (ssrContext) {
  __webpack_require__("WpSr")
}
var AudioContainer_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var AudioContainer___vue_template_functional__ = false
/* styles */
var AudioContainer___vue_styles__ = AudioContainer_injectStyle
/* scopeId */
var AudioContainer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AudioContainer___vue_module_identifier__ = null
var AudioContainer_Component = AudioContainer_normalizeComponent(
  AudioContainer,
  components_AudioContainer,
  AudioContainer___vue_template_functional__,
  AudioContainer___vue_styles__,
  AudioContainer___vue_scopeId__,
  AudioContainer___vue_module_identifier__
)

/* harmony default export */ var src_components_AudioContainer = (AudioContainer_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




















/* harmony default export */ var App = ({
  name: 'app',
  components: {
    PublishPage: src_components_PublishPage,
    NavigationBar: src_components_NavigationBar,
    NavigationLink: src_components_NavigationLink,
    ExternalResource: src_components_ExternalResource,
    ContentsPanel: src_components_ContentsPanel,
    LanguagesPanel: src_components_LanguagesPanel,
    EditionsPanel: src_components_EditionsPanel,
    SearchPanel: src_components_SearchPanel,
    SubscribePanel: src_components_SubscribePanel,
    PageDots: src_components_PageDots,
    GalleryContainer: src_components_GalleryContainer,
    MobileContainer: components_mobile_MobileContainer,
    VideoContainer: src_components_VideoContainer,
    GuideContainer: src_components_GuideContainer,
    MobileLink: src_components_MobileLink,
    AudioContainer: src_components_AudioContainer
  },
  data: function data() {
    return {};
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
    //   showLanguages: state => state.languages.showLanguages,
    //   showSearch: state => state.search.showSearch,
    //   isZoomed: state => state.zoom.isZoomed,
  }), Object(vuex_esm["c" /* mapGetters */])(['title', 'description', 'width', 'height', 'visiblePages', 'currentPage', 'previousPage', 'nextPage', 'nextNextPage', 'previousPreviousPage', 'previousPageURI', 'nextPageURI', 'previousSection', 'nextSection', 'previousSectionURI', 'nextSectionURI', 'previousMobilePage', 'nextMobilePage', 'previousMobilePageURI', 'nextMobilePageURI', 'externalResources', 'searchObject', 'pageScripts', 'documentScript', 'zoomLevel', 'pageContainerStyle', 'rightToLeft', 'isMobile', 'mobileSwitch', 'videoURL', 'showContents', 'contentsPinned', 'showLanguages', 'showSearch', 'showSubscribe', 'showGuide', 'showEditions', 'isZoomed', 'isIE11', 'isPhantom', 'companyLogo', 'publishURL', 'galleryImages', 'galleryCaptions', 'isDoublePage', 'audioURL', 'isMobileFontLarge'])),
  mounted: function mounted() {
    var _this = this;

    // console.log('mounted app component')
    this.setTitle();
    this.setDescription();
    if (this.publishURL != '') this.setOGImage();
    if (!(this.isMobile && this.mobileSwitch || this.isPhantom)) {
      this.loadScripts();
      window.addEventListener("load", function (event) {
        var p = parseInt(Publish.currentPage.pageIndex);
        var s = parseInt(Publish.currentPage.sectionIndex);
        if (window["p" + p + "s" + s + "onPageEnter"]) {
          window["p" + p + "s" + s + "onPageEnter"]();
        }
      });
      this.buildSearchIndex();
      this.resetSectionIndices();
    }
    if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
      this.setInitialWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
      this.changeWindowSize({
        width: screen.height,
        height: screen.width - 90
      });
    } else if (document.documentElement.dataset.mobile == "android") {
      this.setInitialWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
      this.changeWindowSize({
        // width: screen.width,
        // height: screen.height
        width: window.innerWidth,
        height: window.innerHeight
      });
    } else {
      this.changeWindowSize({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    window.addEventListener("orientationchange", function () {
      if ((window.orientation == 90 || window.orientation == -90) && document.documentElement.dataset.mobile == "iOS") {
        _this.setInitialWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
        _this.changeWindowSize({
          width: screen.height,
          height: screen.width - 60
        });
      } else {
        _this.setInitialWindowSize({
          width: screen.width,
          height: screen.height
        });
        _this.changeWindowSize({
          width: screen.width,
          height: screen.height
        });
      }
    });
  },

  watch: {
    currentPage: function currentPage(oldPage, newPage) {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
    }
  },
  methods: extends_default()({
    setTitle: function setTitle() {
      var newTitle = this.title;
      if (this.currentPage.title && this.currentPage.title.length > 0) {
        newTitle += " - " + this.currentPage.title;
      }
      window.document.title = newTitle;
      var meta = document.createElement('meta');
      meta.name = "og:title";
      meta.content = newTitle;
      meta.setAttribute('property', 'og:title');
      document.getElementsByTagName('head')[0].appendChild(meta);
    },
    setDescription: function setDescription() {
      var newDescription = this.description;
      if (this.currentPage.searchText && this.currentPage.searchText.length > 0) {
        newDescription = this.currentPage.searchText.substr(0, 250);
      }
      var meta = document.createElement('meta');
      meta.name = "description";
      meta.content = newDescription;
      document.getElementsByTagName('head')[0].appendChild(meta);
      var og = document.createElement('meta');
      og.name = "og:description";
      og.content = newDescription;
      og.setAttribute('property', 'og:description');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    setOGImage: function setOGImage() {
      var og = document.createElement('meta');
      og.name = "og:image";
      og.content = this.publishURL + (this.currentPage.index + 1) + '.png';
      og.setAttribute('property', 'og:image');
      document.getElementsByTagName('head')[0].appendChild(og);
    },
    buildSearchIndex: function buildSearchIndex() {
      window.search = new commonjs["Search"]('id');
      window.search.searchIndex = new commonjs["UnorderedSearchIndex"]();
      window.search.addIndex('title');
      window.search.addIndex('body');
      window.search.addDocuments(this.searchObject);
    },
    loadScripts: function loadScripts() {
      this.loadDocumentScript();
      this.loadPageScript();
      this.loadAddThis();
    },
    loadDocumentScript: function loadDocumentScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.documentScript);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadPageScript: function loadPageScript() {
      var newScript = document.createElement("script");
      var inlineScript = document.createTextNode(this.pageScripts);
      newScript.appendChild(inlineScript);
      document.getElementById('app').appendChild(newScript);
    },
    loadAddThis: function loadAddThis() {
      if (!this.isMobile) {
        var addthisScript = document.createElement('script');
        addthisScript.setAttribute('src', 'https://s7.addthis.com/js/300/addthis_widget.js#pubid=ra-5a2eb48d8548953f');
        document.body.appendChild(addthisScript);
      }
    }
  }, Object(vuex_esm["b" /* mapActions */])(['goToPage', 'goToNextPage', 'goToPreviousPage', 'goToNextSection', 'goToPreviousSection', 'resetSectionIndices', 'checkMobileLanding', 'goToPreviousMobilePage', 'goToNextMobilePage', 'changeWindowSize', 'setInitialWindowSize']), {
    onLeave: function onLeave(el) {
      el.style.opacity = 0;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e449796","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"name":"contents-fade"}},[_c('div',{class:{'right-to-left': _vm.rightToLeft, 'mobile': _vm.isMobile, 'zoomed': _vm.isZoomed, 'mobile-switch': _vm.mobileSwitch, 'mobile-font-large': _vm.isMobileFontLarge, 'ie11': _vm.isIE11, 'reader': _vm.isReader, 'doublePage': _vm.isDoublePage},attrs:{"id":"app"}},[(_vm.isPhantom)?[_c('img',{staticClass:"logo-loading centre",attrs:{"src":_vm.companyLogo,"alt":""}})]:[_c('navigation-bar',{ref:"navBar",attrs:{"title":_vm.title,"page":_vm.currentPage.title}}),_vm._v(" "),((_vm.isMobile && _vm.mobileSwitch) || _vm.isReader)?[_c('mobile-container'),_vm._v(" "),(_vm.isReader)?[(_vm.previousMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToPreviousMobilePage,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.nextMobilePage)?_c('mobile-link',{attrs:{"click":_vm.goToNextMobilePage,"classes":"navigation-link--next"}}):_vm._e()]:_vm._e()]:[_c('transition-group',{class:{contentsPinned: _vm.contentsPinned},style:(_vm.pageContainerStyle),attrs:{"name":"pages","tag":"div","id":"page-container"},on:{"leave":_vm.onLeave}},[_c('page-dots',{key:"page-dots"}),_vm._v(" "),_vm._l((_vm.visiblePages),function(page,key){return (page)?_c('publish-page',{key:page.pageIndex + 'a' + page.sectionIndex,attrs:{"classes":key,"page":page,"width":_vm.width,"height":_vm.height}}):_vm._e()})],2),_vm._v(" "),((_vm.isMobile && !_vm.isDoublePage))?[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()]:[(_vm.previousPageURI)?_c('navigation-link',{attrs:{"to":_vm.previousPageURI,"rotation":"180","classes":"navigation-link--prev"}}):_vm._e(),_vm._v(" "),(_vm.previousSectionURI)?_c('navigation-link',{attrs:{"to":_vm.previousSectionURI,"rotation":"270","classes":"navigation-link--up"}}):_vm._e(),_vm._v(" "),(_vm.nextPageURI)?_c('navigation-link',{class:[_vm.contentsPinned ? 'navigation-link--next__contents' : 'navigation-link--next'],attrs:{"to":_vm.nextPageURI}}):_vm._e(),_vm._v(" "),(_vm.nextSectionURI)?_c('navigation-link',{attrs:{"to":_vm.nextSectionURI,"rotation":"90","classes":"navigation-link--down"}}):_vm._e()],_vm._v(" "),_c('contents-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showContents),expression:"showContents"}]}),_vm._v(" "),_c('search-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSearch),expression:"showSearch"}]}),_vm._v(" "),_c('subscribe-panel',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSubscribe),expression:"showSubscribe"}]}),_vm._v(" "),_c('guide-container',{directives:[{name:"show",rawName:"v-show",value:(_vm.showGuide),expression:"showGuide"}]}),_vm._v(" "),_vm._l((_vm.externalResources),function(resource){return (_vm.externalResources.length > 0)?_c('external-resource',{key:resource,attrs:{"source":resource}}):_vm._e()})]],_vm._v(" "),(_vm.videoURL != '')?_c('video-container'):_vm._e(),_vm._v(" "),(_vm.galleryImages.length)?_c('gallery-container'):_vm._e(),_vm._v(" "),(_vm.audioURL !=  '')?_c('audio-container'):_vm._e()],2)])}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
function App_injectStyle (ssrContext) {
  __webpack_require__("B4ao")
}
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = App_injectStyle
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./src/store/mutation-types.js
// Toggles for panels/overlays/zoom
var TOGGLE_CONTENTS = 'TOGGLE_CONTENTS';
var TOGGLE_LANGUAGES = 'TOGGLE_LANGUAGES';
var TOGGLE_GUIDE = 'TOGGLE_GUIDE';
var TOGGLE_EDITIONS = 'TOGGLE_EDITIONS';
var TOGGLE_FONT_SIZE = 'TOGGLE_FONT_SIZE';

var TOGGLE_ZOOM = 'TOGGLE_ZOOM';
var UPDATE_ZOOM = 'UPDATE_ZOOM';
var SLIDE_ZOOM = 'SLIDE_ZOOM';

var TOGGLE_SEARCH = 'TOGGLE_SEARCH';
var TOGGLE_SUBSCRIBE = 'TOGGLE_SUBSCRIBE';
var TOGGLE_READER = 'TOGGLE_READER';
var TOGGLE_FULLSCREEN = 'TOGGLE_FULLSCREEN';
var UPDATE_FULLSCREEN = 'UPDATE_FULLSCREEN';

var RESET_SECTION_INDICES = 'RESET_SECTION_INDICES';
var CHANGE_SECTION_INDEX = 'CHANGE_SECTION_INDEX';
var UPDATE_INITIAL_WINDOW_SIZE = 'UPDATE_INITIAL_WINDOW_SIZE';
var UPDATE_PAGE_SCALE = 'UPDATE_PAGE_SCALE';
var UPDATE_VIDEO_URL = 'UPDATE_VIDEO_URL';
var UPDATE_AUDIO_URL = 'UPDATE_AUDIO_URL';
var UPDATE_IS_DOUBLE_PAGE = 'UPDATE_IS_DOUBLE_PAGE';
var UPDATE_GALLERY = 'UPDATE_GALLERY';
var UPDATE_GALLERY_INDEX = 'UPDATE_GALLERY_INDEX';
var UPDATE_CONTENT_PANEL = 'UPDATE_CONTENT_PANEL';
// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// CONCATENATED MODULE: ./src/document.js
/* harmony default export */ var src_document = ({
  "guid": "437c4aa5-0410-47e4-b976-27dbfeda165b",
  "title": "The Loop - The European Beverage Can Magazine - Issue 3",
  "shortTitle": "",
  "description": "",
  "width": 1263,
  "height": 893,
  "currentLanguage": "EN",
  "languages": [{
    "code": "EN",
    "text": "English",
    "href": "#"
  }],
  "basePath": "/issue3",
  // "basePath": "", 
  "companyLogo": "1-logo-1.png",
  "publishURL": "http://touchline-loop.s3-website.eu-west-2.amazonaws.com/issue3/static/_thumbs/",
  "externalResources": ["https://cdnjs.cloudflare.com/ajax/libs/gsap/1.19.0/TweenMax.min.js"],
  "options": {
    "doublePage": false,
    "rightToLeft": false,
    "searchEnabled": true,
    "subscribeEnabled": true,
    "downloadEnabled": false,
    "downloadPath": '',
    "printEnabled": false,
    "zoom": {
      "navEnabled": false,
      "sliderEnabled": true,
      "clickEnabled": true,
      "scrollEnabled": true
    },
    "contents": {
      "enabled": true,
      "pinned": false,
      "numbers": true,
      "titles": true
    },
    "languagesEnabled": false,
    "editionsEnabled": false,
    "mobileSwitch": false,
    "guideEnabled": false,
    "galleryCaptions": {},
    "fullscreenEnabled": true
  },
  "pages": [[{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 0,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg1.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScaleC 1-logo\" style=\"top:-100px;left:-179px;\" src=\"/issue3/static/_content/1-logo-1.png\"/>\n\n        <img class=\"abs halfScale 1-title\" style=\"top:385px;left:61px;\" src=\"/issue3/static/_content/1-title-1.png\"/>\n        <img class=\"abs halfScale 1-title\" style=\"top:465px;left:59px;\" src=\"/issue3/static/_content/1-title-2.png\"/>\n        <img class=\"abs halfScale 1-title\" style=\"top:603px;left:60px;\" src=\"/issue3/static/_content/1-sub-1.png\"/>\n\n        <img class=\"abs halfScale 1-text\" style=\"top:782px;left:51px;\" src=\"/issue3/static/_content/1-text-1.png\"/>   \n        <img class=\"abs halfScale 1-text\" style=\"top:782px;left:358px;\" src=\"/issue3/static/_content/1-text-2.png\"/>   \n        <img class=\"abs halfScale 1-text\" style=\"top:787px;left:706px;\" src=\"/issue3/static/_content/1-text-3.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg1Anim = new TimelineMax()\n          pg1Anim.fromTo(cOf(\"1-logo\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .staggerFromTo(cOf(\"1-title\"), 1.2, {opacity:0, y: 70}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1.1)\n          .staggerFromTo(cOf(\"1-text\"), 0.7, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.3, 1.2)\n        }\n\n        function onPageLeave() {\n          pg1Anim.stop();\n        }\n      ",
    "searchText": "The European Beverage Can Magazine  ON THE  BIG STAGE Cans, creativity and limited editions  Canned coffee goes premium  The latest European recycling progress  Cross-industry collaboration on single alloy aluminium production"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 1,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg2.jpg",
    "zoom": null,
    "content": "\n        <img class=\"abs halfScale 2-title\" style=\"top:96px;left:134px;\" src=\"/issue3/static/_content/2-title-1.png\"/>\n\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:44px; width:31px; height:28px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(3);\" style=\"top:178px; left:129px; width:210px; height:19px;\"></div>      \n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(4);\" style=\"top:213px; left:129px; width:355px; height:19px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(9);\" style=\"top:261px; left:147px; width:342px; height:436px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(9);\" style=\"top:716px; left:172px; width:272px; height:19px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(13);\" style=\"top:756px; left:172px; width:207px; height:19px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(14);\" style=\"top:261px; left:508px; width:342px; height:436px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(14);\" style=\"top:717px; left:538px; width:151px; height:19px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(18);\" style=\"top:756px; left:538px; width:140px; height:19px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(20);\" style=\"top:261px; left:872px; width:342px; height:436px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(20);\" style=\"top:717px; left:895px; width:242px; height:19px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(23);\" style=\"top:756px; left:895px; width:196px; height:19px;\"></div>\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(27);\" style=\"top:811px; left:884px; width:296px; height:19px;\"></div>\n\n        <div id=\"subscribe-overlay\" class=\"standardTransition contentOverlay hidden noclick\">\n          <div id=\"mc_embed_shell\">\n            <link href=\"//cdn-images.mailchimp.com/embedcode/classic-061523.css\" rel=\"stylesheet\" type=\"text/css\">\n            <div id=\"mc_embed_signup\">\n              <img id=\"subscription-cross-p2\" onclick=\"hideOverlay('subscribe-overlay')\" src=\"/issue3/static/_content/subscription-cross.png\" />\n              <form action=\"https://kpstudio.us22.list-manage.com/subscribe/post-json?u=1db79021f22160aa6c8eff4de&amp;id=41edb2fc75&amp;f_id=0030c1e1f0&c=?\" method=\"post\" id=\"mc-embedded-subscribe-form\" name=\"mc-embedded-subscribe-form\" class=\"validate\" target=\"_blank\">\n                <div id=\"mc_embed_signup_scroll\">\n                  <img id=\"subscription-img\" src=\"/issue3/static/_content/subscription-img.png\" />\n                  <h2 class=\"sommet-rounded\">Stay in the loop!</h2>\n                  <div class=\"mc-field-group\">\n                    <label class=\"open-sans-regular\" for=\"mce-EMAIL\">\n                      Enter your email below to receive future issues of <strong class=\"open-sans-bold\">The Loop</strong> direct to your inbox\n                    </label>\n                    <input type=\"email\" name=\"EMAIL\" class=\"required email open-sans-regular\" id=\"mce-EMAIL\" required=\"\" value=\"\" placeholder=\"johnsmith@email.com\">\n                  </div>\n                  <div id=\"mce-responses\" class=\"clear\">\n                    <div class=\"response open-sans-regular\" id=\"mce-error-response\" style=\"display: none;\"></div>\n                    <div class=\"response open-sans-regular\" id=\"mce-success-response\" style=\"display: none;\">There has been an error, please try again.</div>\n                  </div>\n                  <div aria-hidden=\"true\" style=\"position: absolute; left: -5000px;\"><input type=\"text\" name=\"b_1db79021f22160aa6c8eff4de_41edb2fc75\" tabindex=\"-1\" value=\"\"></div>\n                  <div class=\"clear\"><input type=\"submit\" name=\"subscribe\" id=\"mc-embedded-subscribe\" class=\"button sommet-rounded\" value=\"Subscribe\" onclick=\"mailChimpSubmit()\"></div>\n                </div>\n              </form>\n            </div>\n            <script type=\"text/javascript\" src=\"//s3.amazonaws.com/downloads.mailchimp.com/js/mc-validate.js\"></script>\n            <script type=\"text/javascript\">(function($) {window.fnames = new Array(); window.ftypes = new Array();fnames[0]='EMAIL';ftypes[0]='email';fnames[1]='FNAME';ftypes[1]='text';fnames[2]='LNAME';ftypes[2]='text';fnames[3]='ADDRESS';ftypes[3]='address';fnames[4]='PHONE';ftypes[4]='phone';fnames[5]='BIRTHDAY';ftypes[5]='birthday';}(jQuery));var $mcj = jQuery.noConflict(true);</script>\n          </div>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          pg2Anim = new TimelineMax();\n          pg2Anim.fromTo(cOf(\"2-title\"), 0.7, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n            setTimeout(function(){\n              showOverlay('subscribe-overlay');\n            }, 1000)\n        }\n\n        function onPageLeave() {\n          pg2Anim.stop();\n          removeContentLinks();\n          hideOverlay('subscribe-overlay');\n        }\n      ",
    "searchText": "the loop  CONTENTS 03  Opening statement  04  Cover story: Sipping on summer  09 Contents  20  28  Climbing the recycling ladder  13  A can-tastic summer		  14  Cool beans  18  Only Cans  ustry Ind  inabili sta  Su  02  09  I  ty  ovation nn  14 27  20  A single goal: a new alloy  23  Return to sender		 About Metal Packaging Europe"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 2,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg3.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n        <img class=\"abs halfScale 3-title\" style=\"top:101px;left:163px;\" src=\"/issue3/static/_content/3-title-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg3Anim = new TimelineMax();\n          pg3Anim.fromTo(cOf(\"3-title\"), 0.7, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 1)\n        }\n\n        function onPageLeave() {\n          pg3Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "the loop  OPENING STATEMENT We're delighted to present the third  Inside, you'll find stories that capture  You'll also hear from many of our valued  instalment of The Loop – our latest  how creativity and collaboration continue  partners, including Every Can Counts,  dive into the exciting world of the  to shape our industry, from the latest  Alupro and European Aluminium, and  beverage can. We're proud to present  advances in recycling and alloy technology  MPE's beverage can associations in  another insight-packed magazine filled  to the inventive ways brands use cans  Benelux, France, Spain, Germany  with curated news, food for thought  to engage fans at festivals, in the world  and the United Kingdom. We thank  and actionable takeaways.  of sport, and beyond.  these organisations as always for their thoughtful contributions and  Introduction  boundless passion for packaging. Whether you're here for insight, inspiration or a little of both, I hope this issue leaves you as energised about the future of the can as we are. To stay in the loop, click the envelope icon in the top right to get each new edition delivered straight to your inbox. Happy reading!  Bartłomiej Wojdyło MPE Beverage Executive Committee Chair Sustainability Director Europe CANPACK  03 28"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 3,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg4.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n        <img class=\"abs halfScale 4-title\" style=\"top:72px;left:163px;\" src=\"/issue3/static/_content/4-title-1.png\"/>\n        <img class=\"abs halfScale 4-title\" style=\"top:132px;left:149px;\" src=\"/issue3/static/_content/4-title-2.png\"/>\n        <img class=\"abs halfScale 4-sub\" style=\"top:345px;left:784px;\" src=\"/issue3/static/_content/4-sub-1.png\"/>\n        <img class=\"abs halfScale 4-sub\" style=\"top:442px;left:786px;\" src=\"/issue3/static/_content/4-sub-2.png\"/>\n        <img class=\"abs halfScale 4-sub\" style=\"top:602px;left:189px;\" src=\"/issue3/static/_content/4-sub-3.png\"/>\n\n        <img class=\"abs halfScale\" style=\"top:266px;left:374px;\" src=\"/issue3/static/_content/4-img-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg4Anim = new TimelineMax();\n          pg4Anim.staggerFromTo(cOf(\"4-title\"), 0.7, {opacity:0, x: 70}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"4-sub\"), 0.7, {opacity:0, x: 70}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.2, 1.3)\n        }\n\n        function onPageLeave() {\n        pg4Anim.stop();\n        removeContentLinks();\n\n        }\n      ",
    "searchText": "SIPPING ON  SUMMER  CANS, CREATIVITY AND THE SUMMER STAGE  Cover story  the loop  Drinks brands know the value of summer events and beverage cans are the format of choice to engage with new fans and connect with consumers.  Written by Dominique Huret of Cape Decision  S  ummer is big business for beverage brands. The continent's music festivals – including Tomorrowland  in Belgium and Poland's Pol'and'Rock festival – are in full swing, while marketing opportunities in sport are huge. It's a lucrative time of the year and one that relies heavily on limited edition packs.  04 28"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 4,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg5.jpg",
    "zoom": null,
    "content": "\n       <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div>\n\n       <a href=\"https://www.canmakers.co.uk/wp-content/uploads/2025/03/Aluminium-Beverage-Cans-A-Journey-Through-Design-Innovation-.pdf\" target=\"_blank\" class=\"addContentLink\"  style=\"top:0px; left:444px; width:275px; height:344px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n        setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n         removeContentLinks();\n        }\n      ",
    "searchText": "the loop Packaging can create a buzz, ensuring brands get the bang for their marketing buck. Beverage cans play their part too, creating a perfect canvas for drinks makers to get their message across. With its 360-degree design surface, a raft of texture effects plus high-resolution print technology at its most advanced, the can format allows brands to go as wild as their imaginations dare.  Smart marketing  Click to explore the evolution of can design further in the Can Makers' latest report  Cover story  “Cans made the perfect fit for 2025's music and sports events – portable,  event, emphasising their specific energy  convenient and ideal for the growing  and visual identity.  crowd choosing moderation. They enhance brand visibility, strengthen fan  Technology has enabled brands to  engagement and support sustainability,  go further than ever before.  turning every sip into a smart marketing  Advancements in digital printing means  moment,” says Paweł Wiśnioch, Project  customisation has become a reality.  Manager at the Foundation for Recovery  Direct-to-can applications enable  “Limited edition designs not only build  of Aluminium Packaging RECAL, and  high-resolution images to be printed  brand visibility, but also embed the  Każda Puszka Cenna, the Polish arm of  directly onto the can, perfect for small  “Cans enhance brand  product emotionally in participants'  the beverage can recycling initiative  batch production. Variable data opens  visibility, strengthen  experiences. This year, Tyskie's  Every Can Counts.  up the possibility for targeted  fan engagement and  Pol'and‘Rock brand activation includes  campaigns – a dream for any marketer  support sustainability,  not only on-site branding and special  chasing a new generation of drinkers.  turning every sip into  can designs, but also an exclusive zone  a smart marketing  dedicated to nolo (no-alcohol and low-  moment”  alcohol) beverages,” explains Wiśnioch.  Poland's favourite event during festival season is Pol'and‘Rock, one of the biggest  05 28  free-entry music festivals in Europe which  Vibrant special effect inks and  convenes around 700,000 music fans each  varnishes also help to stand out from  year. The Tyskie beer brand, from a major  the crowd. For example, thermochromic  Paweł Wiśnioch  Alongside a growing trend of promoting  Polish brewery group owned by Asahi  and photochromic inks make beverage  Fundacja RECAL  their nolo offerings by encouraging  Breweries, engaged with music festivals  cans chameleon-like in their colour-  responsible drinking behaviour, beverage  including Pol'and‘Rock through a limited  changing capabilities. It goes some  brands are taking advantage of the  series of Tyskie cans. The result? Unique  way to create a strong engagement  can's solid sustainability credentials  designs that refer to the style of each  between brand and consumer.  to boost their own – and using their"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 5,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg6.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n         removeContentLinks();\n        }\n      ",
    "searchText": "the loop platform at festivals to promote responsible recycling too. The addition of reverse vending machines at Pol'and‘Rock ensured that 1.5 tonnes of beverage cans were collected, a five-fold increase on 2024. Meanwhile, Wiśnioch notes that beer brand Tyskie played its part in sharing the benefits of Deposit Return Schemes at a separate Polish  Cover story  festival, with support from Każda Puszka Cenna's volunteers. Such  Powering partygoers  initiatives are helping the beverage  Meanwhile in Boom, Belgium, the  can industry work towards hitting  legendary Tomorrowland music festival  the EU recycling targets across  2025 drew in 400,000 attendees from over  the continent.  200 countries. AB Inbev was the exclusive beer provider quenching the thirst of music  Also in Poland, brewing group Grupa  fans by mostly supplying its Jupiler lager. An  Żywiec (part of Heineken) created a  estimated 3.6 million cans were purchased  collectable, limited edition can series  during the two weekends of the festival.  for one of the nation's hottest music events, the touring Męskie Granie pop  Beer wasn't the only fuel that kept people  music festival. With eight unique designs,  going. Canned energy drinks did a roaring  each representing one of the tour cities,  trade, powering partygoers until the early  the cans were designed in collaboration  hours, as did the key message to ‘Drink  with visual artist Marcin Czaja.  More Water', an initiative run in partnership with Erasmus Student Network. Cans of  The aluminium is used as a canvas for  water were distributed free to festivalgoers,  Czaja's intricate illustrations, using  helping to keep them hydrated.  advanced printing technology to “reflect  06 28  the dynamism of Polish city life”. Ewa  Coca-Cola made its presence felt with  Stefanowicz, Żywiec Brand Manager,  limited edition Tomorrowland cans.  explains: “These cans are more than  It added a competition element to the  packaging. They're a collectable part  new design, with selected cans signed  of the experience.”  by famous DJs and available for fans to"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 6,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg7.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n        setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n         removeContentLinks();\n        }\n      ",
    "searchText": "Cover story  the loop  win. Run by its Coca-Cola Europacific  Tapping into the trend, brewer  Partners branch, there was also a “vibrant  Carlsberg recently created a street art  experience zone with a branded terrace,  zone at Poland's SBM hip-hop festival,  signature bar and relaxed chill zone”,  educating attendees about packaging  according to Senior Manager of Music  recycling schemes in Poland. Każda Puszka  and Sports Philippe Spildooren.  Cenna was an active participant, creating a special can-based pop-art installation  In Paris too, Schweppes strategically  Art attack  for the occasion in collaboration with  “Combining summer  leverages summer events to combine  Urban art has become a powerful form  Carlsberg's Brooklyn beer brand, as seen  visibility, sampling  brand visibility with engaging storytelling.  of cultural expression and a source of  in the image above.  and eco-conscious  This year, it took advantage of the  storytelling,  sleek design, innate portability and  creative inspiration. Street art festivals transform cities into open-air museums,  “People really enjoy these installations  Schweppes  sustainability credentials of the can  showcasing the talent of local and  where we create different pixel artworks  strengthens  format as part of its sampling campaign.  international street artists through  using cans – from animal motifs to  breathtaking XXL murals and fostering  customised designs for special occasions,  and consumer  Sophie de Guigné, Schweppes' Sustainable  a unique form of tourism.  such as the International Green Film  connection.”  Packaging Marketing Manager, explains:  both brand presence  Festival in Kraków, held in a prestigious  07 28  “As an iconic brand strongly associated  Sophie de Guigné  Beverage cans have a proud tradition  location next to Wawel Castle. The  of taking art from the street to the pack.  art makes the perfect background for  From pop art and illustrated characters  selfies and helps raise awareness of the  over in France [among soft drinks]. It  to minimalism and art deco, the format's  importance of collecting and recycling  capitalises on summer as a key period  surface offers designers a sleek canvas to  cans among locals and tourists alike,”  of consumption, sunshine and social  demonstrate their creativity.  adds RECAL Foundation's Wiśnioch.  gatherings. Each year, our brand connects  Schweppes  with sunny days, Schweppes ranks second among consumers aged 35 and"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 7,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg8.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n        setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n         removeContentLinks();\n        }\n      ",
    "searchText": "the loop with consumers through large-scale  Rob Hobart, Marketing Director at  sampling campaigns.  Asahi UK, explains: 'The Women's Rugby World Cup 2025 [was] a landmark event  “In 2025, Schweppes Agrumes, a mixed  and [we] committed to helping our retail  citrus drink that is one of our flagship  partners fully capitalise on it. We also  products, was on the stage. The  [gave] fans incredible chances to win,  Schweppes team executed a major  fostering a deeper connection with the  tour across eight cities over three  tournament and Asahi Super Dry,  months, distributing 600,000 15cl  both in-store and at home.”  Cover story  mini cans and embedding the brand into consumers' most memorable  Whether it's showcasing the world's  summer moments. A giant can art  finest rugby players or celebrating  installation on the emblematic La  music, the summer will always play out  Defense plaza in Paris was just one  strongly for drinks brands. They know  of them. Combining summer visibility,  the power events have to reach new  sampling and eco-conscious storytelling, consumers. And through beverage Schweppes strengthens both brand  cans, they have the perfect backdrop  presence and consumer connection.”  to communicate their messages.  Winning mentality Sport has the power to cut through to new audiences. In England, the major event was the Women's Rugby World Cup and Asahi Super Dry lager was the official beer of the tournament. Rolling out across all Asahi Super Dry and Asahi Super Dry 0.0% cans, a special themed promotion encouraged fans to scan QR codes to play a mobile game for a chance to instantly win prizes. As part of Asahi's sponsorship, it created a bespoke World Cup design emblazoned with the tournament logo. Asahi Super Dry's  08 28  Rugby Like Never Before video campaign, starring English full-back Ellie Kildunne, showcases this limited edition can."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 8,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg9.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n        <img class=\"abs halfScale 9-title-1\" style=\"top:388px;left:112px;\" src=\"/issue3/static/_content/9-title-1.png\"/>\n        <img class=\"abs halfScale 9-title-1\" style=\"top:356px;left:225px;\" src=\"/issue3/static/_content/9-title-2.png\"/>\n        <img class=\"abs halfScale 9-title-1\" style=\"top:275px;left:295px;\" src=\"/issue3/static/_content/9-title-3.png\"/>\n        <img class=\"abs halfScale 9-title-1\" style=\"top:233px;left:361px;\" src=\"/issue3/static/_content/9-title-4.png\"/>\n        <img class=\"abs halfScale 9-title-2\" style=\"top:145px;left:520px;\" src=\"/issue3/static/_content/9-title-5.png\"/>\n        <img class=\"abs halfScale 9-title-2\" style=\"top:172px;left:965px;\" src=\"/issue3/static/_content/9-title-6.png\"/>\n        <img class=\"abs halfScale 9-title-2\" style=\"top:297px;left:715px;\" src=\"/issue3/static/_content/9-sub-1.png\"/>\n        <img class=\"abs halfScale 9-title-2\" style=\"top:303px;left:997px;\" src=\"/issue3/static/_content/9-sub-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg9Anim = new TimelineMax();\n          pg9Anim.staggerFromTo(cOf(\"9-title-1\"), 1.2, {opacity:0, y: -70}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.15, 1)\n          .staggerFromTo(cOf(\"9-title-2\"), 0.8, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.3, 1.6)\n        }\n\n        function onPageLeave() {\n          pg9Anim.stop();\n            removeContentLinks();\n        }\n      ",
    "searchText": "the loop  inabili sta  ty  Su  Section 1  M I L C  BING Written by Lynda Searby  THE R E C YC L I N G LADDER A progress report on beverage can recycling in Europe – including how DRS is driving recycling rate improvements across the continent.  L  atest figures released by Metal Packaging  Europe and European Aluminium show that 75% of beverage cans were recycled in Europe in 2022. Although in percentage terms this represents a marginal drop of 1% on 2021, in real terms, the total amount of aluminium recycled increased 1.7% on the previous year to a record 580,000 tonnes.  09 23"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 9,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg10.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n        <img class=\"abs halfScaleC 10-pie\" style=\"top:82px;left:944px\" src=\"/issue3/static/_content/10-pie-1.png\"/>\n\n        <h1 id=\"10-no\" class=\"abs sommet 10-no\" style=\"top:267px;left:960px; font-size: 4.6em; font-weight: 300; color: #2146a8; padding: 0px; margin: 0px;\"  data-number='{\"to\": 75}' ></h1>\n        <img class=\"abs halfScale 10-percentage\" style=\"top:301px;left:1048px;\" src=\"/issue3/static/_content/10-percentage-1.png\"/>\n\n        <img class=\"abs halfScale 10-text\" style=\"top:346px;left:959px;\" src=\"/issue3/static/_content/10-text-1.png\"/>\n      \"\n      ",
    "script": "\n        function onPageEnter() {\n          pg10Anim = new TimelineMax();\n          pg10Anim.fromTo(cOf(\"10-pie\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n          .fromTo(cOf(\"10-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"10-no\")[0])}}, 1.1)\n          .fromTo(cOf(\"10-percentage\"), 0.7, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1.3)\n          .fromTo(cOf(\"10-text\"), 0.7, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1.6)\n        }\n\n        function onPageLeave() {\n          pg10Anim.stop()\n          resetNumbers(\"10-no\")\n          removeContentLinks();\n        }\n      ",
    "searchText": "the loop The explanation for this is that the market grew at a slightly faster pace than the recycling rate. Higher production and consumption resulted in more cans entering the recycling stream. However, stable collection and sorting rates meant that the percentage of cans recycled decreased slightly. ty  75%  inabili sta  Andy Doran, director of the Packaging Group at European Aluminium,  Su  says this situation highlights the  of beverage cans were recycled in Europe in 2022  importance of continued improvement  Section 1  in infrastructure.  Balancing consumption and collection “It is good for our industry that cans are becoming more popular as a  New schemes come on stream  packaging format, but it is critical for  What is not reflected in these recycling  can recyclers and producers that  figures is the latest wave of DRS  end-of-life collection keeps pace with  implementation activity. Latvia and  or – ideally outstrips – consumption,  Slovakia adopted DRS in 2022, followed  because we want to keep climbing that  by Romania and Malta in 2023, Hungary and Ireland in 2024, and, earlier this year,  recycling ladder,” he explains. Metal Packaging Europe and European Aluminium have jointly pledged to  “We want to  reach 100% circularity for aluminium  keep climbing that  beverage cans by 2030. Doran is  recycling ladder”  confident that the industry is “on the right long-term path” to achieve this target.  10 23  Andy Doran European Aluminium  the embedded infrastructure that is  Austria. As these schemes are still in their  coming on stream, numbers will continue  infancy, and due to lags in data reporting,  to rise,” he says.  their impact on recycling rates has yet to be felt, but early signs are promising, with  Deposit Return Systems (DRS) are widely  all countries observing an increase in  accepted as the key to bettering recycling  recycling rates.  rates. It is no coincidence that several countries at the top of the league table  Doran predicts that by the time the  “Can recycling rates have been in the  – Germany, Belgium, Finland, Norway,  next set of figures is released, some of  mid-seventies for the last two to three  Denmark, Switzerland and Luxembourg –  these initiatives will have translated to  years and I strongly believe that, with  have well-managed DRS systems.  tangible improvements."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 10,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg11.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n        \n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 11-img-1\" style=\"top:145px;left:387px;\" onclick=\"showElevenPopOne()\" src=\"/issue3/static/_content/11-img-1.png\"/>\n        <div id=\"11-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"abs halfScale 11-pop-1\" style=\"top:28px;left:149px;\" src=\"/issue3/static/_content/11-pop-1.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:41px;left:1170px;width:41px;height:39px;\" onclick=\"hideOverlay('11-pop-1')\"></div>\n        </div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function showElevenPopOne() {\n          showOverlay('11-pop-1')\n        }\n        \n        function closeElevenPopOne() {\n          hideOverlay('11-pop-1')\n        }\n\n        function onPageLeave() {\n          pg11Anim.stop();\n          closeElevenPopOne();\n          removeContentLinks();\n        }\n      ",
    "searchText": "the loop “There's noise in the system, so to  the most circular beverage packaging  France: more collaboration needed  speak, because another tranche of  format and 84% believe they are the  French beverage can association  schemes is coming on stream. I strongly  easiest packaging format to recycle.  La Boîte Boisson reports that while 60,000 tonnes of cans enter the market  suspect – in fact I have already seen preliminary reports from some countries  There is something of a north-south  each year, a significant number are not  for 2023 – that we will see corresponding  divide in Europe when it comes to DRS;  yet being recycled.  increases in recycling rates.”  northern European countries tend to  Poland is next in line, with plans for a  ty  inabili sta  phased implementation from October 2025. It will become the 18th European  Su  country to adopt DRS.  Section 1  UK-wide DRS from October 2027 Europe's largest aluminium beverage can market, the United Kingdom (UK), has long been conspicuous in its absence from the list of countries with DRS. But this is set to change, with a UK-wide scheme that covers England, Scotland, Northern Ireland – and now Wales – scheduled to come on stream in October 2027. Whether the UK government sticks with this timetable remains to be seen, particularly as retailers have expressed concerns via the British Retail Consortium that this is too soon, given the work and cost involved. Even if there is some resistance to DRS in the UK market, if the recent Can Makers survey is anything to go  11 23  by, consumers will be on board; the survey revealed that more than 65% of consumers believe that cans are  Click to see the latest European recycling results  be more willing to adopt these schemes  'It's not an acceptable situation,'  with well-established systems than  says Lucien Debever, managing director  southern countries. This correlates with  of La Boîte Boisson. He says the heart  lower recycling rates in France, Spain  of the problem is the discord between  and Portugal.  the various stakeholders."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 11,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg12.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n        \n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 12-img-1\" style=\"top:509px;left:307px;\" onclick=\"Publish.goToPage(23);\" src=\"/issue3/static/_content/12-img-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "the loop Incoming recyclability grading system  generally strictly opposed to DRS; wanting  The regulation also includes the  instead to focus on a strategy that involves  development of a recyclability grading  collection via the yellow bin and sorting  system for packaging materials.  inabili sta  Su  Section 1  Standardization CEN, work is ongoing  together rather than against one another,  with the aim of developing a standard  La Boîte Boisson has drawn up a charter  that will be handed over to the European  to accelerate improvements in recycling  Commission at the end of this year. The  rates. Signatories include stakeholders on  Joint Research Centre will then turn this  both sides of the debate and the headline  into a legislative format,” says Doran.  objective is to achieve a recycling rate of  “When this standard is combined with the  90% for cans by 2030.  PPWR, we will effectively have a system that eventually restricts access to market  “The first step is to obtain more data from  for the poorest-performing materials.”  the recycling collectives to understand why more cans are not being recovered.  “The beverage can, which is infinitely and  Another key objective is to develop out-of-  inherently recyclable, has nothing to fear.”  home collection,” notes Debever. Ultimately, given that DRS schemes have to be in place by 1 January 2029 to satisfy the EU Packaging and Packaging Waste Regulation (PPWR), unless separate collection targets are met, it is a matter of when, not if, for markets like France.  12 23  Click to read more on PPWR later in the magazine  Y  ty  Recognising the importance of working  100%  ULARIT  “Led by the European Committee for  RC  centres,” he explained.  CI  governments and recycling collectives are  “The local administrations, mayors,  2030"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 12,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg13.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div>\n\n      <img class=\"abs halfScale 13-title\" style=\"top:96px;left:167px;\" src=\"/issue3/static/_content/13-title-1.png\"/>\n      <img class=\"abs halfScale 13-sub\" style=\"top:184px;left:169px;\" src=\"/issue3/static/_content/13-sub-1.png\"/>\n\n      <div class=\"addContentLink\" style=\"top:237px;left:1020px;width:138px;height:61px\">\n        <a href=\"https://everycancounts.eu/\" target=\"_blank\"></a>\n      </div>\n      <div class=\"addContentLink\" style=\"top:265px;left:989px;width:200px;height:209px\">\n        <a href=\"https://everycancounts.eu/\" target=\"_blank\"></a>\n      </div>\n\n      <img class=\"halfScaleC animatedpulse halfpulsetwo pointer\" style=\"top:481px;left:653px;\" onclick=\"showThirteenPopOne();popLinks()\" src=\"/issue3/static/_content/13-can.png\"/>\n      <div id=\"13-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 13-pop-1\" style=\"top:234px;left:166px;\" src=\"/issue3/static/_content/13-pop-1.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:786px;left:194px;width:41px;height:39px;\" onclick=\"closeThirteenPopOne()\"></div>\n      </div>\n\n      <img class=\"halfScaleC animatedpulse halfpulsetwo pointer\" style=\"top:507px;left:790px;\" onclick=\"showThirteenPopTwo();popLinks()\" src=\"/issue3/static/_content/13-can.png\"/>\n      <div id=\"13-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 13-pop-2\" style=\"top:234px;left:166px;\" src=\"/issue3/static/_content/13-pop-2.png\"/>\n        <div class=\"addContentLink\" style=\"top:553px;left:188px;width:90px;height:30px\">\n          <a href=\"https://everycancounts.eu/kazda-plechovka-se-pocita-and-coca-cola-renew-partnership-for-live-nation-concerts-2025/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:786px;left:194px;width:41px;height:39px;\" onclick=\"closeThirteenPopTwo()\"></div>\n      </div>\n\n      <img class=\"halfScaleC animatedpulse halfpulsetwo pointer\" style=\"top:565px;left:610px;\" onclick=\"showThirteenPopThree();popLinks()\" src=\"/issue3/static/_content/13-can.png\"/>\n      <div id=\"13-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 13-pop-3\" style=\"top:234px;left:166px;\" src=\"/issue3/static/_content/13-pop-3.png\"/>\n        <div class=\"addContentLink\" style=\"top:575px;left:188px;width:90px;height:30px\">\n          <a href=\"https://everycancounts.eu/chaque-canette-compte-at-techfest/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:786px;left:194px;width:41px;height:39px;\" onclick=\"closeThirteenPopThree()\"></div>\n      </div>\n\n      <img class=\"halfScaleC animatedpulse halfpulsetwo pointer\" style=\"top:688px;left:921px;\" onclick=\"showThirteenPopFour();popLinks()\" src=\"/issue3/static/_content/13-can.png\"/>\n      <div id=\"13-pop-4\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 13-pop-4\" style=\"top:234px;left:166px;\" src=\"/issue3/static/_content/13-pop-4.png\"/>\n        <div class=\"addContentLink\" style=\"top:575px;left:188px;width:90px;height:30px\">\n          <a href=\"https://everycancounts.eu/kathe-kouti-metrai-at-helmos-mountain-festival-vol-3-100kg-of-aluminium-recycled-in-the-mountains-of-greece/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:786px;left:194px;width:41px;height:39px;\" onclick=\"closeThirteenPopFour()\"></div>\n      </div>\n\n      <img class=\"halfScaleC animatedpulse halfpulsetwo pointer\" style=\"top:436px;left:496px;\" onclick=\"showThirteenPopFive();popLinks()\" src=\"/issue3/static/_content/13-can.png\"/>\n      <div id=\"13-pop-5\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 13-pop-5\" style=\"top:234px;left:166px;\" src=\"/issue3/static/_content/13-pop-5.png\"/>\n        <div class=\"addContentLink\" style=\"top:598px;left:188px;width:90px;height:30px\">\n          <a href=\"https://everycancounts.eu/every-can-counts-at-dublin-pride-celebrating-recycling-colour-and-community/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:786px;left:194px;width:41px;height:39px;\" onclick=\"closeThirteenPopFive()\"></div>\n      </div>\n\n      <img class=\"halfScaleC animatedpulse halfpulsetwo pointer\" style=\"top:625px;left:749px;\" onclick=\"showThirteenPopSix();popLinks()\" src=\"/issue3/static/_content/13-can.png\"/>\n      <div id=\"13-pop-6\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 13-pop-6\" style=\"top:234px;left:166px;\" src=\"/issue3/static/_content/13-pop-6.png\"/>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:786px;left:194px;width:41px;height:39px;\" onclick=\"closeThirteenPopSix()\"></div>\n      </div>\n      \n      <img class=\"halfScaleC animatedpulse halfpulsetwo pointer\" style=\"top:623px;left:857px;\" onclick=\"showThirteenPopSeven();popLinks()\" src=\"/issue3/static/_content/13-can.png\"/>\n      <div id=\"13-pop-7\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 13-pop-7\" style=\"top:234px;left:166px;\" src=\"/issue3/static/_content/13-pop-7.png\"/>\n        <div class=\"addContentLink\" style=\"top:618px;left:188px;width:90px;height:30px\">\n          <a href=\"https://everycancounts.eu/svaka-limenka-se-racuna-solagro-smart-flex-return-system-wins-innovation-of-the-year-at-esg-adria-summit/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:786px;left:194px;width:41px;height:39px;\" onclick=\"closeThirteenPopSeven()\"></div>\n      </div>\n\n      <img class=\"halfScaleC animatedpulse halfpulsetwo pointer\" style=\"top:459px;left:842px;\" onclick=\"showThirteenPopEight();popLinks()\" src=\"/issue3/static/_content/13-can.png\"/>\n      <div id=\"13-pop-8\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 13-pop-8\" style=\"top:234px;left:166px;\" src=\"/issue3/static/_content/13-pop-8.png\"/>\n        <div class=\"addContentLink\" style=\"top:574px;left:188px;width:90px;height:30px\">\n          <a href=\"https://everycancounts.eu/kazda-puszka-cenna-zabka-promoting-recycling-in-the-heart-of-wroclaw/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:786px;left:194px;width:41px;height:39px;\" onclick=\"closeThirteenPopEight()\"></div>\n      </div>\n     \n      <img class=\"halfScaleC animatedpulse halfpulsetwo pointer\" style=\"top:563px;left:934px;\" onclick=\"showThirteenPopNine();popLinks()\" src=\"/issue3/static/_content/13-can.png\"/>\n      <div id=\"13-pop-9\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 13-pop-9\" style=\"top:234px;left:166px;\" src=\"/issue3/static/_content/13-pop-9.png\"/>\n        <div class=\"addContentLink\" style=\"top:576px;left:188px;width:90px;height:30px\">\n          <a href=\"https://everycancounts.eu/every-can-counts-romania-drives-national-recycling-conversation/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:786px;left:194px;width:41px;height:39px;\" onclick=\"closeThirteenPopNine()\"></div>\n      </div>\n\n      <img class=\"halfScaleC animatedpulse halfpulsetwo pointer\" style=\"top:601px;left:888px;\" onclick=\"showThirteenPopTen();popLinks()\" src=\"/issue3/static/_content/13-can.png\"/>\n      <div id=\"13-pop-10\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 13-pop-10\" style=\"top:234px;left:166px;\" src=\"/issue3/static/_content/13-pop-10.png\"/>\n        <div class=\"addContentLink\" style=\"top:508px;left:188px;width:90px;height:30px\">\n          <a href=\"https://everycancounts.eu/arsenal-fest-2025-in-numbers-more-than-35000-visitors-attended-and-10-000-drink-cans-collected/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:786px;left:194px;width:41px;height:39px;\" onclick=\"closeThirteenPopTen()\"></div>\n      </div>\n\n      <img class=\"halfScaleC animatedpulse halfpulsetwo pointer\" style=\"top:660px;left:492px;\" onclick=\"showThirteenPopEleven();popLinks()\" src=\"/issue3/static/_content/13-can.png\"/>\n      <div id=\"13-pop-11\" class=\"standardTransition contentOverlay hidden noclick\">\n        <img class=\"abs halfScale 13-pop-11\" style=\"top:234px;left:166px;\" src=\"/issue3/static/_content/13-pop-11.png\"/>\n        <div class=\"addContentLink\" style=\"top:710px;left:188px;width:90px;height:30px\">\n          <a href=\"https://everycancounts.eu/cada-lata-cuenta-collaborates-once-more-with-womad-caceres-to-promote-recycling-during-the-festival/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"abs contentLinkNone pointer\" style=\"top:786px;left:194px;width:41px;height:39px;\" onclick=\"closeThirteenPopEleven()\"></div>\n      </div>\n\n      \n      ",
    "script": "\n      function onPageEnter() {\n        pg13Anim = new TimelineMax();\n           setTimeout(function(){\n            addContentLinks();\n          },1000)\n\n        pg13Anim.staggerFromTo(cOf(\"13-title\"), 0.8, {opacity:0, x:70}, {opacity:1, x:0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.2, 1)\n      }\n      function popLinks() {\n              setTimeout(function(){\n                addContentLinks()\n              },1000)\n      }\n      function showThirteenPopOne() {\n        showOverlay('13-pop-1')\n        setTimeout(function(){\n          addContentLinks()\n        },1000)\n      }\n      \n      function closeThirteenPopOne() {\n        hideOverlay('13-pop-1')\n      }\n\n      function showThirteenPopTwo() {\n        showOverlay('13-pop-2')\n        setTimeout(function(){\n          addContentLinks()\n        },1000)\n      }\n      \n      function closeThirteenPopTwo() {\n        hideOverlay('13-pop-2')\n      }\n\n      function showThirteenPopThree() {\n        showOverlay('13-pop-3')\n        setTimeout(function(){\n          addContentLinks()\n        },1000)\n      }\n      \n      function closeThirteenPopThree() {\n        hideOverlay('13-pop-3')\n      }\n\n      function showThirteenPopFour() {\n         showOverlay('13-pop-4')\n         setTimeout(function(){\n          addContentLinks()\n        },1000)\n      }\n      \n      function closeThirteenPopFour() {\n        hideOverlay('13-pop-4')\n      }\n\n      function showThirteenPopFive() {\n        showOverlay('13-pop-5')\n        setTimeout(function(){\n          addContentLinks()\n        },1000)\n      }\n      \n      function closeThirteenPopFive() {\n        hideOverlay('13-pop-5')\n      }\n\n      function showThirteenPopSix() {\n        showOverlay('13-pop-6')\n        setTimeout(function(){\n          addContentLinks()\n        },1000)\n      }\n      \n      function closeThirteenPopSix() {\n        hideOverlay('13-pop-6')\n      }\n\n      function showThirteenPopSeven() {\n        showOverlay('13-pop-7')\n        setTimeout(function(){\n          addContentLinks()\n        },1000)\n      }\n      \n      function closeThirteenPopSeven() {\n        hideOverlay('13-pop-7')\n      }\n\n      function showThirteenPopEight() {\n        showOverlay('13-pop-8')\n        setTimeout(function(){\n          addContentLinks()\n        },1000)\n      }\n      \n      function closeThirteenPopEight() {\n        hideOverlay('13-pop-8')\n      }\n\n      function showThirteenPopNine() {\n        showOverlay('13-pop-9')\n        setTimeout(function(){\n          addContentLinks()\n        },1000)\n      }\n      \n      function closeThirteenPopNine() {\n        hideOverlay('13-pop-9')\n      }\n\n      function showThirteenPopTen() {\n        showOverlay('13-pop-10')\n        setTimeout(function(){\n          addContentLinks()\n        },1000)\n      }\n      \n      function closeThirteenPopTen() {\n        hideOverlay('13-pop-10')\n      }\n\n      function showThirteenPopEleven() {\n        showOverlay('13-pop-11')\n        setTimeout(function(){\n          addContentLinks()\n        },1000)\n      }\n      \n      function closeThirteenPopEleven() {\n        hideOverlay('13-pop-11')\n      }\n\n      function onPageLeave() {\n        pg13Anim.stop()\n        removeContentLinks();\n        closeThirteenPopOne();\n        closeThirteenPopTwo();\n        closeThirteenPopThree();\n        closeThirteenPopFour();\n        closeThirteenPopFive();\n        closeThirteenPopSix();\n        closeThirteenPopSeven();\n        closeThirteenPopEight();\n        closeThirteenPopNine();\n        closeThirteenPopTen();\n        closeThirteenPopEleven();\n      }\n    \n      \n    \n      ",
    "searchText": "the loop  A CAN-TASTIC SUMMER IN A LANDMARK YEAR FOR EVERY CAN COUNTS  Su  largest aluminium can sheet suppliers.  Section 1  The ECC mission is to inspire, encourage and empower people to recycle their drink cans – wherever they are. 2025 saw ECC celebrating its 15th anniversary in Prague, gathering team members from 21 countries to celebrate a decade and a half of recycling action. Its impact is felt across Europe and beyond, as ECC now also operates in the United Arab Emirates, Brazil and the United States of America. Explore the map below to see examples of how ECC volunteers harnessed their creativity to promote recycling over summer 2025.  13 28  Click the can to read about each country  5t  inabili sta  beverage can manufacturers and the four  sa  1  programme funded by the four largest  h a n n iv e r  not-for-profit behaviour change  r y i n P ra g u e  E  ty  very Can Counts (ECC) is a  If you feel inspired to contribute to ECC's vital recycling awareness programme, please visit everycancounts.eu and click ‘Get involved'!"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 13,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg14.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n        <img class=\"abs halfScale 14-title\" style=\"top:569px;left:144px;\" src=\"/issue3/static/_content/14-title-1.png\"/>\n        <img class=\"abs halfScale 14-title\" style=\"top:693px;left:236px;\" src=\"/issue3/static/_content/14-title-2.png\"/>\n        <img class=\"abs halfScale 14-title\" style=\"top:825px;left:236px;\" src=\"/issue3/static/_content/14-title-3.png\"/>\n        <img class=\"abs halfScale 14-sub\" style=\"top:515px;left:149px;\" src=\"/issue3/static/_content/14-sub-1.png\"/>\n        <img class=\"abs halfScale 14-sub\" style=\"top:325px;left:1004px;\" src=\"/issue3/static/_content/14-sub-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg14Anim = new TimelineMax();\n          pg14Anim.staggerFromTo(cOf(\"14-title\"), 1.2, {opacity:0, x: 70}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"14-sub\"), 1.2, {opacity:0, x: 30}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.2, 1.5)\n        }\n\n        function onPageLeave() {\n          pg14Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ovation nn  the loop  Cans have long been the go-to packaging for caffeinated drinks on the move – think iconic energy drink brands like Red Bull and Monster. Now, they're carrying a different kind of buzz across Europe: coffee.  Section 2  I  Written by Megan Lloyd  14 23  COOL BEANS THE RISE OF CANNED COFFEE  E  urope's ready-to-drink (RTD) coffee culture is growing fast. According to Renub Research,  the market is projected to reach US$4.59 billion by 2033. Cold coffee – the dominant RTD format – is expected to grow by 22.7% between 2024 and 2032, according to Fortune Business Insights."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 14,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg15.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n        <img class=\"abs halfScale 15-bar\" style=\"top:670px;left:467px;\" src=\"/issue3/static/_content/15-bar-1.png\"/>\n        <img class=\"abs halfScale 15-bar\" style=\"top:630px;left:528px;\" src=\"/issue3/static/_content/15-bar-2.png\"/>\n\n        <img class=\"abs halfScaleC 15-num\" style=\"top:825px;left:464px;\" src=\"/issue3/static/_content/15-num-1.png\"/>\n        <img class=\"abs halfScaleC 15-num\" style=\"top:825px;left:524px;\" src=\"/issue3/static/_content/15-num-2.png\"/>\n\n        <img class=\"abs halfScaleC 15-can\" style=\"top:521px;left:439px;\" src=\"/issue3/static/_content/15-can-1.png\"/>\n        <img class=\"abs halfScaleC 15-can\" style=\"top:481px;left:499px;\" src=\"/issue3/static/_content/15-can-2.png\"/>\n\n        <img class=\"abs halfScaleC 15-line\" style=\"top:391px;left:559px;\" src=\"/issue3/static/_content/15-line-1.png\"/>\n\n        <h1 id=\"15-no\" class=\"abs sommet 15-no\" style=\"top:450px;left:448px; font-size: 3.2em; font-weight: 300; color: #ffffff; padding: 0px; margin: 0px;\"  data-number='{\"to\": 22.7, \"decimals\":1 }' ></h1>\n\n        <img class=\"abs halfScale 15-text\" style=\"top:419px;left:453px;\" src=\"/issue3/static/_content/15-text-1.png\"/>\n        <img class=\"abs halfScale 15-text\" style=\"top:509px;left:453px;\" src=\"/issue3/static/_content/15-text-2.png\"/>\n        <img class=\"abs halfScale 15-text\" style=\"top:472px;left:554px;\" src=\"/issue3/static/_content/15-percentage-1.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg15Anim = new TimelineMax();\n          pg15Anim.staggerFromTo(cOf(\"15-bar\"), 0.5, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"15-num\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.1)\n          .staggerFromTo(cOf(\"15-can\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 0.2, 1.3)\n          .fromTo(cOf(\"15-line\"), 0.5, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.4)\n          .fromTo(cOf(\"15-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"15-no\")[0])}}, 1.5)\n          .staggerFromTo(cOf(\"15-text\"), 0.5, {opacity:0, x: 10}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.2, 1.6)\n        }\n\n        function onPageLeave() {\n          pg15Anim.stop();\n          removeContentLinks();\n          resetNumbers(\"15-no\");\n        }\n      ",
    "searchText": "the loop Taking cues from Japanese brands that have sold canned coffee since the 1960s, small and large European producers are now turning to the can to deliver both quality and convenience.  The canned coffee contenders The rise of canned coffee isn't ovation nn  concentrated only in Europe's warmer regions. The UK reported the highest cold coffee sales in Europe in 2024,  I  according to Innova Market Insights, with brands canning black coffee, iced lattes,  Section 2  cold brew – and the occasional espresso martini. Germany, Benelux and Hungary are also pushing the envelope. Brands of all sizes are getting involved. Nescafé leads cold coffee launches in Europe; Nestlé bought out Starbuck's  Cold coffee is expected to grow by  22.7% between 2024 and 2032  Small speciality brands are taking off  brew market is speeding ahead at  coffees through the sector. Global  too, appealing to consumers looking for  about 23%. Hard Beans developed its  Italy-based brand Illy also launched  artisanal products, especially cold brew  own rapid cold brew technology using  a line of cold brew canned black and  – the fastest growing segment of RTD  its custom-built, cutting-edge Hardtank  milky coffees, helping the company  coffee. According to Fortune Business  machine – and in 2022, it launched a  strengthen its position in the RTD  Insights, the cold brew market is expected  production facility for private label brands  market. Hungarian challenger brand  to reach $16.2 billion by 2032. Customers  looking to create their own canned cold  Hell Ice Coffee launched in cans in 2019  are drawn to cold brew's smooth taste,  brew. While Poland is slower to adopt  and its range is now available in over  lower acidity and super-strong caffeine  canned coffee, he notes tremendous  30 countries worldwide. In the United  kick, all born from its long brewing time  growth in the rest of Europe: “Our  Kingdom, established soft drinks company  in cold water.  presence is quite broad across the  retail brand and is pushing RTD canned  continent.” Most of their clients are  Britvic, part of the Carlsberg Group,  15 23  acquired RTD chilled coffee challenger  Maciej Duszak, co-founder and head  speciality European roasters looking  brand Jimmy's – which sells its coffee  of sales at Hard Beans in Poland, notes  to expand their portfolio, as well as  that while the global coffee market  entrepreneurs launching canned  grows at about 5.5% every year, the cold  cold brew businesses.  in traditional cans and an innovative resealable aluminium BottleCan™.  2024  2032"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 15,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg16.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n        setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n         removeContentLinks();\n        }\n      ",
    "searchText": "the loop Germany, Italy, Spain and Benelux  that feels like a treat. “Ten years ago,  are some of the countries noting big  if you wanted to drink canned coffee,  increases in demands for cold brew and  you could probably find one, but it was  canned coffee, each in varying stages. In  likely to be powdered milk and instant  Spain for example, “the trend is practically  coffee,” says Duszak. “Now you can have  just getting started, but we're seeing that  a quality product available on the go.”  in 2025 and 2026 things will really catch coffee. East Crema currently operates  Health-conscious coffee consumers  17 speciality coffee shops around Spain  European consumers are increasingly  and released its own canned cold brew  seeking beverages that cater to their well-  in May this year.  being; they want an energy boost that  ovation nn  on,” says Alberto Velarde of East Crema  I  Section 2  won't compromise their health. Mordor  Customised caffeine on the go  Intelligence cites that “the emergence of  Gen Z and millennials in urban areas  RTD decaf coffee, RTD dairy-free coffee  are driving demand for premium coffee  and RTD flavoured coffee is reshaping  products. According to the Global Coffee  consumer preferences in the region,  Report, many of Gen Z seek unique,  with these beverages now being enjoyed  personalised flavours in their functional  throughout the day and increasingly  caffeine beverages. Cold coffee profiles  competing with traditional choices like  are well suited to these customised  tea, alcohol and sodas.”  experiences, incorporating elements like caramel flavouring, non-dairy milks or  “We've seen an interest from professionals  nitro infusions, which refers to imbuing  who want a premium coffee experience  cold brew coffee with nitrogen gas under pressure to create a silky, velvety texture.  vehicle for caffeine? RTD cold coffee  without the commitment of a café visit,”  can because it's  brands often boast healthier coffee  says Vera Ortmanns, Manager of Beverage  very sustainable,  options like lower sugar or plant-based  Can Benelux. She also notes that in the  it stores well and  milks, as well as functional ingredients.  The demand for convenience is also  rise of hybrid work models, RTD coffee  it's aesthetically  Of course, the can format provides a  driving the canned coffee market forward.  creates a convenient bridge between  practical”  broad canvas for decoration, which  Renub Research notes hectic work  home and office. East Crema, for example,  schedules and fast-paced lifestyles are  sells its cans on Glovo, a delivery service in  giving way to a rising demand for portable  Spain similar to Uber Eats.  beverages that give you a boost – just like  16 23  What makes cold coffee a healthier “We chose the  brands are using to highlight coffee's  Alberto Velarde East Crema  natural antioxidants and other health credentials like sugar-free or naturally sweetened options.  RTD coffee. Consumers want convenient  While RTD coffee was once seen as simply  and portable options for busy days, and  a matter of convenience, speciality brands  Renub Research notes that German  the can fits the bill.  are reframing it as a premium product  consumers in particular are seeking"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 16,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg17.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n         removeContentLinks();\n        }\n      ",
    "searchText": "the loop low-sugar coffee beverages with functional  cool contents and provide superior  aesthetically practical,” says Velarde.  benefits like added protein and vitamins.  protection against light, making them  For speciality coffee producers, the  In Benelux, functional coffee beverages,  ideal for preserving coffee beverage  can is essential according to Duszak:  according to Ortmanns, “especially those  quality.” It's easier and cheaper to ship  “It's the only packaging that allows  that are low in sugar, organic or enriched  than glass and improves shelf life and  you to use liquid nitrogen,” a popular  with vitamins” are entering a dynamic  storage for both brands and retailers.  ingredient used to create creaminess  growth phase.  in cold brew. “We chose the can because it's very “Canned coffee  Beyond the café  drinks open the  Velarde doesn't see the can as  planet-conscious. Sustainability is no  door to wider  a competitor to the European  longer optional for beverage brands but  distribution and  coffeehouse experience, but rather  a major differentiator, making the can the  brand recognition  a complement. “It's a supplementary  ideal method for packaging RTD coffee  in new retail and  product to offer to our customers,” he  and marketing to conscious consumers.  event spaces, from  says. While speciality stores are the  grocery stores to  fastest-growing distribution channel  hotel minibars.”  in the European RTD coffee market,  ovation nn  Consumers are not just health-conscious in their drinking choices, they're also  I  Section 2  The case for the can  sustainable, it stores well and it's  For manufacturers and brands, the can is a no-brainer. Mordor Intelligence concludes that “canned coffee is particularly valued for its ability to rapidly  the can also gives brands access to  Amber Gibson Fresh Cup Magazine  another set of consumers in the retail space. As journalist Amber Gibson writes in the coffee industry's Fresh Cup Magazine, “canned coffee drinks open the door to wider distribution and brand recognition in new retail and event spaces, from grocery stores to hotel minibars.” East Crema, for example, also distributes at speciality grocery stores and high-end department stores around Spain. There's much more to come for canned coffee. “The market is still open for disruption,” says  17 23  Ortmanns. “It's an exciting space with room for both established names and agile newcomers.”"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 17,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg18.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n        <img class=\"abs halfScale 18-title\" style=\"top:205px;left:703px;\" src=\"/issue3/static/_content/18-title-1.png\"/>\n        <img class=\"abs halfScale 18-title\" style=\"top:330px;left:703px;\" src=\"/issue3/static/_content/18-title-2.png\"/>\n        <img class=\"abs halfScale 18-sub\" style=\"top:464px;left:708px;\" src=\"/issue3/static/_content/18-sub-1.png\"/>\n        <img class=\"abs halfScale 18-sub\" style=\"top:566px;left:710px;\" src=\"/issue3/static/_content/18-sub-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg18Anim = new TimelineMax();\n          pg18Anim.staggerFromTo(cOf(\"18-title\"), 1.2, {opacity:0, x: 70}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"18-sub\"), 1.2, {opacity:0, x: 70}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.2, 1.3)\n        }\n\n        function onPageLeave() {\n          pg18Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ovation nn  the loop  I  Section 2  ONLY CANS A CELEBRATION OF THE CAN, SCREENED LIVE Learnings from a standout live event with influencer collective Sorted Food  W  ith 2.9 million YouTube subscribers, leading YouTube influencers Sorted Food  have a phenomenal reach. Their upbeat videos focus  18 23  on recipes, food reviews and culinary challenges."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 18,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg19.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n        \n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 19-img-1\" style=\"top:554px;left:984px;\" onclick=\"showNineteenPopOne()\" src=\"/issue3/static/_content/19-img-1.png\"/>\n        <div id=\"19-pop-1\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"abs halfScale 19-pop-1\" style=\"top:88px;left:998px;\" src=\"/issue3/static/_content/19-pop-1.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:101px;left:1125px;width:41px;height:39px;\" onclick=\"hideOverlay('19-pop-1')\"></div>\n        </div>\n\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 19-img-2\" style=\"top:680px;left:963px;\" onclick=\"showNineteenPopTwo()\" src=\"/issue3/static/_content/19-img-2.png\"/>\n        <div id=\"19-pop-2\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"abs halfScale 19-pop-2\" style=\"top:318px;left:998px;\" src=\"/issue3/static/_content/19-pop-2.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:328px;left:1125px;width:41px;height:39px;\" onclick=\"hideOverlay('19-pop-2')\"></div>\n        </div>\n\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 19-img-3\" style=\"top:453px;left:763px;\" onclick=\"showNineteenPopThree()\" src=\"/issue3/static/_content/19-img-3.png\"/>\n        <div id=\"19-pop-3\" class=\"standardTransition contentOverlay hidden noclick\">\n          <img class=\"abs halfScale 19-pop-3\" style=\"top:-24px;left:117px;\" src=\"/issue3/static/_content/19-pop-3.png\"/>\n          <div class=\"abs contentLinkNone pointer\" style=\"top:158px;left:1151px;width:41px;height:39px;\" onclick=\"hideOverlay('19-pop-3')\"></div>\n        </div>\n\n        <img class=\"abs halfScaleC animatedpulse halfpulsetwo pointer 19-img-4\" style=\"top:797px;left:46px;\" onclick=\"Publish.updateVideoURL('https://www.youtube.com/embed/c8-FL9Eb47I?si=rXisV8SI4KYh6WvY')\" src=\"/issue3/static/_content/19-img-4.png\"/>\n\n        <img class=\"abs halfScale 19-title\" style=\"top:405px;left:464px;\" src=\"/issue3/static/_content/19-title-1.png\"/>\n\n        <img class=\"abs halfScaleC 19-icon-1\" style=\"top:408px;left:434px;\" src=\"/issue3/static/_content/19-icon-1.png\"/>\n        <img class=\"abs halfScale 19-text\" style=\"top:489px;left:544px;\" src=\"/issue3/static/_content/19-text-1.png\"/>\n\n        <img class=\"abs halfScaleC 19-icon-2\" style=\"top:665px;left:440px;\" src=\"/issue3/static/_content/19-icon-2.png\"/>\n        <img class=\"abs halfScale 19-text\" style=\"top:581px;left:464px;\" src=\"/issue3/static/_content/19-text-2.png\"/>\n\n        <img class=\"abs halfScale 19-text\" style=\"top:672px;left:465px;\" src=\"/issue3/static/_content/19-text-3.png\"/>\n        <img class=\"abs halfScaleC 19-icon-3\" style=\"top:730px;left:445px;\" src=\"/issue3/static/_content/19-icon-3.png\"/>\n        <img class=\"abs halfScale 19-text\" style=\"top:701px;left:542px;\" src=\"/issue3/static/_content/19-text-4.png\"/>\n\n        <img class=\"abs halfScale 19-text\" style=\"top:818px;left:529px;\" src=\"/issue3/static/_content/19-text-5.png\"/>\n\n        <h1 id=\"19-no\" class=\"abs sommet 19-no\" style=\"top:430px;left:540px; font-size: 3.1em; font-weight: 300; color: #ef375d; padding: 0px; margin: 0px;\"  data-number='{\"to\": 10000, \"comma\":\"true\"}' ></h1>\n        <h1 id=\"19-no\" class=\"abs sommet 19-no\" style=\"top:522px;left:459px; font-size: 3.1em; font-weight: 300; color: #ef375d; padding: 0px; margin: 0px;\"  data-number='{\"to\": 74000, \"comma\":\"true\"}' ></h1>\n        <h1 id=\"19-no\" class=\"abs sommet 19-no\" style=\"top:614px;left:463px; font-size: 3.1em; font-weight: 300; color: #ef375d; padding: 0px; margin: 0px;\"  data-number='{\"to\": 1852, \"comma\":\"true\"}' ></h1>\n        <h1 id=\"19-no\" class=\"abs sommet 19-no\" style=\"top:758px;left:528px; font-size: 3.1em; font-weight: 300; color: #ef375d; padding: 0px; margin: 0px;\"  data-number='{\"to\": 14000, \"comma\":\"true\"}' ></h1>\n      ",
    "script": "\n        function onPageEnter() {\n          pg19Anim = new TimelineMax();\n          pg19Anim.fromTo(cOf(\"19-title\"), 1.2, {opacity:0, x: 20}, {opacity: 1, x: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"19-icon-1\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.2)\n          .staggerFromTo(cOf(\"19-text\"), 1.2, {opacity:0, x: 10}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1.4)\n          .fromTo(cOf(\"19-icon-2\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1.7)\n          .fromTo(cOf(\"19-icon-3\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 2.2)\n          .fromTo(cOf(\"19-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[0])}}, 1.1)\n          .fromTo(cOf(\"19-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[1])}}, 1.4)\n          .fromTo(cOf(\"19-no\")[2], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[2])}}, 1.7)\n          .fromTo(cOf(\"19-no\")[3], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"19-no\")[3])}}, 2.1)\n          setTimeout(function(){\n            addContentLinks();\n          },3000)\n        }\n\n        function showNineteenPopOne() {\n          showOverlay('19-pop-1')\n        }\n        \n        function closeNineteenPopOne() {\n          hideOverlay('19-pop-1')\n        }\n\n        function showNineteenPopTwo() {\n          showOverlay('19-pop-2')\n        }\n        \n        function closeNineteenPopTwo() {\n          hideOverlay('19-pop-2')\n        }\n\n        function showNineteenPopThree() {\n          showOverlay('19-pop-3')\n        }\n        \n        function closeNineteenPopThree() {\n          hideOverlay('19-pop-3')\n        }\n\n        function onPageLeave() {\n          pg19Anim.stop();\n          closeNineteenPopOne();\n          closeNineteenPopTwo();\n          closeNineteenPopThree();\n          removeContentLinks();\n          resetNumbers(\"19-no\");\n        }\n      ",
    "searchText": "the loop In June this year, Sorted Food partnered with the Can Makers Association for Only Cans, a live cooking show at Media City in Manchester, United Kingdom. Staged in a converted aluminium can-shaped food truck emblazoned with recycling-related messages, the show was streamed on big screens across the plaza and broadcast ovation nn  live on YouTube. During the show, the Sorted Food  I  hosts prepared Mexican-inspired street food dishes including tacos, then each  Section 2  presented their favourite award-winning canned beverage so that viewers could vote for the best. Throughout the  THE EVENT IN NUMBERS  10,000  30-minute session, they successfully integrated the many benefits of the can format, with a particular focus on its sustainability, in an engaging way. The Can Makers Association also conducted vox pop interviews of passersby to assess  74,000  public perception and attitudes toward  views in the first 7 days  canned beverages and distributed goody  1,852  bags containing drink samples. Overall, Only Cans was a resounding success!  WHAT THEY SAID  live viewers on YouTube  Click below to get the inside scoop  comments  98% positive sentiment  19 23  Click here to watch the show recording  14,000 on-location views  KEY TAKEAWAYS Click here for actionable insights from the event  Tim Conybeare Chairman of The Can Makers  Ben Ebbrell Sorted Food co-founder and chef"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 19,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg20.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n        <img class=\"abs halfScale 20-title\" style=\"top:200px;left:159px;\" src=\"/issue3/static/_content/20-title-1.png\"/>\n        <img class=\"abs halfScale 20-title\" style=\"top:290px;left:152px;\" src=\"/issue3/static/_content/20-title-2.png\"/>\n        <img class=\"abs halfScale 20-title\" style=\"top:430px;left:154px;\" src=\"/issue3/static/_content/20-title-3.png\"/>\n        <img class=\"abs halfScale 20-sub\" style=\"top:584px;left:158px;\" src=\"/issue3/static/_content/20-sub-1.png\"/>\n        <img class=\"abs halfScale 20-sub\" style=\"top:246px;left:242px;\" src=\"/issue3/static/_content/20-sub-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg20Anim = new TimelineMax();\n          pg20Anim.staggerFromTo(cOf(\"20-title\"), 1.2, {opacity:0, x: 70}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"20-sub\"), 1.2, {opacity:0, x: 70}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.2, 1.6)\n        }\n\n        function onPageLeave() {\n          pg20Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "the loop  Section 3  ustry Ind  A  Written by Philip Chadwick  SINGLE GOAL HOW THE ALUMINIUM INDUSTRY IS COMING TOGETHER TO EXPLORE SINGLE ALLOY PRODUCTION.  20 28  Innovation in the can's end has the potential to unlock greater circularity and carbon reduction – our writer finds out how.  O  n the face of it, the  aluminium beverage can is a design that can't be improved upon. Strong, solid, lightweight, infinitely recyclable and comfortably ticks off the primary principle of packaging: to protect the product."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 20,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg21.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n        <img class=\"abs halfScale 21-line-1\" style=\"top:707px;left:445px;\" src=\"/issue3/static/_content/21-line-1.png\"/>\n        <img class=\"abs halfScale 21-line-2\" style=\"top:846px;left:445px;\" src=\"/issue3/static/_content/21-line-1.png\"/>\n\n        <h1 id=\"21-no\" class=\"abs sommet 21-no\" style=\"top:718px;left:442px; font-size: 2.5em; font-weight: 300; color: #0d81dd; padding: 0px; margin: 0px;\"  data-number='{\"to\": 95}'></h1>\n        <img class=\"abs halfScale 21-text\" style=\"top:736px;left:493px;\" src=\"/issue3/static/_content/21-percentage-1.png\"/>\n\n        <img class=\"abs halfScale 21-text\" style=\"top:762px;left:445px;\" src=\"/issue3/static/_content/21-text-1.png\"/>\n        <img class=\"abs halfScale 21-text\" style=\"top:781px;left:445px;\" src=\"/issue3/static/_content/21-text-2.png\"/>\n        \n      ",
    "script": "\n        function onPageEnter() {\n          pg21Anim = new TimelineMax();\n          pg21Anim.fromTo(cOf(\"21-line-1\"), 1.2, {opacity:0, y: -20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"21-line-2\"), 1.2, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"21-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"21-no\")[0])}}, 1.1)\n          .staggerFromTo(cOf(\"21-text\"), 1.2, {opacity:0, x: 10}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.2, 1.1)\n        }\n\n        function onPageLeave() {\n          pg21Anim.stop();\n          removeContentLinks();\n          resetNumbers(\"21-no\");\n        }\n      ",
    "searchText": "the loop But, like all pack formats, technologists are  Bernard Slack, Technical and Regulatory  always looking to find marginal gains. And  Affairs Manager at the Metal Packaging  in the case of the beverage can, the end has  Manufacturers Association (MPMA)  become one area of focus. The can's body  explains: “Elementally, the can's alloys  and can end are made from two different  have different compositions – and that's  aluminium alloys.  where the issue arises. It's not practical to separate the two [body and can end]  The reason for this split is highly practical:  when it comes to recycling.”  ustry Ind  the can body needs to provide long-term protection for the drink, while the can end  The innovative project is expected to  has a very different task. It must withstand  further improve the can's circularity,  the intense pressure of carbonation during  reducing its carbon footprint and  filling and storage, and then perform  making the packaging format even and Speira are four leading flat-rolled  Section 3  flawlessly once – by opening safely and  aluminium manufacturers. Launched in  reliably when a consumer wants to drink. Engineering this finely balanced process  “One type of  2024, the aim is to engage other value  The EAPG added: “The use of recycled  requires significant precision and expertise.  alloy will make  chain partners directly involved in the  aluminium drastically reduces direct  The two alloys have different levels of  the recycling  process of canmaking, filling and closing.  carbon emissions and saves 95% of  recycled content, with the can body being  process easier and  much higher. While the combination of  more efficient”  alloys isn't a barrier to recyclability, there is room for improvement.  Tom Giddings Alupro  energy compared with primary aluminium In a statement, EAPG said: “Today, the  production. An alternative alloy with a  aluminium beverage can body and the can  high recycled content for the can end  end are made from two different aluminium  will enable canmakers to offer cans with  alloys. While the rolled aluminium for  strongly reduced carbon emissions. The  A collaborative project could transform  the can body already contains a high  ultimate aim is to develop an aluminium  the alloy and add a new layer of innovation  percentage of recycled aluminium and  beverage can which can be produced from  to the beverage can. If successful, a can  supports ultra-high recyclability, there is  up to 100% recycled aluminium and to  made from a single alloy could move the  additional sustainability potential related  deploy it on the market.”  dial on recyclability and carbon impact  to the can end.”  – an innovative way to bolster the pack's already strong sustainability credentials. The European Aluminium Packaging Group (EAPG) is leading the charge to create  21 28  more sustainable.  an end made from a single alloy. The multi-year project has some big names on board: Constellium, Elval, Novelis  95%  OF ENERGY SAVED using recycled aluminium compared with primary aluminium production  Efficient process  Bigger picture MPMA's Slack believes that the project  Exploring alternative alloys in can  helps shape a wider strategy for the  production would make a difference.  aluminium and metal industry. “It ties in  Alupro's chief executive Tom Giddings is  with the circular economy, which is all  enthusiastic about the project. “One type  about keeping resources in use. At the end  of alloy will make the recycling process  of a material's useful life, we don't dispose  easier and more efficient,” he says.  of it, instead we repurpose that material"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 21,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg22.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n         removeContentLinks();\n        }\n      ",
    "searchText": "the loop and keep that resource in play for as long  “This project is critical – without it we  focusing on recycled content, we must  as possible. The principle is that you keep  simply don't come anywhere near to  include circularity and collection.  the resource in use for as long as possible  getting a system change,” he adds. “It's  We're interested in the bigger picture.  so you're not having to get precious  essential that these manufacturers  Aluminium is classed as a permanent  materials out of the earth.”  [Constellium, Elval, Novelis and Speira]  material so you can keep recycling it  unite. This research and development  over and over again without loss of  “The prize is to keep the onward journey  challenge is one they can solve together,  performance. Aluminium is the perfect  of the metal continuing and the alloys  and we are watching with great interest.  fit for the circular economy. It's a  project could supercharge this,” adds ustry Ind  Alupro's Giddings.  Section 3  Not only that, but the project  valuable commodity.” “Aluminium  “It will achieve its goals in minimising  is classed as a  the carbon impact of the aluminium  The goal of a single alloy for beverage  can. Through collaboration, this project  cans will take time. But with industry  is showing clear leadership.”  ready to come together and tackle the  permanent material  also reinforces the push towards  so you can keep  decarbonisation in the aluminium  recycling it over and  issue, there's a solid chance that cans of  sector. Earlier this year, the Aluminium  over again without  Maarten Labberton, Director of  the future will enhance the aluminium  Stewardship Initiative (ASI) reported  loss of performance.  Recycling Aluminium Packaging  industry's strong circular track record.  that clear progress has been made  Aluminium is the  Netherlands and ex-Director of the  in the last five years.  perfect fit for the  EAPG, adds: “Collaboration and pooling  circular economy”  of expertise on this vital topic is  The organisation stated that in 2020, only 16 smelters were ASI PS certified, and just nine of them had set greenhouse  something that all company members  Tom Giddings Alupro  of the Packaging Group of European Aluminium are fully committed to, and  gas (GHG) targets. Since then, a further  that will help decarbonise our industry.  34 smelters have been certified. Of this  The project is a key driver towards full  group, less than 15% had GHG targets in  circularity and will make beverage cans  2020. This year, ASI reports that over 80%  an even more sustainable packaging  have GHG targets.  format. In addition, with the steady growth of Deposit Return Systems  22 28  Collaboration is the key  across Europe, we will be able to recycle  But success stories don't come  more cans via can-to-can remelting  through organisations working in  solutions, in line with the joint roadmap  silos. The key is collaboration. Alupro's  with the canmakers towards 100%  Giddings believes that the alloys project  beverage can recycling by 2030.”  represents industry doing what it does best: working together to find a  “The holistic approach is important,”  sustainable solution.  says MPMA's Slack. “Rather than just"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 22,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg23.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n        <img class=\"abs halfScale 23-title\" style=\"top:528px;left:154px;\" src=\"/issue3/static/_content/23-title-1.png\"/>\n        <img class=\"abs halfScale 23-title\" style=\"top:598px;left:152px;\" src=\"/issue3/static/_content/23-title-2.png\"/>\n        <img class=\"abs halfScale 23-title\" style=\"top:594px;left:255px;\" src=\"/issue3/static/_content/23-title-3.png\"/>\n        <img class=\"abs halfScale 23-sub\" style=\"top:752px;left:264px;\" src=\"/issue3/static/_content/23-sub-1.png\"/>\n        <img class=\"abs halfScale 23-sub\" style=\"top:491px;left:152px;\" src=\"/issue3/static/_content/23-sub-2.png\"/>\n      ",
    "script": "\n        function onPageEnter() {\n          pg23Anim = new TimelineMax();\n          pg23Anim.staggerFromTo(cOf(\"23-title\"), 1.2, {opacity:0, x: 70}, {opacity: 1, x: 0, ease: Power2.easeOut}, 0.2, 1)\n          .staggerFromTo(cOf(\"23-sub\"), 1.2, {opacity:0, x: 70}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.2, 1.6)\n        }\n\n        function onPageLeave() {\n          pg23Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "ustry Ind  the loop  Section 3  New packaging regulations have hit Europe, impacting recycling targets. Find out how PPWR aims to bolster the collection of beverage cans. Written by Philip Chadwick  RETURN TO  SENDER  23 28  REVIEWING THE IMPACT OF A YEAR OF LEGISLATIVE CHANGE FOR THE BEVERAGE CAN INDUSTRY  I  t's been a year of legislative change,  with the continent adjusting to a new and improved way of dealing with packaging. New targets, fresh timelines and rebooted ambitions have arrived, all thanks to the Packaging and Packaging Waste Regulation (PPWR)."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 23,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg24.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n\n        <h1 id=\"24-no\" class=\"abs sommet 24-no\" style=\"top:429px;left:792px; font-size:3.5em; font-weight: 300; color: #ffca00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 70}'></h1>\n        <img class=\"abs halfScale 24-text\" style=\"top:456px;left:861px;\" src=\"/issue3/static/_content/24-percentage-1.png\"/>\n        <img class=\"abs halfScale 24-text\" style=\"top:486px;left:784px;\" src=\"/issue3/static/_content/24-text-1.png\"/>\n\n        <h1 id=\"24-no\" class=\"abs sommet 24-no\" style=\"top:568px;left:789px; font-size:3.5em; font-weight: 300; color: #ffca00; padding: 0px; margin: 0px;\"  data-number='{\"to\": 80}'></h1>\n        <img class=\"abs halfScale 24-text\" style=\"top:596px;left:862px;\" src=\"/issue3/static/_content/24-percentage-1.png\"/>\n        <img class=\"abs halfScale 24-text\" style=\"top:626px;left:812px;\" src=\"/issue3/static/_content/24-text-2.png\"/>        \n      ",
    "script": "\n        function onPageEnter() {\n          pg24Anim = new TimelineMax();\n          pg24Anim.fromTo(cOf(\"24-no\")[0], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"24-no\")[0])}}, 1)\n          .staggerFromTo(cOf(\"24-text\"), 1.2, {opacity:0, x: 10}, {opacity: 1, x: 0, ease: Power2.easeOut, onComplete: addContentLinks}, 0.2, 1.1)\n          .fromTo(cOf(\"24-no\")[1], 0, {opacity:0}, {opacity:1, onComplete:function(){animateNumber(cOf(\"24-no\")[1])}}, 1.4)\n        }\n\n        function onPageLeave() {\n          pg24Anim.stop();\n          removeContentLinks();\n          resetNumbers(\"24-no\");\n        }\n      ",
    "searchText": "the loop The legislation came into force  A high bar  in February this year and has clear  There are a few key targets that stand  aims: to reduce packaging and packaging  out: By 1 January 2030, at least 70% by  waste; bolster the recyclability of packs;  weight of all packaging placed on the EU  and promote reusable and refillable  market must be recyclable, rising to 80% in  formats. It will heavily influence how  2038. For aluminium that's not a problem,  packaging is designed and nudge brand  but PPWR's Article 50 sets the bar a little  owners into placing more circular formats  higher: by 1 January 2029 member states  onto the market.  need to ensure the separate collection  Section 3  ustry Ind  of at least 90% by weight per year of When you examine the targets, they are  single-use metal beverage containers  ambitious. Lawmakers felt they had to  with a capacity of up to three litres  be, replacing the haphazard Packaging  (unless they qualify for specific  and Packaging Waste Directive (PPWD).  exemptions, like having reached  The European Council deemed that it had  80% separate collection by 2026 and  “not succeeded in reducing the negative  submitting a credible plan to reach 90  environmental impacts of packaging”.  becomes the law in every EU country. That's what makes the new Packaging  Regulation v directive – EU decides  and Packaging Waste Regulation (PPWR)  “A directive is at the discretion of the  so powerful: it leaves no wiggle room for  member states on how it's implemented,”  27 different versions.  explains Bernard Slack, Technical and Regulatory Affairs Manager at the Metal  It also reduces trading friction. The original  Packaging Manufacturers Association  national deployment of PPWD restricted  (MPMA). “It's been around for decades,  the EU's free movement of goods, one of  but the conclusion was that the directive  the union's core principles, as labelling and  wasn't doing enough. It wasn't keeping up  recycling standards differed per country.  with the amount of packaging people were using and the waste being generated.”  24 28  70%  of all packaging placed on the EU market must be recyclable by 2030  80% by 2038  by 2029). And DRS is the preferred collection method to do just that. “One of the primary objectives of a DRS is collection,” adds MPMA's Slack. “There has been a debate over the years about the need for DRS. If your country has household kerbside collections for beverage cans, then why DRS? Why implement a new scheme with additional infrastructure? What it boils down to is collection.”  PPWR's impact will be far-reaching for all materials, including beverage cans.  Gillian Garside-Wight, Consulting Director  Whilst a directive also needs to be  While its track record on recycling puts  at packaging sustainability consultancy  transposed into each country's  the sector in an already strong position,  Aura, says that the fundamental purpose  national laws, a regulation applies  the aluminium can market needs the  of a DRS is to reduce waste and improve  in all Member States from the moment  regulation to drive up collection rates  the quality of recycled materials. This  it enters into force. Simply put, the exact  boosted by the widespread adoption  aligns closely with PPWR's objectives,  text of the regulation itself immediately  of deposit return schemes (DRS).  but only time will tell on its impact."
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 24,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg25.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div>\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n         removeContentLinks();\n        }\n      ",
    "searchText": "ustry Ind  the loop Garside-Wight adds: “However, the  adoption of reuse targets, feeling that  Regulation is the key to this. Through  inclusion of DRS within PPWR has already  these measures do not consider the  harmonisation, the expectation is that  driven greater focus and urgency,  complementary nature of recycling and  recycling rates across the EU will climb.  particularly through the requirement for  reuse – or the contribution of existing  But it's not just about collection. MPMA's  every EU member state to implement a  highly recyclable and recycled packaging  Slack notes that PPWR incorporates design  scheme by 1 January 2029. That in itself is  formats to the circular economy. It  for recycling criteria, which he argues is a  a step in the right direction.  remains to be seen whether this approach  “good news story for the beverage can”.  will favour specific materials on the  A grading system delivers an ‘A' for 95%  “In an ideal world, higher recycling  market, or even potentially lead to an  rates and more accessible public  increase in non-recyclable packaging  recycling infrastructure might achieve  – at odds with the regulation's goals.  Section 3  similar outcomes. But that's not the reality we're operating in, at least not yet. Until  Success story  then, DRS remains a critical mechanism  Some member states, such as  for driving behavioural change and improving material recovery.”  of packaging by weight that is recyclable. “The inclusion of DRS within PPWR has already driven  The beverage can, of course, receives an  greater focus and  A, excelling for its infinitely recyclable  urgency, particularly  aluminium make-up, robust recycling  Germany, have a well-established  through the  infrastructure and inherent value. “This  DRS in place already. But there are  requirement for  grade really showcases the aluminium  states that are starting from scratch.  every EU member  beverage can's recyclability credentials,”  As Garside-Wight notes, DRS is  On the face of it, this is a daunting task.  state to implement  adds Slack.  proven to drive long-term behavioural  But the Republic of Ireland has shown  change in consumers. There can  the way and reaped early rewards.  1 January 2029.”  perceived inconvenience, but with clear  Ireland's scheme was launched in  communication and convenient return  February 2024 and this July's annual  points, acceptance follows.  report – from operator Re-turn – stated  Gillian Garside-Wight Aura  a scheme by  28  Consistency concern But while drinks manufacturers will no  be resistance at first, often due to  25  Grade ‘B' is 80% and grade ‘C' is 70%.  doubt welcome a clear direction across Europe, there are still challenges. Robbie Staniforth, Innovation and Policy Director  that Ireland's recycling rate for aluminium  at producer responsibility compliance  Similarly, Metal Packaging  and steel cans, as well as plastic bottles,  scheme Ecosurety, warns that there is still  Europe (MPE) sees PPWR as a  jumped from 49% to 91%. It claimed  work to be done.  largely positive step, applauding  that 76% is directly captured via  in particular the introduction of a  the DRS and over 1.6 billion cans and  “Pan-European consistency for DRS,  specific provision on recyclability  bottles have been returned since  as an operating model for collecting  and clear definition of what  February last year. The scheme has  drinks packaging under extended  high-quality recycling is. Whilst the  also been driven in-store. Reverse  producer responsibility (EPR)  DRS implementation from aluminium  vending machines have been installed  requirements, is still a long way off,”  beverage cans could be more ambitious,  in participating retailers, with Lidl  says Staniforth. “The differences in  MPE welcomes the mandatory DRS  particularly active, having placed  waste management funding and practices  system. However, it is concerned by the  machines in all stores.  are far too varied across the European"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 25,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg26.jpg",
    "zoom": null,
    "content": "\n        <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n        <img class=\"abs halfScale 26-text-1\" style=\"top:669px;left:791px;\" src=\"/issue3/static/_content/26-text-1.png\"/>\n        <img class=\"abs halfScale 26-text-2\" style=\"top:750px;left:781px;\" src=\"/issue3/static/_content/26-text-2.png\"/>\n        <img class=\"abs halfScaleC 26-a\" style=\"top:680px;left:792px;\" src=\"/issue3/static/_content/26-a-1.png\"/>\n        \n      ",
    "script": "\n        function onPageEnter() {\n          pg26Anim = new TimelineMax();\n          pg26Anim.fromTo(cOf(\"26-text-1\"), 1.2, {opacity:0, y: -20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"26-text-2\"), 1.2, {opacity:0, y: 20}, {opacity: 1, y: 0, ease: Power2.easeOut}, 1)\n          .fromTo(cOf(\"26-a\"), 0.7, {scale: 0}, {scale:0.5, ease: Back.easeOut.config(1.7)}, 1)\n        }\n\n        function onPageLeave() {\n          pg26Anim.stop();\n          removeContentLinks();\n        }\n      ",
    "searchText": "the loop  The reality is that recycling infrastructures vary significantly from country to country, making complete standardisation a complex and long-term challenge. “It's important not to oversimplify this process. The key for businesses is to understand the specific requirements of each country  ustry Ind  where their products, whether product or packaging, are sold. This means collecting data that meets all relevant national regulations.”  Section 3  Staniforth adds: “Moreover, consumption habits differ greatly across member states. Producers should be mindful of how these regional variations will affect the packaging they place onto the market, especially with modulated fees becoming increasingly common practice. Those selling drinks across Europe may choose to adopt a range of different packaging strategies and materials because of block for them to coalesce around one  reaches its end-of-life) by placing such  system for EPR or DRS soon.”  costs on manufacturers or sellers (‘producers').”  EPR is defined by the Waste and Resources Action Programme (WRAP)  26 28  Aura's Garside Wight concurs.  Beverage cans receive  A  in new EU grading system  these differences.” The mid-term will no doubt throw up teething problems for the supply chain. But PPWR's long-term goals  as “a regulatory mechanism used  “Harmonisation is a core ambition  to finance costs associated with the  of PPWR, but full alignment across  a helping hand on the collection  environmentally friendly management  EU member states remains unlikely  front, aluminium's strong circular  of a product or its packaging (once it  in the short to medium term.  track record looks set to continue.  are achievable and with DRS lending"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 26,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg27.jpg",
    "zoom": null,
    "content": "\n      \n      <div class=\"addContentLink\" onclick=\"Publish.goToPage(2);\" style=\"top:160px; left:43px; width:31px; height:28px;\"></div> \n\n        <div class=\"addContentLink\" style=\"top:761px;left:165px;width:160px;height:59px\">\n          <a href=\"https://canmakersbenelux.com/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:761px;left:354px;width:160px;height:59px\">\n          <a href=\"https://laboiteboisson.com/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:761px;left:538px;width:160px;height:59px\">\n          <a href=\"https://forum-getraenkedose.de/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:761px;left:736px;width:160px;height:59px\">\n          <a href=\"https://latasdebebidas.org/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:761px;left:918px;width:160px;height:59px\">\n          <a href=\"https://www.canmakers.co.uk/\" target=\"_blank\"></a>\n        </div>\n      \n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "the loop  ABOUT METAL PACKAGING EUROPE This magazine is published by Metal Packaging Europe, a trade body that represents the rigid metal packaging industry across the continent. We represent 13 corporate members and 10 associate members. MPE serves as the unified voice of the rigid metal packaging industry in conversations with policymakers and other stakeholders. It strives  About Us  to facilitate knowledge-sharing to enhance agility and competitiveness, and to support companies on the key challenges facing our industry. Our ultimate goal is to make metal the preferred choice for consumer and industrial packaging by raising awareness of its infinite versatility and importance in building a truly circular economy.  THE BEVERAGE EXECUTIVE COMMITTEE AND BEVERAGE CAN ASSOCIATIONS Within Metal Packaging Europe, the Beverage Executive Commission proactively supports the positive perception of beverage cans as a sustainable, circular packaging solution. Its members – Ardagh, Ball, CANPACK and Crown – collaborate to drive aluminium beverage can circularity throughout the supply chain and industry as a whole, and are represented at national level in the Benelux countries, France, Germany, Spain and the UK by the following Beverage Can Associations.  27 28"
  }], [{
    "guid": "00000000-0000-0000-0000-000000000000",
    "title": "",
    "index": 27,
    "subIndex": 0,
    "startIndex": 0,
    "original": "pg28.jpg",
    "zoom": null,
    "content": "\n      \n        <div class=\"addContentLink\" style=\"top:792px;left:363px;width:60px;height:59px\">\n          <a href=\"https://metalpackagingeurope.org/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:792px;left:463px;width:60px;height:59px\">\n          <a href=\"https://twitter.com/metal_packaging?s=20\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:780px;left:571px;width:130px;height:77px\">\n          <a href=\"https://metalpackagingeurope.org/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:792px;left:739px;width:60px;height:59px\">\n          <a href=\"https://www.instagram.com/metal_packaging_eu/\" target=\"_blank\"></a>\n        </div>\n        <div class=\"addContentLink\" style=\"top:792px;left:840px;width:60px;height:59px\">\n          <a href=\"https://www.linkedin.com/company/metal-packaging-europe/\" target=\"_blank\"></a>\n        </div>\n\n      ",
    "script": "\n        function onPageEnter() {\n          setTimeout(function(){\n            addContentLinks();\n          },1000)\n        }\n\n        function onPageLeave() {\n          removeContentLinks();\n        }\n      ",
    "searchText": "the loop"
  }]],
  "script": "\n      function idOf(id) {\n        return document.getElementById(id)\n      }\n  \n      function cOf(klass) {\n        return document.getElementsByClassName(klass)\n      }\n      \n      function removeContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) { \n          return e.className = 'addContentLink'\n        })\n      }\n  \n      function addContentLinks() {\n        var contentLinks = [].slice.call(document.querySelectorAll('.addContentLink'))\n        contentLinks.map(function callback(e) {\n          return e.className = 'contentLink addContentLink'\n        })\n      }\n  \n      function showOverlay(idx) {\n        idOf(idx).className = 'contentOverlay visible'\n      }\n  \n      function hideOverlay(idx) {\n        idOf(idx).className = 'contentOverlay hidden noclick'\n      }\n\n      function animateNumber(element){\n        if(element.getAttribute(\"data-number\")){\n          var args = JSON.parse(element.getAttribute(\"data-number\"));\n          var from = 0;\n          var to = 100;\n          var append = \"\";\n          var preppend = \"\";\n          var decimals = 0;\n          var duration = 1;\n          var ease = \"Linear.easeNone\";\n          var comma = false;\n          var separator = \",\";\n          var decChar = \".\";\n          for(obj in args){\n            if(obj == \"from\") from = args[obj];\n            if(obj == \"to\") to = args[obj];\n            if(obj == \"append\") append = args[obj];\n            if(obj == \"preppend\") preppend = args[obj];\n            if(obj == \"decimals\") decimals = args[obj];\n            if(obj == \"duration\") duration = args[obj];\n            if(obj == \"ease\") ease = args[obj];\n            if(obj == \"comma\") comma = args[obj];\n            if(obj == \"separator\") separator = args[obj];\n            if(obj == \"decChar\") decChar = args[obj];\n          }\n          var obj = {number: from}\n          TweenMax.to(obj, duration, {number: to, onUpdate: function(){\n            if(comma){\n              console.log(obj.number)\n              var str = obj.number.toFixed(decimals).toString();\n              var predec = str.split(/^d*/)[0];\n              console.log(\"PREDEC\", predec, typeof(predec));\n              var newstr = predec.split('').reverse().join('').replace(/(.{3})/g, '$1'+ separator).split('').reverse().join('')\n              var comp = newstr.replace(/^,/, '')\n              console.log(\"NEWSTR\", newstr, typeof(newstr));\n              // console.log({newstr})\n              // var dp = str.split(/.d+/) ? str.split(/.d+/)[0] : \"\";\n              // if(dp[0]) dp = dp[0].replace(\".\", decChar);\n              var dp = \"\";\n              element.innerHTML = preppend+comp+dp+append;\n            }else{\n              element.innerHTML = preppend+obj.number.toFixed(decimals).toString().replace(\".\", decChar)+append;\n            }\n          }, ease: eval(ease)});\n        }else{\n          return;\n        }\n      }\n\n      function resetNumbers(ele){\n        var numbers = cOf(ele)\n        for(var i=0; i<numbers.length; i++) {\n          numbers[i].innerText= \"\"\n        }\n      }\n\n      function mailChimpSubmit(){\n        $('#mc-embedded-subscribe-form').submit(function (e) {\n          var that = $(this);\n          var mailchimpSubmit = $(this).find('input[type=submit]');\n          var errorResponse = $('#mce-error-response');\n          var successResponse = $('#mce-success-response');\n\n          e.preventDefault();\n\n          $.ajax({\n            method: 'GET',\n            url: that.attr('action'),\n            data: that.serialize(),\n            dataType: 'jsonp',\n            success: function(data) {\n              console.log('AJAX SUCCESS')\n            // If there was an error then show the error message.\n              if (data.result === 'error') {\n                console.log('AJAX ERROR')\n                // If the error has an error code at front then alter the message to not include the error code and hyphen.\n                if(data.msg.indexOf('0') === 0) {\n                  data.msg = data.msg.slice(3);\n                }\n                errorResponse.html(data.msg).fadeIn(300).delay(3000).fadeOut(300);\n              }\n              // If success then show message\n              else {\n                successResponse.html('Thank you for subscribing!').fadeIn(300).delay(3000).fadeOut(300);\n              }\n            }\n          });\n        });\n      }\n    ",
  "mobilePages": null,
  "mobileTemplate": null
});
// CONCATENATED MODULE: ./src/router/index.js





vue_esm["default"].use(vue_router_esm["a" /* default */]);
/* harmony default export */ var router = (new vue_router_esm["a" /* default */]({
  mode: 'history',
  base: src_document.basePath,
  routes: [{
    path: '/',
    name: 'Home',
    component: src_components_PublishPage,
    redirect: '/1-1'
  }, {
    path: '/:page-:section',
    name: 'PublishPage',
    component: src_components_PublishPage
  }]
}));
// CONCATENATED MODULE: ./src/store/actions.js





/* harmony default export */ var actions = ({
  goToPage: function goToPage(context, payload) {
    if (payload === null) {
      // console.log('Page does not exist')
      return;
    }
    if (typeof payload == "number") {
      if (context.getters.pageInRange(payload, 1)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          console.log('TEST 1');
          router.push(context.getters.routeFromIndex(payload - 1, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload, 1), function () {
            // console.log(payload)
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload,
              sectionIndex: 0
            });
          });
        }
      }
    } else {
      if (context.getters.pageInRange(payload.pageIndex, payload.sectionIndex)) {
        if (Publish.isDoublePage && Publish.$store.state.document.pages.length == payload.pageIndex && payload.pageIndex % 2 !== 0) {
          router.push(context.getters.routeFromIndex(payload.pageIndex - 1, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        } else {
          router.push(context.getters.routeFromIndex(payload.pageIndex, payload.sectionIndex), function () {
            context.commit('CHANGE_SECTION_INDEX', {
              pageIndex: payload.pageIndex - 1,
              sectionIndex: payload.sectionIndex - 1
            });
          });
        }
      }
    }
  },

  goToPreviousPage: function goToPreviousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  goToNextPage: function goToNextPage(context) {
    if (context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  previousPage: function previousPage(context) {
    if (context.getters.previousPreviousPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.previousDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.previousPageIndices);
    }
  },
  nextPage: function nextPage(context) {
    if (context.getters.nextNextPage != null && context.state.isDoublePage && context.getters.doublePage) {
      context.dispatch('goToPage', context.getters.nextDoublePageIndices);
    } else {
      context.dispatch('goToPage', context.getters.nextPageIndices);
    }
  },
  goToPreviousMobilePage: function goToPreviousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  goToNextMobilePage: function goToNextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  goToPreviousSection: function goToPreviousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  goToNextSection: function goToNextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },
  previousMobilePage: function previousMobilePage(context) {
    return context.dispatch('goToPage', context.getters.previousMobilePageIndices);
  },
  nextMobilePage: function nextMobilePage(context) {
    return context.dispatch('goToPage', context.getters.nextMobilePageIndices);
  },
  previousSection: function previousSection(context) {
    return context.dispatch('goToPage', context.getters.previousSectionIndices);
  },
  nextSection: function nextSection(context) {
    return context.dispatch('goToPage', context.getters.nextSectionIndices);
  },

  resetSectionIndices: function resetSectionIndices(context) {
    var sectionIndices = context.getters.pages.map(function (page, index) {
      if (index == context.getters.zeroedPageIndex) return context.getters.sectionIndex - 1;
      return page.startIndex || 0;
    });
    context.commit('RESET_SECTION_INDICES', sectionIndices);
  },

  updateVideoURL: function updateVideoURL(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  openVideo: function openVideo(context, payload) {
    context.commit('UPDATE_VIDEO_URL', payload);
    trackingHandler.trackVideoPlay(payload);
  },

  setInitialWindowSize: function setInitialWindowSize(context, payload) {
    context.commit('UPDATE_INITIAL_WINDOW_SIZE', extends_default()({}, payload));
  },
  changeWindowSize: function changeWindowSize(context, payload) {
    var pageWidth = context.getters.width;
    var pageHeight = context.getters.height;
    if (context.getters.contentsPinned) {
      if (payload.width < 992) {
        var windowWidth = payload.width;
        var mobile = true;
      } else {
        var windowWidth = payload.width - 300;
        var mobile = false;
      }
    } else {
      var windowWidth = payload.width;
    }
    var windowHeight = payload.height - 60;
    var widthRatio = windowWidth / pageWidth;
    var heightRatio = windowHeight / pageHeight;
    if (context.getters.doublePage) {
      if (windowWidth / (pageWidth * 2) < heightRatio) {
        context.commit('UPDATE_IS_DOUBLE_PAGE', false);
      } else {
        context.commit('UPDATE_IS_DOUBLE_PAGE', true);
      }
    }

    if (pageWidth <= windowWidth && pageHeight <= windowHeight) {
      var newScale = Math.min(widthRatio, heightRatio);
      // console.log('widthratio', widthRatio)
      // console.log('heightratio', heightRatio)
      context.commit('UPDATE_PAGE_SCALE', { pageScale: newScale });
    } else {
      var _newScale = Math.min(widthRatio, heightRatio);
      context.commit('UPDATE_PAGE_SCALE', { pageScale: _newScale });
    }
    if (context.getters.contentsPinned) {
      if (windowWidth <= 992 && mobile) {
        context.commit('UPDATE_CONTENT_PANEL', false);
      } else {
        context.commit('UPDATE_CONTENT_PANEL', true);
      }
    }
  },

  checkMobileLanding: function checkMobileLanding(context, payload) {
    var isMobile = context.getters.isMobile;
    var landingPage = context.getters.currentMobilePage;
    var mobileSwitch = context.getters.mobileSwitch;
    if (!mobileSwitch || !isMobile) return;
    if (landingPage) {
      return;
    } else {
      router.replace('/1-1');
    }
  },

  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    // if(newX < -context.getters.width  ) newX = (-context.getters.width -  100) / newZ
    // if(newY < -context.getters.height ) newY = (-context.getters.height - 100) / newZ
    // if(newX > context.getters.width ) newX = (context.getters.width + 100) / newZ
    // if(newY > context.getters.height) newY = (context.getters.height + 100) / newZ
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  scrollZoom: function scrollZoom(context, payload) {
    var zoomLevel = context.state.zoomLevel + payload.zoomDelta;
    zoomLevel = zoomLevel > 2 ? 2 : zoomLevel;
    zoomLevel = zoomLevel < 1 ? 1 : zoomLevel;
    var windowWidthAdjustment = context.getters.contentsPinned ? 300 : 0;
    var newX = payload.x - (window.innerWidth - windowWidthAdjustment) / 2;
    var newY = payload.y - (window.innerHeight + 48) / 2;
    var translateX = context.state.translateX + (newX - context.state.zoomOriginX) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));
    var translateY = context.state.translateY + (newY - context.state.zoomOriginY) * (1 - 1 / (context.state.zoomLevel * context.state.pageScale));

    console.log({ zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });

    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: zoomLevel, translateX: translateX, translateY: translateY });
  },
  pinchZoom: function pinchZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY / newZ;
    // if(newX < -context.getters.width  ) newX = -context.getters.width -  100
    // if(newY < -context.getters.height ) newY = -context.getters.height - 100
    // if(newX > context.getters.width ) newX = context.getters.width + 100
    // if(newY > context.getters.height) newY = context.getters.height + 100
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: payload.zoomLevel });
  },
  panZoom: function panZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.state.pageScale - 1;
    var newX = context.state.zoomOriginX - payload.zoomOriginX / newZ;
    var newY = context.state.zoomOriginY - payload.zoomOriginY / newZ;
    console.log("Pan Zoom: " + newZ + ", " + newX + ", " + newY);
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY, zoomLevel: context.state.zoomLevel });
  },
  openGallery: function openGallery(context, payload) {
    context.commit('UPDATE_GALLERY', payload);
  },
  openGalleryTwo: function openGalleryTwo(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload[1]);
    context.commit('UPDATE_GALLERY', payload[0]);
  },
  closeGallery: function closeGallery(context, payload) {
    context.commit('UPDATE_GALLERY', []);
  },
  goToGallerySlide: function goToGallerySlide(context, payload) {
    context.commit('UPDATE_GALLERY_INDEX', payload);
  },
  nextGallerySlide: function nextGallerySlide(context, payload) {
    if (context.state.galleryIndex < context.state.galleryImages.length - 1) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex + 1);else context.commit('UPDATE_GALLERY_INDEX', 0);
  },
  previousGallerySlide: function previousGallerySlide(context, payload) {
    if (context.state.galleryIndex > 0) context.commit('UPDATE_GALLERY_INDEX', context.state.galleryIndex - 1);else context.commit('UPDATE_GALLERY_INDEX', context.state.galleryImages.length - 1);
  },


  updateAudioURL: function updateAudioURL(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  },

  openAudio: function openAudio(context, payload) {
    context.commit('UPDATE_AUDIO_URL', payload);
    trackingHandler.trackAudioPlay(payload);
  }
});
// EXTERNAL MODULE: ./node_modules/util/util.js
var util = __webpack_require__("OMJi");
var util_default = /*#__PURE__*/__webpack_require__.n(util);

// CONCATENATED MODULE: ./src/store/getters.js


/* harmony default export */ var getters = ({
  title: function title(state) {
    return state.document.title;
  },
  description: function description(state) {
    return state.document.description;
  },
  basePath: function basePath(state) {
    return state.document.basePath;
  },
  pages: function pages(state) {
    return state.document.pages.map(function (page, pageIndex) {
      return page.map(function (section, sectionIndex) {
        section.pageIndex = pageIndex;
        section.sectionIndex = sectionIndex;
        return section;
      });
    });
  },
  titledPages: function titledPages(state) {
    return state.document.pages.filter(function (page) {
      return page[0].title;
    });
  },
  videoURL: function videoURL(state) {
    return state.videoURL;
  },
  audioURL: function audioURL(state) {
    return state.audioURL;
  },
  showContents: function showContents(state, getters) {
    return state.activePanel == "Contents" || getters.contentsPinned;
  },
  showLanguages: function showLanguages(state) {
    return state.activePanel == "Languages";
  },
  showSearch: function showSearch(state) {
    return state.activePanel == "Search";
  },
  showSubscribe: function showSubscribe(state) {
    return state.activePanel == "Subscribe";
  },
  showGuide: function showGuide(state) {
    return state.activePanel == "Guide";
  },
  showEditions: function showEditions(state) {
    return state.activePanel == "Editions";
  },
  isZoomed: function isZoomed(state) {
    return state.zoomLevel != 1;
  },
  zoomLevel: function zoomLevel(state) {
    return state.zoomLevel;
  },
  companyLogo: function companyLogo(state, getters) {
    if (state.document.companyLogo != "") {
      return getters.basePath + "/static/_content/" + state.document.companyLogo;
    } else return getters.basePath + "/static/kp-logo-white.svg";
  },
  galleryImages: function galleryImages(state) {
    return state.galleryImages;
  },
  galleryCaptions: function galleryCaptions(state) {
    return state.document.options.galleryCaptions;
  },
  galleryIndex: function galleryIndex(state) {
    return state.galleryIndex;
  },
  isGalleryOpen: function isGalleryOpen(state) {
    return state.galleryImages.length > 0;
  },
  isMobile: function isMobile(state, getters) {
    return function (a) {
      if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|)|g1 u|g560|gene|gf-5|g-mo|go(.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(a.substr(0, 4))) return true;
    }(navigator.userAgent || navigator.vendor || window.opera) ? true : false;
  },
  isMobileFontLarge: function isMobileFontLarge(state) {
    return state.isMobileFontLarge;
  },
  isIE11: function isIE11(state, getters) {
    return !!navigator.userAgent.match(/Trident\/7\./);
  },
  isPhantom: function isPhantom(state, getters) {
    return !!(navigator.userAgent.match("PhantomJS") != null);
  },
  initialWindowWidth: function initialWindowWidth(state) {
    return state.initialWindowWidth;
  },
  initialWindowHeight: function initialWindowHeight(state) {
    return state.initialWindowHeight;
  },
  publishURL: function publishURL(state) {
    return state.document.publishURL;
  },
  doublePage: function doublePage(state) {
    return state.document.options.doublePage;
  },
  contentsEnabled: function contentsEnabled(state) {
    return state.document.options.contents.enabled;
  },
  contentsPinned: function contentsPinned(state, getters) {
    return state.document.options.contents.pinned && getters.contentsEnabled && !getters.isMobile && !getters.isFullscreen;
  },
  contentsNumbers: function contentsNumbers(state) {
    return state.document.options.contents.numbers;
  },
  contentsTitles: function contentsTitles(state) {
    return state.document.options.contents.titles;
  },
  downloadEnabled: function downloadEnabled(state) {
    return state.document.options.downloadEnabled;
  },
  languagesEnabled: function languagesEnabled(state) {
    return state.document.options.languagesEnabled;
  },
  readerEnabled: function readerEnabled(state) {
    return state.document.options.readerEnabled;
  },
  printEnabled: function printEnabled(state) {
    return state.document.options.printEnabled;
  },
  searchEnabled: function searchEnabled(state) {
    return state.document.options.searchEnabled;
  },
  subscribeEnabled: function subscribeEnabled(state) {
    return state.document.options.subscribeEnabled;
  },
  guideEnabled: function guideEnabled(state) {
    return state.document.options.guideEnabled;
  },
  editionsEnabled: function editionsEnabled(state) {
    return state.document.options.editionsEnabled;
  },
  zoomNavEnabled: function zoomNavEnabled(state) {
    return state.document.options.zoom.navEnabled;
  },
  zoomClickEnabled: function zoomClickEnabled(state) {
    return state.document.options.zoom.clickEnabled;
  },
  zoomScrollEnabled: function zoomScrollEnabled(state) {
    return state.document.options.zoom.scrollEnabled;
  },
  zoomSliderEnabled: function zoomSliderEnabled(state) {
    return state.document.options.zoom.sliderEnabled;
  },
  zoomEnabled: function zoomEnabled(state) {
    return state.document.options.zoom.navEnabled || state.document.options.zoom.clickEnabled || state.document.options.zoom.scrollEnabled || state.document.options.zoom.sliderEnabled;
  },
  mobileSwitch: function mobileSwitch(state) {
    return state.document.options.mobileSwitch;
  },
  rightToLeft: function rightToLeft(state, getters) {
    return state.document.options.rightToLeft;
  },
  pagesVisible: function pagesVisible(state, getters) {
    return !getters.showSearch;
  },
  downloadPath: function downloadPath(state, getters) {
    return state.document.options.downloadPath;
  },
  fullscreenEnabled: function fullscreenEnabled(state) {
    return state.document.options.fullscreenEnabled && document.documentElement.requestFullscreen;
  },
  isFullscreen: function isFullscreen(state) {
    return state.isFullscreen;
  },
  width: function width(state) {
    return state.document.width;
  },
  height: function height(state) {
    return state.document.height;
  },
  languages: function languages(state) {
    return state.document.languages;
  },
  currentLanguage: function currentLanguage(state) {
    return state.document.currentLanguage;
  },
  editions: function editions(state) {
    return state.document.editions;
  },
  zeroedPageIndex: function zeroedPageIndex(state, getters) {
    return getters.pageIndex - 1;
  },
  zeroedSectionIndex: function zeroedSectionIndex(state, getters) {
    return getters.sectionIndex - 1;
  },
  currentPages: function currentPages(state, getters) {
    return getters.pages[getters.zeroedPageIndex];
  },
  currentPage: function currentPage(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  currentSection: function currentSection(state, getters) {
    return getters.pages[getters.zeroedPageIndex][getters.zeroedSectionIndex];
  },
  routeFromIndex: function routeFromIndex(state, getters) {
    return function (pageIndex, sectionIndex) {
      return "/" + pageIndex + "-" + sectionIndex;
    };
  },
  externalResources: function externalResources(state) {
    return state.document.externalResources;
  },
  pageInRange: function pageInRange(state, getters) {
    return function (pageIndex, sectionIndex) {
      return (getters.pages[pageIndex - 1] || [])[sectionIndex - 1] !== undefined;
    };
  },
  isDoublePage: function isDoublePage(state, getters) {
    return state.isDoublePage;
  },
  visiblePages: function visiblePages(state, getters) {
    if (state.isDoublePage && getters.doublePage) {
      if (getters.zeroedPageIndex == 0) {
        return {
          previousLeftPage: null,
          previousRightPage: null,
          leftPage: null,
          previousSection: getters.previousSection,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else if (getters.nextPage == null && getters.nextNextPage == null) {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: null,
          currentPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: null,
          nextRightPage: null
        };
      } else if (getters.zeroedPageIndex % 2 != 1) {
        return {
          previousLeftPage: getters.previousPreviousPreviousPage,
          previousRightPage: getters.previousPreviousPage,
          previousSection: getters.previousSection,
          leftPage: getters.previousPage,
          rightPage: getters.currentPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextPage,
          nextRightPage: getters.nextNextPage
        };
      } else {
        return {
          previousLeftPage: getters.previousPreviousPage,
          previousRightPage: getters.previousPage,
          previousSection: getters.previousSection,
          leftPage: getters.currentPage,
          rightPage: getters.nextPage,
          nextSection: getters.nextSection,
          nextLeftPage: getters.nextNextPage,
          nextRightPage: getters.nextNextNextPage
        };
      }
    } else {
      return {
        previousPreviousPage: getters.previousPreviousPage,
        previousPage: getters.previousPage,
        previousSection: getters.previousSection,
        currentPage: getters.currentPage,
        nextSection: getters.nextSection,
        nextPage: getters.nextPage,
        nextNextPage: getters.nextNextPage
      };
    }
  },
  previousPreviousPreviousPage: function previousPreviousPreviousPage(state, getters) {
    if (getters.pageIndex <= 3) return null;
    return getters.pages[getters.pageIndex - 4][state.sectionIndices[0]];
  },

  previousPreviousPage: function previousPreviousPage(state, getters) {
    if (getters.pageIndex <= 2) return null;
    return getters.pages[getters.pageIndex - 3][state.sectionIndices[0]];
  },

  previousPage: function previousPage(state, getters) {
    if (getters.pageIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 2][state.sectionIndices[0]];
  },

  nextPage: function nextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length) return null;
    return getters.pages[getters.pageIndex][state.sectionIndices[0]];
  },

  nextNextPage: function nextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 1) return null;
    return getters.pages[getters.pageIndex + 1][state.sectionIndices[0]];
  },

  nextNextNextPage: function nextNextNextPage(state, getters) {
    if (getters.pageIndex >= getters.pages.length - 2) return null;
    return getters.pages[getters.pageIndex + 2][state.sectionIndices[0]];
  },

  previousSection: function previousSection(state, getters) {
    if (getters.sectionIndex <= 1) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex - 2];
  },

  nextSection: function nextSection(state, getters) {
    if (getters.sectionIndex >= getters.pages[getters.pageIndex - 1].length) return null;
    return getters.pages[getters.pageIndex - 1][getters.sectionIndex];
  },

  previousPageURI: function previousPageURI(state, getters) {
    if (getters.previousPage == null) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.previousPreviousPage == null) {
        return getters.routeFromIndex(1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex - 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex - 1, state.sectionIndices[getters.pageIndex - 2] + 1);
  },

  nextPageURI: function nextPageURI(state, getters) {
    if (getters.nextPage == null || getters.nextPage.index == Publish.$store.state.document.pages.length) return null;
    if (state.isDoublePage && getters.doublePage) {
      if (getters.nextNextPage == null) {
        return getters.routeFromIndex(Publish.$store.state.document.pages.length - 1, 1);
      }
      return getters.routeFromIndex(2 * parseInt((getters.pageIndex + 2) / 2.0), 1);
    }
    return getters.routeFromIndex(getters.pageIndex + 1, state.sectionIndices[getters.pageIndex] + 1);
  },

  previousSectionURI: function previousSectionURI(state, getters) {
    if (getters.previousSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex - 1);
  },

  nextSectionURI: function nextSectionURI(state, getters) {
    if (getters.nextSection == null) return null;
    return getters.routeFromIndex(getters.pageIndex, getters.sectionIndex + 1);
  },

  previousPageIndices: function previousPageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: getters.pageIndex - 1,
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  previousDoublePageIndices: function previousDoublePageIndices(state, getters) {
    if (getters.previousPage == null) return null;
    return {
      pageIndex: Math.ceil(getters.pageIndex - 2),
      sectionIndex: state.sectionIndices[getters.pageIndex - 2] + 1
    };
  },

  nextPageIndices: function nextPageIndices(state, getters) {
    if (getters.nextPage == null) return null;
    return {
      pageIndex: getters.pageIndex + 1,
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  nextDoublePageIndices: function nextDoublePageIndices(state, getters) {
    if (getters.nextNextPage == null) return null;
    return {
      pageIndex: 2 * parseInt((getters.pageIndex + 2) / 2.0),
      sectionIndex: state.sectionIndices[getters.pageIndex] + 1
    };
  },

  previousSectionIndices: function previousSectionIndices(state, getters) {
    if (getters.previousSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex - 1
    };
  },

  nextSectionIndices: function nextSectionIndices(state, getters) {
    if (getters.nextSection == null) return null;
    return {
      pageIndex: getters.pageIndex,
      sectionIndex: getters.sectionIndex + 1
    };
  },

  pageContainerStyle: function pageContainerStyle(state, getters) {
    var styleObject = {};

    styleObject.transformOrigin = state.zoomOriginX + "px " + state.zoomOriginY + "px";

    styleObject.transform = "scale(" + getters.pageContainerZoomLevel * state.pageScale + ") translate(" + state.translateX + "px, " + state.translateY + "px)";

    return styleObject;
  },

  pageContainerZoomLevel: function pageContainerZoomLevel(state, getters) {
    return state.zoomLevel;
  },

  searchObject: function searchObject(state, getters) {
    var searchArray = [];
    getters.pages.forEach(function (sections, pageIndex) {
      sections.forEach(function (section, sectionIndex) {
        searchArray.push({
          id: pageIndex + 1 + "-" + (sectionIndex + 1),
          pageIndex: pageIndex + 1,
          sectionIndex: sectionIndex + 1,
          title: section.title,
          body: section.searchText || "",
          image: section.original || "",
          thumb: section.index + 1
        });
      });
    });
    return searchArray;
  },

  pageScripts: function pageScripts(state, getters) {
    return getters.pages.map(function (page, pageIndex) {
      return page.filter(function (e) {
        return e.script;
      }).map(function (section, sectionIndex) {
        return section.script.replace("onPageEnter", "p" + pageIndex + "s" + sectionIndex + "onPageEnter").replace("onPageLeave", "p" + pageIndex + "s" + sectionIndex + "onPageLeave");
      });
    }).reduce(function (a, b) {
      return a.concat(b);
    }).join("\n");
  },

  documentScript: function documentScript(state) {
    return state.document.script;
  },

  //#region Mobile
  mobilePages: function mobilePages(state) {
    return state.document.mobilePages;
  },
  mobilePageLink: function mobilePageLink(state, getters) {
    return function (page) {
      if (page.pageLinks.length) {
        var pageLink = page.pageLinks[0];
        return "/" + (pageLink.index + 1) + "-" + (pageLink.subIndex + 1);
      }
    };
  },
  currentMobilePage: function currentMobilePage(state, getters) {
    if (!(getters.isMobile && getters.mobileSwitch || getters.readerEnabled)) return;
    var currentPage = getters.mobilePages.find(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
    if (currentPage) return currentPage;else return null;
  },
  currentMobilePageIndex: function currentMobilePageIndex(state, getters) {
    if (!getters.mobilePages) return;
    return getters.mobilePages.findIndex(function (e) {
      return e.pageLinks.find(function (f) {
        return f.index == getters.zeroedPageIndex && f.subIndex == getters.zeroedSectionIndex;
      });
    });
  },
  nextMobilePage: function nextMobilePage(state, getters) {
    if (getters.currentMobilePageIndex >= getters.mobilePages.length) return null;
    return getters.mobilePages[getters.currentMobilePageIndex + 1];
  },
  nextMobilePageIndices: function nextMobilePageIndices(state, getters) {
    if (getters.nextMobilePage == null) return null;
    return {
      pageIndex: getters.nextMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.nextMobilePage.pageLinks[0].subIndex + 1
    };
  },
  previousMobilePage: function previousMobilePage(state, getters) {
    if (getters.currentMobilePageIndex <= 0) return null;
    return getters.mobilePages[getters.currentMobilePageIndex - 1];
  },
  previousMobilePageIndices: function previousMobilePageIndices(state, getters) {
    if (getters.previousMobilePage == null) return null;
    return {
      pageIndex: getters.previousMobilePage.pageLinks[0].index + 1,
      sectionIndex: getters.previousMobilePage.pageLinks[0].subIndex + 1
    };
  },

  mobilePageContent: function mobilePageContent(state, getters) {
    return function (mobilePage) {
      return mobilePage.pageLinks.map(function (e) {
        return getters.pages[e.index][e.subIndex].mobileHtml;
      }).reduce(function (a, b) {
        return a + b;
      }, "");
    };
  }

  //#endregion

  //#region doublePage

  //#endregion
});
// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("bOdI");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/epsilon.js
var epsilon = __webpack_require__("NnIC");
var epsilon_default = /*#__PURE__*/__webpack_require__.n(epsilon);

// CONCATENATED MODULE: ./src/store/mutations.js



var _types$RESET_SECTION_;



/* harmony default export */ var mutations = (_types$RESET_SECTION_ = {}, defineProperty_default()(_types$RESET_SECTION_, RESET_SECTION_INDICES, function (state, payload) {
  state.sectionIndices = payload;
}), defineProperty_default()(_types$RESET_SECTION_, CHANGE_SECTION_INDEX, function (state, payload) {
  state.sectionIndices[payload.pageIndex] = payload.sectionIndex;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_PAGE_SCALE, function (state, payload) {
  state.pageScale = payload.pageScale;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_VIDEO_URL, function (state, payload) {
  state.videoURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_AUDIO_URL, function (state, payload) {
  state.audioURL = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel = "";
  } else {
    state.activePanel = "Languages";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_EDITIONS, function (state) {
  if (state.activePanel == "Editions") {
    state.activePanel = "";
  } else {
    state.activePanel = "Editions";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel = "";
  } else {
    state.activePanel = "Contents";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel = "";
  } else {
    state.activePanel = "Search";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_SUBSCRIBE, function (state) {
  if (state.activePanel == "Subscribe") {
    state.activePanel = "";
  } else {
    state.activePanel = "Subscribe";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_GUIDE, function (state) {
  if (state.activePanel == "Guide") {
    state.activePanel = "";
  } else {
    state.activePanel = "Guide";
  }
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FONT_SIZE, function (state) {
  state.isMobileFontLarge = !state.isMobileFontLarge;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  // console.log('toggleZoom', payload.zoomOriginX)
  if (state.zoomLevel != 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
  } else {
    state.zoomLevel = payload.zoomLevel || 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_FULLSCREEN, function (state) {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen();
    state.isFullscreen = true;
  } else if (document.exitFullscreen) {
    document.exitFullscreen();
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_FULLSCREEN, function (state) {
  if (document.fullscreenElement || window.fullscreenElement) {
    state.isFullscreen = true;
  } else {
    state.isFullscreen = false;
  }
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.translateX = payload.translateX || state.translateX;
  state.translateY = payload.translateY || state.translateY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;

  if (state.zoomLevel <= 1) {
    state.zoomLevel = 1;
    state.zoomOriginX = 0;
    state.zoomOriginY = 0;
    state.translateX = 0;
    state.translateY = 0;
  }

  Publish.$refs.app.$refs.navBar.$refs.zoomSlider.setValue(Math.round((state.zoomLevel + epsilon_default.a) * 100) / 100);
}), defineProperty_default()(_types$RESET_SECTION_, SLIDE_ZOOM, function (state, payload) {
  var zoomDelta = payload.zoomValue - state.zoomLevel;

  if (zoomDelta < 0) {
    var zoomDeltaScale = zoomDelta / (1 - state.zoomLevel);
    state.zoomOriginX = state.zoomOriginX * (1 - zoomDeltaScale);
    state.zoomOriginY = state.zoomOriginY * (1 - zoomDeltaScale);
  }

  state.zoomLevel = payload.zoomValue || state.zoomLevel;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_INITIAL_WINDOW_SIZE, function (state, payload) {
  state.initialPageWidth = payload.width;
  state.initialPageHeight = payload.height;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_IS_DOUBLE_PAGE, function (state, payload) {
  state.isDoublePage = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY, function (state, payload) {
  state.galleryImages = payload;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_GALLERY_INDEX, function (state, payload) {
  state.galleryIndex = payload;
}), defineProperty_default()(_types$RESET_SECTION_, TOGGLE_READER, function (state, payload) {
  state.isReader = !state.isReader;
}), defineProperty_default()(_types$RESET_SECTION_, UPDATE_CONTENT_PANEL, function (state, payload) {
  state.contentsPanel = payload;
}), _types$RESET_SECTION_);
// CONCATENATED MODULE: ./src/store/modules/contents.js



// initial state
var contents_state = {
  showContents: false

  // getters
};var contents_getters = {};

// actions
var contents_actions = {};

// mutations
var contents_mutations = defineProperty_default()({}, TOGGLE_CONTENTS, function (state) {
  if (state.activePanel == "Contents") {
    state.activePanel == "";
  } else {
    state.activePanel == "Contents";
  }
});

/* harmony default export */ var contents = ({
  state: contents_state,
  getters: contents_getters,
  actions: contents_actions,
  mutations: contents_mutations
});
// CONCATENATED MODULE: ./src/store/modules/languages.js



// initial state
var languages_state = {
  showLanguages: false

  // getters
};var languages_getters = {};

// actions
var languages_actions = {};

// mutations
var languages_mutations = defineProperty_default()({}, TOGGLE_LANGUAGES, function (state) {
  if (state.activePanel == "Languages") {
    state.activePanel == "";
  } else {
    state.activePanel == "Languages";
  }
});

/* harmony default export */ var languages = ({
  state: languages_state,
  getters: languages_getters,
  actions: languages_actions,
  mutations: languages_mutations
});
// CONCATENATED MODULE: ./src/store/modules/zoom.js


var _mutations;



// initial state
var zoom_state = {
  isZoomed: false,
  zoomLevel: 1,
  zoomOriginX: 0,
  zoomOriginY: 0

  // getters
};var zoom_getters = {
  // isZoomed: (state, getters) => state.isZoomed,
  zoomLevel: function zoomLevel(state, getters) {
    return state.zoomLevel;
  }

  // actions
};var zoom_actions = {
  updateZoom: function updateZoom(context, payload) {
    var newZ = context.state.zoomLevel * context.rootState.pageScale - 1;
    var newX = context.state.zoomOriginX - mouse.deltaX / newZ;
    var newY = context.state.zoomOriginY - mouse.deltaY / newZ;
    if (newX < -context.getters.width) newX = -context.getters.width;
    if (newY < -context.getters.height) newY = -context.getters.height;
    if (newX > context.getters.width) newX = context.getters.width;
    if (newY > context.getters.height) newY = context.getters.height;
    context.commit('UPDATE_ZOOM', { zoomOriginX: newX, zoomOriginY: newY });
  }
};

// mutations
var zoom_mutations = (_mutations = {}, defineProperty_default()(_mutations, TOGGLE_ZOOM, function (state) {
  var payload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (state.activePanel == 'Zoom') {
    state.activePanel = "";
  } else {
    state.activePanel = 'Zoom';
  }
  if (state.activePanel == 'Zoom') {
    state.zoomLevel = 2;
    state.zoomOriginX = payload.zoomOriginX || 0;
    state.zoomOriginY = payload.zoomOriginY || 0;
  } else {
    state.zoomLevel = 1;
  }
}), defineProperty_default()(_mutations, UPDATE_ZOOM, function (state, payload) {
  state.zoomOriginX = payload.zoomOriginX;
  state.zoomOriginY = payload.zoomOriginY;
  state.zoomLevel = payload.zoomLevel || state.zoomLevel;
}), _mutations);

/* harmony default export */ var zoom = ({
  state: zoom_state,
  getters: zoom_getters,
  actions: zoom_actions,
  mutations: zoom_mutations
});
// CONCATENATED MODULE: ./src/store/modules/search.js



// initial state
var search_state = {
  showSearch: false

  // getters
};var search_getters = {}
// allProducts: state => state.all


// actions
;var search_actions = {}
// getAllProducts ({ commit }) {
//   shop.getProducts(products => {
//     commit(types.RECEIVE_PRODUCTS, { products })
//   })
// }


// mutations
;var search_mutations = defineProperty_default()({}, TOGGLE_SEARCH, function (state) {
  if (state.activePanel == "Search") {
    state.activePanel == "";
  } else {
    state.activePanel == "Search";
  }
});

/* harmony default export */ var modules_search = ({
  state: search_state,
  getters: search_getters,
  actions: search_actions,
  mutations: search_mutations
});
// CONCATENATED MODULE: ./src/store/modules/route.js



// initial state - straight from the router i.e.
// route:{
// fullPath:"/5-1",
// meta: {},
// name:"PublishPage",
// params: {
//     section: "1",
//     page: "5"
// },
// path:"/5-1",
// query: {},
// }

// getters
var route_getters = {
  pageIndex: function pageIndex(state) {
    return parseInt(state.params.page);
  },
  sectionIndex: function sectionIndex(state) {
    return parseInt(state.params.section);
  }

  // actions
};var route_actions = {};

// mutations
var route_mutations = {};

/* harmony default export */ var route = ({
  getters: route_getters,
  actions: route_actions,
  mutations: route_mutations
});
// CONCATENATED MODULE: ./src/store/index.js












vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

/* harmony default export */ var store = (new vuex_esm["a" /* default */].Store({
  state: {
    document: src_document,
    sectionIndices: [],
    pageScale: 1,
    videoURL: "",
    audioURL: "",
    activePanel: "",
    contentsPanel: true,
    zoomLevel: 1,
    zoomOriginX: 0,
    zoomOriginY: 0,
    translateX: 0,
    translateY: 0,
    isDoublePage: false,
    isFullscreen: false,
    galleryImages: [],
    galleryIndex: 0,
    isReader: false,
    initialWindowWidth: 300,
    initialWindowHeight: 476,
    isMobileFontLarge: false
  },
  actions: actions,
  getters: getters,
  mutations: mutations,
  modules: {
    // contents,
    // languages,
    // search,
    // zoom,
    route: route
  },
  strict: debug
}));
// EXTERNAL MODULE: ./node_modules/hammerjs/hammer.js
var hammer = __webpack_require__("rxKx");
var hammer_default = /*#__PURE__*/__webpack_require__.n(hammer);

// CONCATENATED MODULE: ./src/helpers/modules/inputHandler.js


/* harmony default export */ var inputHandler = ({
  init: function init() {
    window.mouseDown = false;
    window.mouse = {
      x: 0,
      y: 0,
      startX: 0,
      startY: 0,
      lastX: 0,
      lastY: 0,
      upX: 0,
      upY: 0,
      deltaX: 0,
      deltaY: 0
      // Mouse Events
      // document.addEventListener("mousedown", this.mouseDownHandler)
      // document.addEventListener("mousemove", this.mouseMoveHandler)
      // document.addEventListener("mouseup", this.mouseUpHandler)
    };document.addEventListener("wheel", this.mouseWheelHandler, { passive: false });
    document.addEventListener("dblclick", this.doubleClickHandler);
    //Touch Events
    // document.addEventListener( "touchstart", this.touchStartHandler)
    // document.addEventListener( "touchend", this.touchEndHandler)
    // document.addEventListener( "touchmove", this.touchMoveHandler)
    //Keyboard Events
    document.onkeydown = this.keyDownHandler;
    var hammertime;
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto",
        inputClass: hammer_default.a.SUPPORT_POINTER_EVENTS ? hammer_default.a.PointerEventInput : hammer_default.a.TouchInput,
        recognizers: [[hammer_default.a.Swipe, {
          direction: hammer_default.a.DIRECTION_HORIZONTAL
        }]]
      });
      hammertime.add(new hammer_default.a.Swipe());
    } else {
      hammertime = new hammer_default.a(document.getElementById("app"), {
        touchAction: "auto"
      });
    }

    hammertime.get("swipe").set({ direction: hammer_default.a.DIRECTION_ALL });

    // hammertime.add(new Hammer.Tap({ event: "doubletap", taps: 2 }))
    // hammertime.add(new Hammer.Tap({ event: "singletap" }))
    // hammertime.get("doubletap").recognizeWith("singletap")
    // hammertime.get("singletap").requireFailure("doubletap")

    // hammertime.on("singletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1)
    //   ) {
    //     mouse.lastX = e.srcEvent.clientX
    //     mouse.lastY = e.srcEvent.clientY
    //   } else {
    //     console.log("Could not single tap")
    //   }
    // })

    // hammertime.on("doubletap", function(e) {
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     console.log("WORKING - MOBILE")
    //     Publish.toggleZoom({
    //       zoomOriginX: e.srcEvent.clientX,
    //       zoomOriginY: e.srcEvent.clientY,
    //     })
    //   } else {
    //     console.log("Could not double tap")
    //   }
    // })

    // hammertime.on("pinchin", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch in")
    //   }
    // })


    // hammertime.on("pinchout", function(e) {
    //   e.hammertime.preventDefault()
    //   if (Publish.zoomEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" &&
    //     (e.target.className.search("currentPage") !== -1 ||
    //       e.target.className.search("leftPage") !== -1 ||
    //       e.target.className.search("rightPage") !== -1 ||
    //       e.path.indexOf(document.getElementById("page-container") !== -1)
    //     )
    //   ) {
    //     Publish.pinchZoom({
    //       zoomOriginX: e.center.x,
    //       zoomOriginY: e.center.y,
    //       zoomLevel: e.scale,
    //     })
    //   } else {
    //     console.log("Could not pinch out")
    //   }
    // })

    hammertime.on("pan", function (e) {
      if (!Publish.isMobile) {
        mouse.x = e.srcEvent.clientX;
        mouse.y = e.srcEvent.clientY;
        mouse.deltaX = mouse.x - mouse.lastX;
        mouse.deltaY = mouse.y - mouse.lastY;
        mouse.lastX = mouse.x;
        mouse.lastY = mouse.y;
        // console.log(mouse.deltaX + ", " + mouse.deltaY)
        // console.log("Panning")
        if (mouseDown && Publish.isZoomed && mouse.y > 50) {
          Publish.updateZoom({
            x: mouse.x,
            y: mouse.y
          });
        }
      }
    });

    hammertime.on("panstart", function (e) {
      if (!Publish.isMobile) {
        if (Publish.isZoomed) {
          mouseDown = true;
          mouse.lastX = e.srcEvent.clientX;
          mouse.lastY = e.srcEvent.clientY;
        }
      }
    });

    hammertime.on("panend", function (e) {
      if (!Publish.isMobile) {
        if (mouseDown && Publish.pagesVisible) {
          mouse.lastX = mouse.x;
          mouse.lastX = mouse.y;
          mouseDown = false;
        }
      }
    });

    hammertime.on("swipe", function (e) {
      if (Publish.isMobile && document.documentElement.dataset.mobile == "iOS" && screen.width != window.innerWidth && screen.width != window.innerHeight) //Safari
        {
          // console.log('zoomed portrait')
        } else {
        if (Publish.isGalleryOpen) {
          if (e.direction === hammer_default.a.DIRECTION_LEFT) {
            if (!Publish.rightToLeft) {
              Publish.nextGallerySlide();
            } else {
              Publish.previousGallerySlide();
            }
          } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
            if (!Publish.rightToLeft) {
              Publish.previousGallerySlide();
            } else {
              Publish.nextGallerySlide();
            }
          }
        } else if (Publish.videoURL == "" && Publish.audioURL == "" && !Publish.isZoomed) {
          if (Publish.isMobile || Publish.isReader) {
            if (Publish.mobileSwitch || Publish.isReader) {
              if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                if (!Publish.rightToLeft) {
                  Publish.goToNextMobilePage();
                } else {
                  Publish.goToPreviousMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                if (!Publish.rightToLeft) {
                  Publish.goToPreviousMobilePage();
                } else {
                  Publish.goToNextMobilePage();
                }
              } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                console.log('Hammering Up');
                if (Publish.pagesVisible) Publish.goToNextSection();
              } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                console.log('Hammering Down');
                if (Publish.pagesVisible) Publish.goToPreviousSection();
              }
            } else {
              if (!Publish.isZoomed) {
                if (e.direction === hammer_default.a.DIRECTION_LEFT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToNextPage();
                  } else {
                    Publish.goToPreviousPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
                  if (!Publish.rightToLeft) {
                    Publish.goToPreviousPage();
                  } else {
                    Publish.goToNextPage();
                  }
                } else if (e.direction === hammer_default.a.DIRECTION_UP) {
                  console.log('Hammering Up');
                  if (Publish.pagesVisible) Publish.goToNextSection();
                } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
                  console.log('Hammering Down');
                  if (Publish.pagesVisible) Publish.goToPreviousSection();
                }
              }
            }
          } else {
            if (e.direction === hammer_default.a.DIRECTION_LEFT) {
              if (!Publish.rightToLeft) {
                Publish.goToNextPage();
              } else {
                Publish.goToPreviousPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_RIGHT) {
              if (!Publish.rightToLeft) {
                Publish.goToPreviousPage();
              } else {
                Publish.goToNextPage();
              }
            } else if (e.direction === hammer_default.a.DIRECTION_UP) {
              console.log('Hammering Up');
              if (Publish.pagesVisible) Publish.goToNextSection();
            } else if (e.direction === hammer_default.a.DIRECTION_DOWN) {
              console.log('Hammering Down');
              if (Publish.pagesVisible) Publish.goToPreviousSection();
            }
          }
        }
        // else {
        //   if (e.direction === Hammer.DIRECTION_LEFT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToNextPage()
        //     } else {
        //       Publish.goToPreviousPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_RIGHT) {
        //     if (!Publish.rightToLeft) {
        //       Publish.goToPreviousPage()
        //     } else {
        //       Publish.goToNextPage()
        //     }
        //   } else if (e.direction === Hammer.DIRECTION_UP) {
        //     if (Publish.pagesVisible) Publish.goToPreviousSection()
        //   } else if (e.direction === Hammer.DIRECTION_DOWN) {
        //     if (Publish.pagesVisible) Publish.goToNextSection()
        //   }
        // }
      }
    });
  },
  mouseWheelHandler: function mouseWheelHandler(e) {
    if (e.ctrlKey) {
      e.preventDefault();
      mouse.x = e.clientX;
      mouse.y = e.clientY;

      if (e.wheelDelta > 0) {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: 0.08
        });
      } else {
        Publish.scrollZoom({
          x: mouse.x,
          y: mouse.y,
          zoomDelta: -0.08
        });
      }
    } else {
      if (e.wheelDelta > 0) {
        Publish.goToPreviousSection();
      } else {
        Publish.goToNextSection();
      }
    }
  },
  mouseMoveHandler: function mouseMoveHandler(e) {
    if (Publish.pagesVisible && Publish.zoomEnabled) {
      mouse.x = e.clientX;
      mouse.y = e.clientY;
      if (mouseDown && !Publish.isZoomed) {
        if (mouse.x - mouse.lastX < -100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToPreviousPage()
          //   else
          //     Publish.goToNextPage()
          // }
          mouseDown = false;
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
        } else if (mouse.x - mouse.lastX > 100) {
          // if (Publish.pagesVisible) {
          //   if (Publish.rightToLeft)
          //     Publish.goToNextPage()
          //   else
          //     Publish.goToPreviousPage()
          // }
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY < -100) {
          // if (Publish.pagesVisible) Publish.goToNextSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        } else if (mouse.y - mouse.lastY > 100) {
          // if (Publish.pagesVisible) Publish.goToPreviousSection()
          mouse.lastX = mouse.x;
          mouse.lastY = mouse.y;
          mouseDown = false;
        }
      }
      if (mouseDown && Publish.isZoomed) {
        Publish.updateZoom({
          x: mouse.x,
          y: mouse.y
        });
      }
    }
  },
  mouseDownHandler: function mouseDownHandler(e) {
    if (!mouseDown && Publish.pagesVisible) {
      mouseDown = true;
      mouse.lastX = mouse.x;
      mouse.lastY = mouse.y;
    }
  },
  mouseUpHandler: function mouseUpHandler(e, fromTouch) {
    if (mouseDown && Publish.pagesVisible) {
      mouse.upX = mouse.x;
      mouse.upY = mouse.y;
      mouseDown = false;
    }
  },
  doubleClickHandler: function doubleClickHandler(e) {
    if (Publish.zoomClickEnabled && Publish.isGalleryOpen == false && Publish.videoURL == "" && (e.target.className.search("currentPage") !== -1 || e.target.className.search("leftPage") !== -1 || e.target.className.search("rightPage") !== -1 || e.path.indexOf(document.getElementById("page-container") !== -1))) {
      Publish.toggleZoom({
        zoomOriginX: e.pageX - window.innerWidth / 2,
        zoomOriginY: e.pageY - window.innerHeight / 2
      });
    } else {
      console.log("Double click failed!");
    }
  },
  keyDownHandler: function keyDownHandler(e) {
    e = e || window.event;
    if (e.target.tagName == "INPUT" || e.ctrlKey == true || e.metaKey == true) return;
    if (Publish.isGalleryOpen) {
      if (e.keyCode == "37") {
        if (!Publish.rightToLeft) {
          Publish.previousGallerySlide();
        } else {
          Publish.nextGallerySlide();
        }
      }
      if (e.keyCode == "39") {
        if (!Publish.rightToLeft) {
          Publish.nextGallerySlide();
        } else {
          Publish.previousGallerySlide();
        }
      }
    } else if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
      // if(!Publish.isZoomed){
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextMobilePage();else Publish.goToPreviousMobilePage();
      }
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousMobilePage();else Publish.goToNextMobilePage();
      }
      // }
    } else if (!Publish.videoURL == "" || !Publish.audioURL == "") {} else {
      if (e.keyCode == "37") {
        if (Publish.rightToLeft) Publish.goToNextPage();else Publish.goToPreviousPage();
      } // left arrow
      if (e.keyCode == "38") Publish.goToPreviousSection(); // up arrow
      if (e.keyCode == "39") {
        if (Publish.rightToLeft) Publish.goToPreviousPage();else Publish.goToNextPage();
      } // right arrow
      if (e.keyCode == "40") Publish.goToNextSection(); // down arrow
    }
  },
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var timer = null;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (timer === null) {
        timer = setTimeout(function () {
          func.apply(_this, args);
          timer = null;
        }, wait);
      }
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/platformHandler.js
/* harmony default export */ var platformHandler = ({
  init: function init() {
    var documentElement = document.documentElement;
    documentElement.setAttribute("data-useragent", navigator.userAgent);
    documentElement.setAttribute("data-platform", navigator.platform);
    documentElement.setAttribute("data-mobile", this.getMobileOperatingSystem());
    documentElement.setAttribute("data-browser", this.getBrowserInformation());
  },

  /**
   * Determine the mobile operating system.
   * This function returns one of 'iOS', 'Android', 'Windows Phone', or 'unknown'.
   *
   * @returns {String}
   */
  getMobileOperatingSystem: function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
      return "Windows";
    }

    if (/android/i.test(userAgent)) {
      return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      return "iOS";
    }

    return "unknown";
  },
  getBrowserInformation: function getBrowserInformation() {
    var ua = navigator.userAgent,
        tem,
        M = ua.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
    if (/trident/i.test(M[1])) {
      tem = /\brv[ :]+(\d+)/g.exec(ua) || [];
      return "IE " + (tem[1] || "");
    }
    if (M[1] === "Chrome") {
      tem = ua.match(/\b(OPR|Edge)\/(\d+)/);
      if (tem != null) return tem.slice(1).join(" ").replace("OPR", "Opera");
    }
    M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, "-?"];
    if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1]);
    return M[0];
  }
});
// CONCATENATED MODULE: ./src/helpers/modules/pageHandler.js
/* harmony default export */ var pageHandler = ({
  init: function init() {
    var delay = 250;
    var timeout = false;
    this.actualResizeHandler();
    window.addEventListener('resize', this.debounce(this.actualResizeHandler, 250));
    document.addEventListener('fullscreenchange', this.updateFullscreen);
  },
  actualResizeHandler: function actualResizeHandler(event) {
    if (typeof Publish !== 'undefined') {
      if (!Publish.isMobile) {
        Publish.changeWindowSize({
          width: window.innerWidth,
          height: window.innerHeight
        });
      } else {
        if (document.documentElement.dataset.mobile == "Android") {
          Publish.changeWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
          });
        }
      }
    }
  },
  updateFullscreen: function updateFullscreen() {
    Publish.updateFullscreen();
  },
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    var timeout = void 0;
    return function () {
      var _this = this;

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timeout);
      timeout = setTimeout(function () {
        func.apply(_this, args);
      }, wait);
    };
  }
});
// CONCATENATED MODULE: ./src/helpers/index.js





/* harmony default export */ var helpers = ({
  inputHandler: inputHandler,
  platformHandler: platformHandler,
  pageHandler: pageHandler,
  trackingHandler: trackingHandler
});
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./src/main.js

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var unsync = Object(vuex_router_sync["sync"])(store, router);

vue_esm["default"].config.productionTip = false;

vue_esm["default"].use(vue_gtag_esm["a" /* default */], {
  config: { id: "G-37YJH3692D" }
}, router);

/* eslint-disable no-new */
window.Publish = new vue_esm["default"]({
  el: "#app",
  router: router,
  store: store,
  template: '<App ref="app"/>',
  components: {
    App: src_App
  },
  created: function created() {
    if (this.mobileSwitch) this.checkMobileLanding();
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])({
    isReader: function isReader(state) {
      return state.isReader;
    }
  }), Object(vuex_esm["c" /* mapGetters */])(["currentPage", "pagesVisible", "isZoomed", "showContents", "zoomLevel", "rightToLeft", "zoomEnabled", "zoomClickEnabled", "isMobile", "mobileSwitch", "currentMobilePageIndex", "videoURL", "isGalleryOpen", "doublePage", "isPhantom", "isDoublePage", "showGuide", "initialWindowWidth", "initialWindowHeight", "audioURL"])),
  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])({
    toggleZoom: "TOGGLE_ZOOM",
    updateFullscreen: "UPDATE_FULLSCREEN"
  }), Object(vuex_esm["b" /* mapActions */])(["goToPage", "goToNextPage", "goToPreviousPage", "goToNextSection", "goToPreviousSection", "goToPreviousMobilePage", "goToNextMobilePage", "nextPage", "previousPage", "nextSection", "previousSection", "previousMobilePage", "nextMobilePage", "scrollZoom", "updateZoom", "startZoom", "changeWindowSize", "checkMobileLanding", "updateVideoURL", "pinchZoom", "panZoom", "openVideo", "isPhantom", "openGallery", "openGalleryTwo", "closeGallery", "goToGallerySlide", "nextGallerySlide", "previousGallerySlide", 'changeWindowSize', 'setInitialWindowSize', "updateAudioURL", "openAudio"])),
  mounted: function mounted() {
    helpers.pageHandler.init();
    helpers.inputHandler.init();
    helpers.platformHandler.init();
    helpers.trackingHandler.init();
    // if (!Publish.isPhantom) {
    // this.changeWindowSize({
    //   width: window.innerWidth,
    //   height: window.innerHeight,
    // })
    // }
  }
});

router.beforeEach(function (to, from, next) {
  if (Publish.isMobile && Publish.mobileSwitch) next();
  // console.log('Navigating from', from, ' to ', to)
  var p = parseInt(from.params.page) - 1;
  var s = parseInt(from.params.section) - 1;
  try {
    if (window["p" + p + "s" + s + "onPageLeave"] && !Publish.$store.getters.tmpMobile) {
      window["p" + p + "s" + s + "onPageLeave"]();
    }
    if (Publish.$store.state.isDoublePage && Publish.doublePage) {
      window["p" + p + "s" + s + "onPageLeave"]();
      window["p" + (p + 1) + "s" + s + "onPageLeave"]();
    }
  } catch (err) {
    console.error("WARNING - p" + p + "s" + s + "onPageLeave caused an error:");
    console.error(err.message);
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

router.beforeEach(function (to, from, next) {
  if (!Publish.isMobile) window.scrollTo(0, 0);
  if (Publish.isMobile && Publish.mobileSwitch || Publish.isReader) {
    document.getElementById('mobile-container').style.position = "fixed";
    setTimeout(function () {
      document.getElementById('mobile-container').style.position = "";
    }, 100);
  }
  if (Publish.isZoomed) {
    Publish.toggleZoom();
  }
  next();
});

/***/ }),

/***/ "Om6c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Tnot":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "WpSr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z1YF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hIWI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hLNX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hxKv":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nSix":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "o4GY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "p53m":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "r8RT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zMNT":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.7e66332d4ed656ccc0d3.js